// Public-pages i18n dictionary (FR default, EN). Scope: header/footer, landing,
// pricing, FAQ and public dossier page. Other areas remain French.
export const translations = {
  fr: {
    switcher: { aria: "Choisir la langue" },
    common: {
      spamHint:
        "Si vous ne le recevez pas, pensez à vérifier vos courriers indésirables (spam).",
      registryUnavailable: "Le registre n'a pas pu répondre. Rien ne peut en être conclu.",
      retry: "Réessayer",
      close: "Fermer",
    },
    legal: {
      disclaimer:
        "Provena est une plateforme de documentation et de traçabilité. Provena n'authentifie pas, ne certifie pas et ne garantit pas l'authenticité des montres. Les informations reposent sur les déclarations des propriétaires et des professionnels enregistrés. Provena ne saurait être tenu responsable en cas d'informations inexactes ou frauduleuses.",
    },
    reportTheft: {
      locationHint: "Indiquez uniquement la ville et le pays, sans adresse précise.",
      metaTitle: "Déclarer une montre volée",
      metaDescription:
        "Signalez le vol de votre montre de luxe pour la rendre identifiable sur le marché secondaire et compliquer toute revente frauduleuse.",
      loginDescription:
        "Connectez-vous pour signaler le vol de votre montre et la rendre identifiable sur le marché secondaire.",
      submittedTitle: "Signalement enregistré",
      submittedBodyPre: "La montre portant le numéro de série ",
      submittedBodyPost:
        " est désormais signalée comme volée dans le registre Provena.",
      submittedHint:
        "Tout acheteur consultant ce numéro de série sera alerté de son statut.",
      backHome: "Retour à l'accueil",
      another: "Déclarer une autre montre",
      eyebrow: "Registre des montres volées",
      title: "Déclarer une montre volée",
      intro:
        "Signalez le vol de votre montre pour la rendre identifiable sur le marché secondaire et compliquer toute revente frauduleuse.",
      fSerial: "Numéro de série",
      fSerialPh: "Ex. 4113-02-0997",
      fSerialHint: "Laissez vide pour une montre sans numéro et renseignez l'identifiant Provena.",
      fProvena: "Identifiant Provena",
      fProvenaPh: "Ex. PRV-000123",
      fProvenaHint: "Pour une montre vintage sans numéro de série, enregistrée à votre compte.",
      needIdentifier: "Indiquez un numéro de série ou un identifiant Provena.",
      fDate: "Date du vol",
      fBrand: "Marque",
      fBrandPh: "Ex. Patek Philippe",
      fModel: "Modèle",
      fModelPh: "Ex. Nautilus 5711/1A",
      fOwnerName: "Nom du propriétaire",
      fOwnerNamePh: "Prénom et nom",
      fEmail: "Adresse e-mail",
      fEmailPh: "vous@exemple.com",
      fLocation: "Lieu du vol",
      fLocationPh: "Ville, pays",
      fPolice: "Référence du dépôt de plainte",
      fPolicePh: "Numéro de procès-verbal",
      fCircumstances: "Circonstances du vol",
      fCircumstancesPh: "Décrivez les circonstances et tout détail utile.",
      disclaimer:
        "Un signalement de vol n'a pas valeur de dépôt de plainte. Pensez à contacter les autorités compétentes.",
      submitting: "Envoi en cours…",
      submit: "Déclarer le vol",
      submitAnonymous: "Créer mon compte et déclarer",
      sworn:
        "Je déclare sur l'honneur que cette montre m'a été volée et qu'une plainte a été déposée, ou est sur le point de l'être. Une déclaration mensongère m'engage.",
      swornRequired:
        "Merci de confirmer votre déclaration sur l'honneur pour continuer.",
      pendingReference:
        "Votre déclaration est enregistrée. Ajoutez votre référence de plainte sous sept jours, sans quoi le signalement s'éteindra.",
      submitError:
        "Une erreur est survenue. Vérifiez les informations et réessayez.",
    },
    magicLinkPage: {
      metaTitle: "Connexion par lien",
      metaDescription: "Confirmez la connexion à votre espace Provena.",
      title: "Se connecter",
      signInAs: "Ce lien ouvre l'espace Provena de :",
      confirm: "Se connecter",
      notYou:
        "Ce n'est pas votre adresse ? Fermez cette page : personne n'a été connecté.",
    },
    loginPage: {
      metaTitle: "Connexion",
      metaDescription:
        "Connectez-vous à votre espace Provena : collection, rapports de provenance, passeports et transferts de propriété.",
      gateDescription:
        "Connectez-vous avec Google pour accéder à votre espace Provena : collection, rapports, passeports et transferts de propriété.",
      errors: {
        generic: "La connexion a échoué. Veuillez réessayer.",
        oauth: "La connexion Google a été annulée ou n'a pas abouti. Réessayez.",
        state:
          "Votre session de connexion a expiré ou est invalide. Veuillez réessayer.",
        config:
          "La connexion Google n'est pas configurée correctement. Contactez le support.",
        token: "L'échange sécurisé avec Google a échoué. Réessayez dans un instant.",
        userinfo: "Impossible de récupérer votre profil Google. Réessayez.",
        network:
          "Le service d'authentification est momentanément indisponible. Réessayez.",
        email:
          "Votre adresse Google n'est pas vérifiée. Vérifiez votre compte Google, puis réessayez.",
        magic_invalid:
          "Ce lien de connexion est invalide. Demandez-en un nouveau ci-dessous.",
        magic_expired:
          "Ce lien de connexion a expiré. Demandez-en un nouveau ci-dessous.",
        magic_used:
          "Ce lien de connexion a déjà été utilisé. Demandez-en un nouveau ci-dessous.",
      },
    },
    header: {
      nav: {
        problem: "Le problème",
        stolen: "Montres volées",
        verify: "Consulter",
        gallery: "Galerie",
        passport: "Le passeport",
        howItWorks: "Comment ça marche",
      },
      register: "Enregistrer ma montre",
      professionals: "Professionnels",
      home: "Accueil",
      account: "Mon compte",
      logout: "Déconnexion",
      login: "Connexion",
      proArea: "Espace pro",
      becomePro: "Professionnels",
      accountMenu: "Menu du compte",
      admin: "Admin",
    },
    footer: {
      groups: {
        registry: "Registre",
        understand: "Comprendre",
        account: "Compte",
        legal: "Cadre",
      },
      about: "À propos",
      pricing: "Tarifs",
      reportTheft: "Déclarer un vol",
      stolenGuide: "Que faire en cas de vol ?",
      faq: "FAQ",
      yourData: "Vos données",
      privacy: "Politique de confidentialité",
      cookies: "Cookies",
      terms: "Conditions d'utilisation",
      account: "Mon compte",
      register: "Enregistrer ma montre",
      home: "Accueil",
      rights:
        "Provena Registry · Registre horloger de confiance. Tous droits réservés.",
      signature: "Chaque montre a une histoire. Nous la gardons.",
      instagram: "Provena sur Instagram (nouvel onglet)",
      studio: "Provena Studio, pour les ateliers",
    },
    hero: {
      eyebrow: "Registre de provenance horlogère",
      titlePre: "Le dossier de votre montre,",
      titleHighlight: "vérifiable par celui qui l'achètera.",
      subtitle:
        "Propriétaires successifs, révisions, documents, signalement de vol : Provena consigne ce qu'une montre a vécu et le rend consultable. Sans jamais prétendre l'authentifier.",
      verify: "Consulter une montre",
      register: "Enregistrer ma montre",
      trust: [
        "Registre indépendant",
        "Données confidentielles",
        "Consultation gratuite",
      ],
      scroll: "Découvrir",
    },
    registry: {
      eyebrow: "Le registre",
      title: "Ce que Provena fait de votre montre",
      steps: [
        {
          title: "Vous déposez ce que vous avez",
          description:
            "Facture, documents de garantie, carnet d'entretien, photos. Rien n'est obligatoire. Vos documents restent privés et vos coordonnées ne sont jamais publiées ; seule une photo de la montre peut illustrer la galerie publique, sans rien qui vous désigne.",
        },
        {
          title: "La montre reçoit son identifiant",
          description:
            "Un identifiant Provena permanent, attaché à la pièce et non à vous. Il survit aux ventes et suit la montre à travers ses propriétaires successifs.",
        },
        {
          title: "Un tiers peut vérifier",
          description:
            "Un acheteur, un assureur ou un marchand consulte la montre et voit ce qui existe au dossier, depuis quand, et si elle a été déclarée volée. Sans compte, et gratuitement.",
        },
      ],
      dossierLabel: "Pièces au dossier",
      dossier: [
        "Historique de propriété",
        "Justificatifs d'achat",
        "Carnet d'entretien",
        "Documents et garanties d'origine",
        "Dossier de provenance numérique",
      ],
      mission:
        "Notre mission : rendre chaque montre plus simple à consulter, plus sûre à posséder et plus précieuse à transmettre.",
    },
    counter: {
      eyebrow: "Le registre vivant",
      label: "montres au registre",
      foundersEyebrow: "Registre ouvert",
      foundersTitle: "Édition fondateurs",
      foundersText:
        "Le registre vient d'ouvrir. Les premières montres enregistrées portent à jamais les plus petits numéros. Le vôtre vous attend.",
    },
    trust: {
      eyebrow: "Ils nous font confiance",
    },
    physicalPassport: {
      eyebrow: "Le Passeport Métal",
      title: "L'extension tactile de l'acier et de la mémoire",
      body:
        "Une montre se définit par son poids, la froideur de son acier, la friction de son mécanisme. Son registre ne devrait pas faire exception. Chaque montre enregistrée peut recevoir son Passeport Métal : une carte de métal usinée de précision, lourde, glissée dans un étui de cuir à tannage végétal qui prendra sa patine au fil des décennies. Un lien NFC sécurisé, invisible, y ancre la mémoire éternelle de votre garde-temps au creux de la main.",
      imageAlt:
        "Carte de métal brossé du Passeport Métal dans son étui de cuir à tannage végétal",
      cta: "Demander votre Passeport Métal",
      registerPrompt:
        "Souhaitez-vous ancrer cette histoire dans un héritage physique ?",
    },
    nfc: {
      seoTitle: "Ouverture du registre",
      reading: "Lecture du registre…",
      opening: "Ouverture du dossier",
      notFound: "Ce passeport ne correspond à aucun dossier du registre.",
    },
    login: {
      reassurance: [
        "Gratuit, sans carte bancaire",
        "Vos données restent privées",
        "2 minutes pour enregistrer votre première montre",
      ],
      google: "Continuer avec Google",
      or: "ou",
      emailLabel: "Adresse e-mail",
      emailPlaceholder: "vous@exemple.com",
      magicSubmit: "Recevoir un lien de connexion",
      sameAccount: "Les deux méthodes ouvrent le même compte, rattaché à votre adresse. Si c'est une adresse Google, vous pouvez passer par le bouton ci-dessus et retrouver vos montres, sans attendre d'e-mail.",
      magicError:
        "Adresse e-mail invalide, ou service momentanément indisponible. Réessayez.",
      magicSentTitle: "Vérifiez votre boîte mail",
      // Split around the address, which is styled inline.
      magicSentPre: "Si un compte est associé à ",
      magicSentPost:
        ", un lien de connexion vient d'être envoyé. Il est valable 15 minutes.",
      magicOtherAddress: "Utiliser une autre adresse",
    },
    problem: {
      eyebrow: "Le constat",
      title: "Le marché de l'occasion repose encore largement sur la confiance.",
      constat: "Une montre change de main sans que l'acheteur puisse vérifier facilement son historique complet. En 2025, plus de 10 000 montres de luxe ont été déclarées volées ou perdues, soit environ une par heure.",
      needLabel: "Le besoin",
      need: "Le marché a besoin d'un dossier consultable avant l'achat, d'un registre des montres volées et d'un historique structuré qui rende la revente plus lisible et la fraude plus difficile.",
      answerLabel: "Provena",
      answer: "Provena ne prétend pas corriger le marché. Il donne à chaque montre un dossier consultable avant l'achat et aide à rendre une pièce volée plus difficile à revendre.",
      cta: "Enregistrer ma montre",
      sourcePre: "Source :",
      sourceName: "The Watch Register",
      sourceNote: "registre international des montres volées",
    },
    stolen: {
      eyebrow: "Registre des montres volées",
      title: "Déclarez et suivez les montres volées",
      features: [
        "Déclarez une montre volée en quelques minutes.",
        "Conservez vos justificatifs de propriété.",
        "Créez un signalement de vol consultable.",
        "Compliquez la revente frauduleuse.",
        "Aidez les futurs acheteurs à repérer une montre suspecte.",
      ],
      cta: "Déclarer une montre volée",
      guidePre: "Votre montre vient d'être volée ?",
      guideLink: "Voici les premières démarches à suivre.",
      imageAlt: "Mécanisme horloger de précision",
    },
    editorial: {
      title: "Proposer pour un épisode",
      intro: "Provena consacre des épisodes à des pièces qui ont une histoire. Si celle-ci en a une, racontez-la : c'est le récit qui fait l'épisode, pas la photographie.",
      pitchLabel: "L'histoire de cette pièce",
      pitchPlaceholder: "Ce que vous savez d'elle : d'où elle vient, ce qu'elle a traversé, ce qui la rend particulière.",
      minChars: "Encore {n} caractères.",
      privacy: "Ni le numéro de série, ni le propriétaire, ni sa ville ne seront publiés. Une pièce déclarée volée quitte la sélection automatiquement.",
      consent: "J'autorise Provena à mettre cette montre en avant sur ses publications.",
      submit: "Proposer cette pièce",
      done: "{watch} a été proposée pour un épisode.",
      withdraw: "Retirer ma proposition",
      withdrawn: "Proposition retirée.",
      alreadySubmitted: "Cette pièce est déjà proposée. Vous pouvez retirer votre proposition à tout moment.",
      error: "L'envoi a échoué. Réessayez.",
      action: "Proposer un épisode",
    },
    signatoryBadge: {
      founder: "Fondateur",
      solo: "Signataire {cohort}",
      contributor: "{name} · Signataire {cohort}",
      title: "Signataire de la charte Provena",
      enrichedBy: "Dossier enrichi par",
    },
    dataProtection: {
      metaTitle: "Vos données, ce qu'elles deviennent",
      metaDescription:
        "Ce qu'un tiers voit d'une montre enregistrée, ce qu'il ne verra jamais, et comment récupérer ou effacer vos données en un clic.",
      eyebrow: "Confier son stock, ou sa collection",
      title: "Ce que deviennent vos données",
      lead: "La politique de confidentialité répond au droit. Cette page répond aux questions qu'on se pose vraiment avant de confier un stock ou de photographier ses pièces. Chaque réponse décrit le fonctionnement réel du registre, pas une intention.",

      q1Title: "Qui voit quoi, exactement ?",
      q1: "Un dossier consulté par un tiers, acheteur ou assureur, n'affiche que la pièce. Jamais vous. Voici l'inventaire complet, sans exception :",
      shownTitle: "Ce qu'un tiers voit",
      shown: [
        "La marque, le modèle, l'année",
        "Si des photos existent, sans les afficher",
        "Si des photos ou des justificatifs sont au dossier",
        "Si la pièce est signalée volée",
        "Le nombre d'interventions professionnelles",
        "La date d'enregistrement au registre",
      ],
      hiddenTitle: "Ce qu'il ne voit jamais",
      hidden: [
        "Votre nom et votre adresse e-mail",
        "Vos photos et vos documents",
        "Vos factures et vos justificatifs",
        "Votre ville et vos coordonnées",
        "Le prix d'achat ou de vente",
        "L'identité des propriétaires précédents",
      ],

      q2Title: "Et mes photos, mes factures ?",
      q2: "Elles ne sont accessibles qu'à vous. Un fichier n'est jamais servi publiquement : chaque accès vérifie que le compte demandeur en est le propriétaire, et les liens de partage que le site génère expirent au bout de quelques minutes. Un lien intercepté ne sert donc à rien passé ce délai, et il ne donne accès qu'à ce seul fichier.",

      q3Title: "Mes clients apparaissent-ils quelque part ?",
      q3: "Non. Quand vous enregistrez une montre pour un client, son nom et son adresse ne figurent sur aucune page publique. Le dossier consultable ne dit pas à qui la pièce appartient, seulement qu'elle a un propriétaire. Vos concurrents ne peuvent pas davantage lister votre stock : rien ne relie publiquement les montres enregistrées à celui qui les a enregistrées, sauf si vous choisissez d'apparaître comme signataire contributeur.",

      q4Title: "Puis-je récupérer mes données ?",
      q4: "Oui, en un clic, depuis votre tableau de bord. Vous obtenez un fichier contenant l'intégralité de ce que le registre détient sur vous : vos montres, leurs événements, leurs documents, vos signalements. Aucune demande à formuler, aucun délai. C'est votre garantie de ne jamais être enfermé, et pour un registre jeune c'est la seule qui vaille.",

      q5Title: "Et si je m'en vais ?",
      q5: "La suppression de votre compte efface vos données, et pas seulement votre profil : les montres que vous possédez encore partent avec leurs documents, leurs photos, leurs événements et leurs rapports. Les pièces que vous avez déjà transmises restent au registre, puisqu'elles appartiennent désormais à quelqu'un d'autre, mais votre identité en est retirée et n'apparaît plus dans leur historique.",

      limitsTitle: "Ce que cette page ne prétend pas",
      limit1: "Une équipe restreinte peut accéder aux dossiers pour le support et la modération, notamment pour traiter un signalement de vol. Ces accès sont tracés. Toute plateforme fonctionne ainsi ; celles qui affirment le contraire se trompent ou vous trompent.",
      limit2: "Vos données sont hébergées chez des prestataires nommés, listés dans la politique de confidentialité, dont la base est en Union européenne. Provena est une jeune structure : c'est précisément pourquoi l'export existe et pourquoi il est immédiat.",

      cta: "Enregistrer ma première montre",
      policyLink: "Lire la politique de confidentialité",
    },
    signatoryWelcome: {
      eyebrow: "Votre statut a changé",
      title: "Vous êtes signataire de la cohorte {cohort}",
      titleNoCohort: "Vous êtes signataire du registre",
      access: "Votre compte a désormais un accès complet : passeports et rapports de provenance sans limite, pour toutes vos montres. Aucun abonnement n'est nécessaire.",
      inReturnLabel: "Ce que vous vous engagez à faire",
      inReturnDealer: "Établir le passeport d'au moins dix pièces, remettre le dossier à l'acheteur lors de la vente, et trente minutes de retour par trimestre.",
      inReturnMaker: "Consigner la fabrication d'au moins une pièce, étape par étape, y joindre vos photographies d'atelier, et trente minutes de retour par trimestre.",
      inReturnCollector: "Documenter votre collection, au moins trois pièces, et trente minutes de retour par trimestre.",
      cta: "Relire la charte",
      dismiss: "Fermer cette annonce",
    },
    signatory: {
      metaTitle: "Les signataires de Provena",
      metaDescription:
        "Les créateurs, professionnels et collectionneurs qui ont signé la charte Provena. Une cohorte datée, qui se referme le 31 décembre.",
      eyebrow: "Sur invitation",
      title: "Les signataires",
      cohort: "Signataires 2026",
      lead: "Provena consigne des faits datés. Celui-ci en est un : ces artisans, ces professionnels et ces collectionneurs ont signé la charte en 2026, alors que le registre n'existait presque pas encore.",
      leadTwo: "La cohorte 2026 se referme le 31 décembre. Ceux qui signeront ensuite auront un autre statut, jamais celui-ci.",

      whoTitle: "Trois profils",
      makerTitle: "Créateur",
      makerText: "Consigne la fabrication des pièces qui sortent de son atelier, étape par étape, et remet leur dossier au premier propriétaire. Ses entrées portent le degré du créateur dans l'historique des pièces.",
      dealerTitle: "Marchand",
      dealerText: "Crée les passeports des montres qu'il vend, gère son stock, transmet le dossier à l'acheteur. Ses interventions sont inscrites au niveau professionnel dans l'historique des pièces.",
      collectorTitle: "Collectionneur",
      collectorText: "Documente sa collection, éprouve le registre sur des pièces réelles et signale ce qui manque.",

      getTitle: "Ce que le statut donne",
      get1: "L'accès complet à Provena, offert pendant toute la période d'ouverture.",
      get2: "Les nouvelles fonctionnalités avant leur ouverture publique.",
      get3: "D'être consulté avant les décisions produit importantes. Consulté, pas suivi : nous ne promettons pas d'appliquer.",
      get4: "La possibilité de proposer une montre et son histoire pour un épisode éditorial Provena. Réservé aux marchands et aux créateurs : un collectionneur s'exposerait lui-même.",
      get5: "D'être mentionné comme professionnel utilisant Provena, si vous le souhaitez.",
      get6: "Une signature datée, qui ne se retire pas et ne se rejoint plus.",

      giveTitle: "Ce que chacun s'engage à faire",
      giveMakerTitle: "Créateur",
      giveMaker1: "Consigner la fabrication d'au moins une pièce, étape par étape.",
      giveMaker2: "Y joindre les photographies de l'atelier.",
      giveMaker3: "Trente minutes de retour par trimestre.",
      giveDealerTitle: "Marchand",
      giveDealer1: "Établir le passeport d'au moins dix pièces.",
      giveDealer2: "Remettre le dossier à l'acheteur lors de la vente.",
      giveDealer3: "Trente minutes de retour par trimestre.",
      giveCollectorTitle: "Collectionneur",
      giveCollector1: "Documenter sa collection, au moins trois pièces.",
      giveCollector2: "Trente minutes de retour par trimestre.",
      giveNote: "C'est peu, et ce n'est pas le même effort selon qu'on fabrique, qu'on tient boutique ou qu'on collectionne. Mais c'est ce qui distingue un cercle d'une liste de diffusion : un statut qui ne demande rien n'a rien à raconter.",

      neutralTitle: "Ce que Provena ne fait pas",
      dataLink: "Ce que deviennent vos données",
      neutral: "Provena ne certifie pas les signataires, ne garantit ni leurs pièces ni leurs transactions, et ne perçoit aucune commission sur leurs ventes. Une signature constate un engagement, elle ne vaut ni recommandation ni caution.",

      ctaTitle: "Rejoindre",
      ctaText: "On ne signe que sur invitation. Si vous pensez y avoir votre place, écrivez-nous. Dites-nous qui vous êtes et ce que vous conservez.",
      ctaButton: "Nous écrire",
    },
    explore: {
      eyebrow: "Le registre en pratique",
      passportTitle: "Le passeport",
      passportText: "Le document que reçoit chaque montre inscrite au registre.",
      verifyTitle: "Consulter une montre",
      verifyText: "Vérifiez le statut d'une pièce avant de l'acheter.",
      stolenTitle: "Montres volées",
      stolenText: "Le registre public des pièces déclarées volées par leur propriétaire.",
    },
    passportPage: {
      metaTitle: "Le passeport de provenance d'une montre",
      metaDescription:
        "Le document que Provena constitue pour chaque montre : identité, chaîne de propriété, documents et sceau d'intégrité vérifiable publiquement.",
      sealTitle: "Ce qui le rend vérifiable",
      seal1Title: "Un sceau d'intégrité",
      seal1:
        "À chaque enregistrement, le dossier reçoit une empreinte numérique et une signature cryptographique. Toute modification ultérieure se voit.",
      seal2Title: "Un QR de consultation",
      seal2:
        "Le passeport porte un code menant à une page publique où n'importe qui peut contrôler le sceau, sans voir vos données personnelles.",
      seal3Title: "Un document à emporter",
      seal3:
        "Le passeport se télécharge en PDF, imprimable et transmissible avec la montre le jour où elle change de main.",
      limitTitle: "Ce que le passeport n'est pas",
      limit:
        "Ce n'est pas un certificat d'authenticité. Provena n'expertise pas les montres et ne se prononce pas sur leur origine : le passeport atteste de la traçabilité des événements et des documents déclarés, rien de plus.",
      demoCta: "Voir un passeport en entier",
      registerCta: "Enregistrer ma montre",
    },
    audience: {
      eyebrow: "Pour qui",
      title: "Trois façons d'entrer dans le registre",
      items: [
        {
          role: "Vous achetez",
          body: "Consultez une montre avant de payer : ce qui figure au dossier, depuis quand, et si elle a été déclarée volée. Sans compte, gratuitement, en quelques secondes.",
          cta: "Consulter une montre",
        },
        {
          role: "Vous possédez",
          body: "Enregistrez votre montre et rassemblez ses justificatifs. Le jour d'un vol, d'une succession ou d'une revente, son histoire existe ailleurs que dans un tiroir.",
          cta: "Enregistrer ma montre",
        },
        {
          role: "Vous vendez",
          body: "Un dossier consultable par l'acheteur remplace la parole donnée. Les marchands ouvrent le programme signataires, avec un accès complet et un badge sur les pièces qu'ils enregistrent.",
          cta: "Découvrir le programme",
        },
      ],
      // RDEC-023 : l'atelier est renvoyé vers Studio, son outil de travail.
      studio: {
        question: "Vous êtes un atelier ?",
        link: "Provena Studio, l'outil de travail des ateliers horlogers",
      },
    },
    passportPreview: {
      eyebrow: "Le passeport, en clair",
      title: "Ce que le passeport consigne",
      subtitle:
        "Il documente la garde et la continuité d'un objet : son identité, les mains qui l'ont tenu, son état constaté. Rien d'autre.",
      demoCta: "Voir un dossier complet",
      screens: {
        identity: "Identité",
        custody: "Chaîne de garde",
        condition: "Constat d'état",
        continuity: "Continuité",
      },
      identity: {
        name: "Pièce",
        maker: "Marque",
        year: "Année",
        material: "Matière",
        reference: "Référence",
        noIssuer:
          "Aucune marque émettrice. Le passeport est tenu par le registre, pas par un fabricant.",
      },
      condition: {
        assessedOn: "Constat du",
        tags: {
          case: "Boîtier",
          movement: "Mouvement",
          bracelet: "Bracelet",
        },
        states: {
          intact: "Intact",
          serviced: "Révisé",
          worn: "Traces d'usage",
        },
        note: "Constat réalisé par un professionnel tiers, horodaté et signé.",
      },
      continuity: {
        owners: "{count} propriétaires enregistrés",
        anonymous:
          "Aucune identité affichée : seuls les rôles et les dates sont consignés.",
        closing: "La donnée appartient à l'objet, pas à la marque.",
      },
      nav: { goTo: "Afficher l'écran {screen}" },
      demo: {
        name: "Chronographe automatique",
        maker: "Manufacture indépendante",
        material: "Acier inoxydable",
      },
    },
    // Montre fictive de la carte passeport (tarifs, CTA final) : aucune maison
    // réelle, aucun nom de personne.
    demoPassport: {
      maker: "Manufacture indépendante",
      model: "Chronographe automatique",
      owner: "Collection privée",
    },
    verifyWatch: {
      metaTitle: "Vérifier une montre avant de l'acheter",
      metaDescription:
        "Consultez gratuitement le statut d'une montre dans le registre Provena : enregistrement, provenance documentée, déclaration de vol.",
      showsTitle: "Ce que cette consultation vous dit",
      shows1: "Si la montre est inscrite au registre Provena.",
      shows2: "Si elle a été déclarée volée par son propriétaire.",
      shows3: "Si son dossier contient des documents de provenance.",
      limitsTitle: "Ce qu'elle ne dit pas",
      limits1:
        "Provena n'authentifie pas les montres et ne certifie pas leur origine. Le registre conserve des déclarations et des documents, il ne les expertise pas.",
      limits2:
        "Une montre absente du registre n'est ni suspecte ni garantie : elle n'y a simplement jamais été inscrite.",
      limits3:
        "En cas de doute sur une pièce, adressez-vous à un horloger ou à un expert.",
      stolenCta: "Voir le registre des montres volées",
      registerCta: "Enregistrer ma montre",
    },
    verification: {
      eyebrow: "Consultation du registre",
      title: "Consultez avant d'acheter",
      subtitle:
        "Saisissez le numéro de série ou le Provena ID d'une montre pour consulter son statut dans le registre Provena.",
      placeholder: "Numéro de série ou Provena ID",
      submit: "Consulter",
      orScan: "Ou, montre en main, photographiez le fond de boîte :",
      ref: "N° de série",
      provenaIdLabel: "Provena ID",
      extract: "Extrait du registre",
      viewedOn: "Extrait consulté le {date}",
      openDossier: "Ouvrir le dossier",
      statusRegistered: "Au registre",
      statusStolen: "Signalée volée",
      statusAbsent: "Non enregistrée",
      fieldRegistered: "Enregistrement",
      fieldOwnership: "Propriété",
      fieldProvenance: "Pièces au dossier",
      fieldStolen: "Statut vol",
      notFoundSerial: "Aucune montre n'est enregistrée sous le numéro de série {q}.",
      notFoundProvenaId: "Aucun dossier pour le Provena ID {q}.",
      notFoundOwn:
        "C'est le cas de la plupart des montres. Si celle-ci est la vôtre, vous pouvez ouvrir son dossier : vous seul pouvez déclarer qu'elle vous appartient.",
      registerCta: "Enregistrer cette montre",
      registeredYes: "Enregistrée dans le registre",
      registeredNo: "Non enregistrée",
      ownershipYes: "Justificatifs de propriété disponibles",
      ownershipNo: "Aucun justificatif de propriété",
      provenanceYes: "Photos ou justificatifs déposés",
      provenanceNo: "Aucune photo ni justificatif",
      stolenYes: "Signalée comme volée",
      stolenNo: "Aucun signalement de vol",
    },
    about: {
      metaTitle: "Le troisième étage, l'origine de Provena",
      metaDescription:
        "Genève, 2022. Une bibliothèque de 8 000 ouvrages, un tiroir, et deux lettres gravées. L'histoire qui a donné naissance au registre Provena.",
      eyebrow: "L'origine",
      title: "Le troisième étage",
      place: "Musée Patek Philippe · Genève · 2022",
      s1: "Je ne me souviens d'aucune montre.",
      s2: "Je me souviens du troisième étage.",
      s2b: "Plus de 8 000 ouvrages et manuscrits, certains remontant au XVIᵉ siècle. Un bâtiment entier pour exposer des objets, et un étage entier pour se souvenir de ce qu'ils sont.",
      s3: "Ce qui m'a marqué, ce n'étaient pas les montres. C'étaient les questions derrière chacune d'elles. Pourquoi cette complication. Pourquoi ce design. Pourquoi ces matériaux.",
      s4: "Si on peut encore répondre à ces questions aujourd'hui, c'est seulement parce que quelqu'un avait pris le temps de les écrire.",
      drawerTitle: "Le tiroir",
      s5: "Je suis rentré. J'ai ouvert le tiroir de ma grand-mère.",
      s6: "Ses montres ont traversé deux guerres mondiales, la crise du quartz et soixante ans de journées ordinaires.",
      s7: "Et je suis incapable de vous dire une seule chose sur l'une ou l'autre.",
      s8: "L'une d'elles est une montre à gousset en or. À l'intérieur, deux lettres sont gravées.",
      engraving: "YM",
      s9: "Deux initiales. Toute une vie réduite à deux lettres.",
      s10: "Je ne sais pas qui était YM. Je ne sais pas pourquoi cette montre a été gravée. Je sais seulement qu'elle est arrivée jusqu'à moi.",
      thesisPre: "La différence entre ces montres et celles du musée n'est ni la valeur, ni la rareté.",
      thesisA: "Le musée avait une bibliothèque.",
      thesisB: "Ma grand-mère n'avait personne.",
      youTitle: "Vous en avez une aussi",
      s11: "Un tiroir. Une boîte. Une montre arrêtée. Un objet que vous ne vendrez jamais.",
      s12: "Vous savez qu'il compte. Vous ne savez juste pas pourquoi.",
      s13: "Les objets survivent aux histoires qu'ils portent.",
      whyTitle: "C'est pour ça que Provena existe",
      s14: "Un registre où une montre garde son histoire quand elle change de main : propriétaires successifs, révisions, documents, et une déclaration si elle est volée.",
      s15: "Provena ne certifie pas et n'authentifie rien. Le registre conserve des événements datés et des documents, et les rend vérifiables par n'importe qui. La confiance ne vient pas d'un label : elle vient de la trace.",
      closing: "On ne voit pas une histoire. On l'écrit.",
      ctaRegister: "Enregistrer ma montre",
      ctaHow: "Comment ça marche",
    },
    founder: {
      eyebrow: "Le mot du fondateur",
      title: "Une obsession pour l'histoire des objets",
      p1: "Ma fascination pour la provenance dépasse l'horlogerie. Un violon, un livre, un meuble : chaque objet qui traverse le temps a vécu bien plus que n'importe quel humain. J'ai retracé ma propre généalogie pour connaître la mienne.",
      p2: "Provena est née de cette obsession, un jour de 2022, au troisième étage du musée Patek Philippe.",
      signature: "Nathan De Ridder",
      role: "Fondateur · Provena",
      readStory: "Lire l'histoire complète",
    },
    finalCta: {
      title: "Protégez l'histoire de votre montre",
      subtitle:
        "Rejoignez ceux qui ne laissent plus une montre sans histoire.",
      register: "Enregistrer ma montre",
      verify: "Consulter une montre",
      price:
        "L'enregistrement de vos montres et la consultation du registre sont gratuits, et le resteront.",
      priceLink: "Voir les tarifs",
    },
    gallery: {
      eyebrow: "Le registre en images",
      title: "La galerie Provena",
      subtitle:
        "Un aperçu anonyme des garde-temps inscrits au registre. Aucune donnée personnelle, aucun numéro de série complet.",
      all: "Toutes les marques",
      empty: "Aucune montre à afficher pour le moment.",
      anonymized:
        "Galerie anonymisée : propriétaires et numéros de série confidentiels.",
      view: "Voir le dossier",
      enlarge: "Agrandir la photo",
      closePhoto: "Fermer la photo agrandie",
      metaTitle: "Galerie Provena · montres enregistrées",
      metaDescription:
        "Découvrez les garde-temps inscrits au registre Provena. Galerie anonymisée : marque, modèle et année, sans donnée personnelle.",
    },
    howItWorks: {
      eyebrow: "Le parcours Provena",
      title: "Comment ça marche",
      metaDescription:
        "De l'enregistrement à la vérification publique : découvrez le parcours Provena pour documenter durablement votre montre de luxe.",
      intro:
        "De l'enregistrement à la vérification publique, quatre étapes pour documenter durablement votre montre.",
      cta: "Enregistrer ma montre",
      steps: [
        {
          title: "Enregistrez votre montre",
          description:
            "Constituez le dossier de votre garde-temps : marque, modèle, numéro de série, justificatifs et photographies.",
        },
        {
          title: "Vérifiez votre identité",
          description:
            "Connectez-vous via une authentification sécurisée. Vous devenez le propriétaire enregistré du dossier.",
        },
        {
          title: "Recevez le passeport",
          description:
            "Un passeport numérique signé est généré, avec empreinte SHA-256 et QR code de vérification.",
        },
        {
          title: "Vérification publique",
          description:
            "N'importe qui peut scanner le QR code et vérifier l'intégrité du dossier, sans compte ni donnée personnelle.",
        },
      ],
    },
    passport: {
      title: "Passeport numérique Provena",
      eyebrow: "Extrait du registre Provena",
      presentation: "Mode présentation",
      exit: "Quitter",
      owner: "Propriétaire enregistré",
      serial: "Numéro de série",
      year: "Année",
      acquisition: "Acquisition",
      boxPapers: "Boîte & papiers",
      registeredOn: "Enregistré le",
      verify: "Scannez pour vérifier le sceau du dossier",
      fingerprint: "Empreinte cryptographique du dossier",
      stolen: "Cette montre est signalée comme volée.",
      privateTitle: "Passeport confidentiel",
      privateText:
        "Seul le propriétaire enregistré peut consulter ce passeport. Vous pouvez néanmoins vérifier publiquement l'intégrité du dossier.",
      verifyPublic: "Vérification publique",
      loginCta: "Se connecter",
      notFound: "Passeport introuvable.",
      edition: "Pièce enregistrée · Édition",
      sealTitle: "Scellement numérique",
      sealExplain: "Ce document est protégé par une signature cryptographique. Toute modification du dossier rend cette signature invalide.",
      authenticity: "Document scellé et vérifié cryptographiquement",
      verifyStamp: "Vérifier ce passeport",
      qrAlt: "QR de vérification Provena",
      print: "Imprimer",
      downloadPdf: "Télécharger le PDF",
      heroEyebrow: "Passeport numérique",
      cardHolder: "Titulaire",
      identityTitle: "Identité de la pièce",
      photosTitle: "Photographies",
    },
    pricing: {
      eyebrow: "Les formules",
      metaDescription:
        "Découvrez les formules Provena : enregistrement, passeport et consultation gratuits, dossiers de provenance et outils professionnels.",
      title: "Choisissez votre formule",
      intro:
        "L'enregistrement de vos montres, leur passeport et la consultation du registre restent toujours gratuits. Des paliers supérieurs (rapports de provenance, outils professionnels) seront proposés prochainement.",
      checkoutError:
        "Le paiement n'a pas pu être initié. Veuillez réessayer dans un instant.",
      passportEyebrow: "Inclus pour chaque montre enregistrée",
      passportTitle: "Le passeport numérique, un objet à part",
      passportText:
        "Chaque montre enregistrée reçoit son passeport interactif : un reflet qui suit votre geste, son Provena ID, un QR de vérification intégré. Un objet que l'on présente, pas un simple document.",
      passportHint: "Survolez la carte : la lumière suit votre geste.",
      passportPrivacy:
        "Exemple fictif. Hors démonstration, les informations personnelles d'un passeport ne sont visibles que par son propriétaire.",
      passportCta: "Voir un passeport complet",
      comingSoon: "Bientôt disponible",
      joinWaitlist: "Rejoindre la liste d'attente",
      waitlistTitle: "Liste d'attente",
      waitlistIntro:
        "Les abonnements arrivent bientôt. Laissez votre e-mail : vous serez prévenu·e en priorité au lancement.",
      waitlistThanks:
        "Merci ! Vous êtes sur la liste. Nous vous préviendrons dès l'ouverture des abonnements.",
      waitlistClose: "Fermer",
      waitlistError: "L'inscription a échoué. Vérifiez votre e-mail et réessayez.",
      free: "Gratuit",
      forever: "Pour toujours",
      startFree: "Ouvrir le registre",
      collector: "Collectionneur",
      collectorTag: "Pour les collectionneurs",
      chooseCollector: "Choisir Collectionneur",
      professional: "Professionnel",
      professionalTag: "Négociants & professionnels",
      chooseProfessional: "Choisir Professionnel",
      enterprise: "Maisons & institutions",
      enterpriseTag: "Assureurs, maisons de vente",
      contactUs: "Nous contacter",
    },
    faq: {
      eyebrow: "Aide & questions",
      title: "Foire aux questions",
      intro:
        "Tout ce qu'il faut savoir sur le fonctionnement du registre Provena, ce qu'il documente, et ce qu'il ne fait pas.",
      items: [
        {
          q: "Qu'est-ce que Provena Registry ?",
          a: "Provena Registry est un registre numérique dédié à la documentation et à la traçabilité des montres de luxe. Il vous permet de constituer l'historique de propriété et de provenance d'une montre, de signaler un vol et de consulter le statut d'une pièce par son numéro de série.",
        },
        {
          q: "Provena certifie-t-il ou authentifie-t-il les montres ?",
          a: "Non. Provena est une plateforme de documentation et de traçabilité. Provena n'authentifie pas, ne certifie pas et ne garantit pas l'authenticité des montres. Les informations enregistrées reposent sur les déclarations des propriétaires. Pour une expertise d'authenticité, adressez-vous à un horloger ou à une maison spécialisée.",
        },
        {
          q: "Pourquoi Provena refuse-t-il de certifier ?",
          a: "Parce qu'authentifier est un geste physique. Il faut avoir la montre en main, l'ouvrir, comparer ses composants aux références de la manufacture. Un registre qui ne touche jamais l'objet ne peut pas le faire, et s'il prétendait le faire, il mentirait sur ce qu'il a vu. C'est ensuite un refus délibéré. Un registre qui tranche devient le point de défaillance unique : s'il déclare authentique une contrefaçon, il la blanchit sous son nom ; s'il déclare fausse une pièce véritable, il en détruit la valeur sur une supposition. Aucune de ces deux erreurs n'est rattrapable, et les deux seraient les nôtres. Enfin, un verdict vieillit mal. Une authentification est vraie le jour où elle est rendue et ne dit rien de la montre deux propriétaires plus tard. Un historique daté, lui, garde sa valeur, précisément parce qu'il n'a jamais prétendu conclure. Ce que Provena fait à la place : nommer qui a déclaré quoi, quand, et avec quel appui. Chaque événement porte le rang de celui qui l'a consigné : le propriétaire, le créateur de la pièce, un professionnel enregistré, la manufacture. Provena ne vous dit pas si la montre est vraie ; il vous met en état d'en juger. Et il répond de ce dont il peut répondre : l'intégrité du dossier. Toute modification y inscrit un événement visible, et le sceau cryptographique, vérifiable publiquement, permet de contrôler que le dossier qu'on vous montre est bien celui qui a été scellé.",
        },
        {
          q: "Comment fonctionne la consultation par numéro de série ?",
          a: "Saisissez le numéro de série d'une montre sur la page d'accueil. Le registre indique si la pièce est enregistrée, si des photos ou des justificatifs sont au dossier et si elle a été signalée comme volée. Aucune coordonnée personnelle du propriétaire n'est affichée publiquement.",
        },
        {
          q: "Qu'est-ce que le passeport numérique Provena et le dossier de provenance ?",
          a: "Le passeport numérique Provena est un document récapitulant l'inscription d'une montre au registre au nom de son propriétaire déclaré. Le dossier de provenance regroupe l'historique de propriété, les justificatifs, le carnet d'entretien et les photographies que vous fournissez. Aucun de ces documents ne constitue une certification d'authenticité.",
        },
        {
          q: "Le passeport numérique Provena est-il le passeport numérique européen (DPP) ?",
          a: "Non, ce sont deux choses distinctes. Le passeport numérique de produit (DPP), prévu par la réglementation européenne sur l'écoconception, est émis par le fabricant qui met un produit sur le marché et décrit ce qu'est le produit : composition, réparabilité, conformité. Le passeport numérique Provena est établi à partir des déclarations du propriétaire et décrit à qui appartient la montre et d'où elle vient : chaîne de propriété, transferts, entretiens, signalements. Les deux sont complémentaires, jamais interchangeables : Provena n'émet pas de DPP, et un document Provena ne vaut ni conformité réglementaire ni certification.",
        },
        {
          q: "Mes coordonnées personnelles sont-elles visibles publiquement ?",
          a: "Non. Lors d'une consultation publique, seules les informations de statut (montre enregistrée, photos ou justificatifs au dossier, signalement de vol) sont visibles. Vos coordonnées restent confidentielles. Pour en savoir plus, consultez notre politique de confidentialité.",
        },
        {
          q: "Comment déclarer une montre volée ?",
          a: "Rendez-vous sur la page « Déclarer une montre volée » après vous être connecté. Un signalement rend la montre identifiable lors de toute consultation par numéro de série. Attention : un signalement Provena n'a pas valeur de dépôt de plainte, pensez à contacter les autorités compétentes.",
        },
        {
          q: "Comment transférer la propriété d'une montre ?",
          a: "Depuis votre compte, indiquez le nom et l'e-mail du nouveau propriétaire : il reçoit un lien pour récupérer le dossier. Jusque-là, le dossier reste à votre nom, et vous pouvez annuler. Le Provena ID et l'historique de provenance sont conservés, et vous êtes prévenu quand il l'a récupéré.",
        },
        {
          q: "Combien coûte Provena ?",
          a: "La création de compte, l'enregistrement de montres et la consultation par numéro de série sont gratuits. Des options premium (dossiers de provenance, passeports, outils professionnels) sont proposées à l'unité ou par abonnement.",
        },
        {
          q: "Comment mes données personnelles sont-elles protégées ?",
          a: "Nous appliquons des mesures techniques et organisationnelles raisonnables et ne vendons jamais vos données. Le détail des traitements, des sous-traitants et de vos droits (accès, suppression, portabilité) figure dans notre politique de confidentialité.",
        },
      ],
      moreTitle: "Une autre question ?",
      moreText:
        "Notre équipe est à votre disposition pour toute demande sur le registre, votre compte ou vos données.",
      legalPre: "Consultez aussi notre",
      legalPrivacy: "politique de confidentialité",
      legalCookies: "politique de cookies",
      legalTermsPre: "et nos",
      legalTerms: "conditions d'utilisation",
    },
    // RDEC-022 : un vol relayé se lit sous le nom de qui l'a publié.
    theftSource: {
      notice: "Signalée volée par {publisher}, dans un avis public relayé par Provena.",
      noticeDated:
        "Signalée volée par {publisher}, dans un avis public du {date} relayé par Provena.",
      viewNotice: "Voir l'avis",
      pageLink: "Page du signalement",
    },
    stolenRegistry: {
      metaTitle: "Registre des montres volées | Provena",
      metaDescription:
        "Vérifiez gratuitement si une montre a été déclarée volée avant de l'acheter. Registre public tenu par Provena.",
      eyebrow: "Registre public",
      title: "Montres déclarées volées",
      subtitle:
        "Avant d'acheter une montre d'occasion, vérifiez qu'elle n'a pas été déclarée volée. Recherchez par numéro de série, marque ou modèle.",
      searchPlaceholder: "Numéro de série, marque ou modèle…",
      searchBtn: "Rechercher",
      clearBtn: "Effacer",
      resultsCount: "{count} montre(s) déclarée(s) volée(s)",
      empty: "Aucune montre volée ne correspond à votre recherche.",
      emptyAll: "Aucune montre n'est actuellement déclarée volée dans le registre.",
      emptyHint:
        "Cela dit qu'elle n'est pas signalée, et rien de plus : le registre ne connaît peut-être pas cette montre du tout. Sa fiche complète se consulte ailleurs.",
      emptyAllHint:
        "Le registre est jeune. Une montre n'y figure que si son détenteur l'a déclarée, plainte à l'appui.",
      emptyVerifyCta: "Vérifier un numéro de série",
      emptyReportCta: "Déclarer un vol",
      colWatch: "Montre",
      colSerial: "Numéro de série",
      noSerial: "Sans numéro",
      colStolen: "Déclarée volée",
      colLocation: "Lieu",
      reportedOn: "Signalée le {date}",
      loadMore: "Voir plus",
      viewFile: "Voir le dossier public",
      disclaimer:
        "Ce registre repose sur des déclarations faites par les propriétaires. Une absence dans cette liste ne garantit pas qu'une montre n'a pas été volée. En cas de doute, contactez les autorités.",
      ctaOwnerPre: "Une de vos montres a été volée ?",
      ctaOwnerLink: "Déclarez-la ici",
    },
    stolenGuide: {
      metaTitle:
        "Vol de montre : que faire ? Signaler le vol de votre montre | Provena",
      metaDescription:
        "Votre montre de luxe a été volée ? Découvrez les étapes à suivre pour la signaler, prévenir votre assurance et la rendre identifiable. Guide pratique et signalement gratuit.",
      eyebrow: "Que faire en cas de vol",
      title: "Votre montre a été volée ? Voici quoi faire.",
      intro:
        "Le vol d'une montre, surtout une pièce qui compte pour vous, est un moment difficile. Au-delà de la valeur, c'est souvent une histoire, un souvenir, parfois un héritage qui disparaît. Cette page vous explique les démarches à entreprendre rapidement pour maximiser vos chances de la retrouver, et comment la rendre identifiable si quelqu'un tente de la revendre.",
      stepsTitle: "Agissez vite : les premières heures comptent",
      stepsIntro:
        "Plus vous signalez le vol tôt, plus la montre devient difficile à écouler pour le voleur. Voici les étapes à suivre.",
      steps: [
        {
          title: "1. Portez plainte",
          description:
            "Déposez plainte auprès de la police le plus rapidement possible. Munissez-vous de tout ce qui identifie la montre : marque, modèle, et surtout le numéro de série. Le dépôt de plainte est indispensable pour votre assurance et pour toute démarche ultérieure. Conservez précieusement le récépissé.",
        },
        {
          title: "2. Rassemblez les preuves de propriété",
          description:
            "Réunissez tout ce qui prouve que la montre vous appartient : facture d'achat, certificat, photos (notamment du fond de boîte et du numéro de série), papiers d'origine. Ces éléments seront demandés par la police, l'assurance, et serviront à prouver vos droits si la montre réapparaît.",
        },
        {
          title: "3. Prévenez votre assurance",
          description:
            "Si votre montre est assurée (assurance habitation, contrat spécifique, ou garantie dédiée), déclarez le vol dans les délais prévus par votre contrat. Ces délais varient selon les assureurs et les pays, alors vérifiez vos conditions sans attendre.",
        },
        {
          title: "4. Diffusez le signalement",
          description:
            "Une montre volée se revend souvent vite, en ligne ou via des circuits spécialisés. Signalez le vol autour de vous : revendeurs, forums de collectionneurs, plateformes de revente, communauté horlogère. Plus le vol est connu, plus la revente devient risquée pour le voleur.",
        },
        {
          title: "5. Inscrivez le vol dans un registre de provenance",
          description:
            "Enregistrer le vol sur un registre comme Provena crée une trace officielle et datée, associée au numéro de série de votre montre. Si un acheteur prudent, un professionnel ou un revendeur vérifie la montre avant une transaction, le signalement apparaît. Cela rend la pièce plus difficile à écouler et renforce vos preuves en cas de réapparition.",
        },
      ],
      reportCta: "Signaler le vol de ma montre",
      reportCtaNote: "Le signalement est gratuit.",
      protectTitle: "Vos autres montres ont-elles un dossier ?",
      protectText:
        "Une montre enregistrée à l'avance est bien plus facile à signaler et à identifier en cas de vol. Son numéro de série, ses photos et ses preuves de propriété sont déjà réunis, prêts à servir. Provena vous permet de constituer ce dossier en amont, pour vos montres comme pour celles que vous transmettrez.",
      protectCta: "Enregistrer mes montres",
      faqTitle: "Questions fréquentes",
      faq: [
        {
          q: "Comment signaler le vol d'une montre ?",
          a: "Commencez par déposer plainte auprès de la police avec le numéro de série et la description de la montre. Prévenez ensuite votre assurance dans les délais de votre contrat, et diffusez le signalement auprès des revendeurs, plateformes de revente et communautés de collectionneurs. Vous pouvez aussi enregistrer le vol sur un registre de provenance comme Provena pour créer une trace officielle datée, associée au numéro de série.",
        },
        {
          q: "Peut-on retrouver une montre volée grâce à son numéro de série ?",
          a: "Le numéro de série est l'élément clé pour identifier une montre. C'est lui qui permet de la distinguer de toute autre, de prouver qu'elle vous appartient, et de la signaler comme volée. Si la montre réapparaît à la vente, un acheteur ou un professionnel attentif peut comparer ce numéro avec les signalements existants. Plus le vol est documenté et diffusé, plus les chances d'identification augmentent.",
        },
        {
          q: "Est-il légal de revendre une montre volée ?",
          a: "Non. Vendre ou acheter sciemment un bien volé est une infraction. C'est pourquoi de plus en plus d'acheteurs vérifient l'origine d'une montre avant un achat, en demandant ses preuves de propriété et son historique. Une montre dont le vol a été signalé devient nettement plus difficile à écouler.",
        },
        {
          q: "Que faire si je retrouve ma montre volée en vente quelque part ?",
          a: "Ne tentez pas de la récupérer vous-même. Notez toutes les informations disponibles (annonce, vendeur, lieu, capture d'écran) et transmettez-les à la police en faisant le lien avec votre dépôt de plainte. C'est aux autorités d'intervenir. Vos preuves de propriété et votre signalement antérieur faciliteront la procédure.",
        },
        {
          q: "Faut-il une assurance pour signaler le vol d'une montre ?",
          a: "Non. Le signalement d'un vol, auprès de la police comme sur un registre de provenance, est indépendant de votre assurance. L'assurance concerne l'indemnisation éventuelle ; le signalement, lui, vise à rendre la montre identifiable et difficile à revendre. Les deux démarches sont complémentaires.",
        },
        {
          q: "Combien coûte le signalement d'un vol sur Provena ?",
          a: "Le signalement d'un vol sur Provena est gratuit.",
        },
      ],
    },
    dossier: {
      eyebrow: "Consultation du registre",
      title: "Dossier Provena",
      permanentId: "Identifiant permanent",
      notFoundTitle: "Aucun dossier trouvé",
      notFoundText:
        "Aucune montre n'est associée à cet identifiant Provena. Vérifiez le numéro saisi.",
      backHome: "Retour à l'accueil",
      stolenAlertPre: "Cette pièce est actuellement",
      stolenAlertStrong: "signalée comme volée",
      stolenAlertPost: "dans le registre Provena.",
      stolenPending:
        "Un vol a été déclaré pour cette pièce. La référence de plainte n'a pas encore été fournie : le signalement n'est pas confirmé.",
      stolenDisputed:
        "Un vol a été déclaré pour cette pièce, et le détenteur du dossier le conteste. Provena consigne les deux, sans trancher.",
      proBadge: (n) =>
        `${n} intervention${n > 1 ? "s" : ""} professionnelle${n > 1 ? "s" : ""} documentée${n > 1 ? "s" : ""}`,
      noTheftReport: "Aucun signalement de vol connu",
      ownerRegistered: "Propriétaire enregistré, identité confidentielle",
      ownerPending: "Dossier ouvert par un professionnel, en attente de son propriétaire",
      ownerUnclaimed: "Dossier à revendiquer",
      servicedByAtelier: "Entretenue par un atelier professionnel",
      unclaimedHistory:
        "L'historique de ce dossier reste privé jusqu'à ce que son propriétaire le revendique.",
      unclaimedCta: "Revendiquer avec le code de mon reçu d'atelier",
      registeredOn: "Inscrit au registre le {date}",
      verifyTitle: "Vérifier le sceau de ce dossier",
      qrAlt: "QR code de vérification du dossier",
      verifyLink: "Ouvrir la page de vérification",
      confidential: "Les coordonnées du propriétaire restent confidentielles.",
      enrichTitle: "Vous êtes le propriétaire de cette montre ?",
      enrichText:
        "Enrichissez son dossier : ajoutez factures, photographies et documents d'entretien pour valoriser sa provenance.",
      enrichCta: "Je suis le propriétaire · enrichir",
    },
    dashboard: {
      metaTitle: "Mon compte",
      metaDescription:
        "Votre registre Provena : collection, adhésion, rapports, passeports et historique de facturation.",
      loginTitle: "Mon compte",
      loginDescription:
        "Connectez-vous pour retrouver votre collection, votre registre et votre adhésion.",
      loadErrorTitle: "Chargement impossible",
      loadErrorText:
        "Vos données n'ont pas pu être chargées. Vérifiez votre connexion et réessayez.",
      retry: "Réessayer",
      eyebrow: "Votre collection",
      greeting: "Bonjour, {name}",
      greetingNoName: "Bienvenue dans votre registre",
      emailSentTitle: "Un email vous a été envoyé",
      emailFailedTitle: "Document généré",
      emailFailedDesc:
        "L'envoi de l'email a échoué. Retrouvez votre document dans votre espace compte.",
      proArea: "Espace pro",
      becomePro: "Professionnels",
      planBadge: "Plan {tier}",
      subscription: "Abonnement",
      intervalAnnual: "Annuel",
      intervalMonthly: "Mensuel",
      subscriptionValid: "{interval} · valable jusqu'au {date}",
      changeRenew: "Changer / Renouveler",
      comingSoon: "Bientôt disponible",
      cancelConfirmText:
        "Annuler votre abonnement ? L'accès prendra fin immédiatement.",
      cancelConfirmYes: "Confirmer l'annulation",
      cancelConfirmNo: "Garder l'abonnement",
      cancel: "Annuler",
      planFree: "Plan Gratuit",
      freeUpsell:
        "Passez à un abonnement pour débloquer les rapports inclus et les outils avancés.",
      seeSubscriptions: "Voir les abonnements",
      seePricing: "Voir l'adhésion",
      genericError: "Une erreur est survenue.",
      notOwnerError:
        "Cette montre n'est pas enregistrée sous votre compte. Seul le propriétaire enregistré peut enrichir ce dossier.",
      collection: "Ma collection",
      collectionEmpty: "Vous n'avez encore enregistré aucune montre.",
      registerWatch: "Enregistrer une montre",
      addWatch: "Enregistrer une nouvelle montre",
      importBulk: "Importer un fichier",
      reports: "Mes rapports",
      reportsEmpty: "Aucun rapport généré.",
      passports: "Mes passeports",
      passportsEmpty: "Aucun passeport généré.",
      billing: "Historique de facturation",
      billingEmpty: "Aucune transaction.",
      colDate: "Date",
      colOffer: "Offre",
      colAmount: "Montant",
      colStatus: "Statut",
      paid: "Payé",
      cancelFailed: "L'annulation a échoué. Réessayez.",
      itemSerial: "N° de série",
      viewDossier: "Voir le dossier et sa chronologie",
      moreActions: "Autres actions",
      itemNoSerial: "Sans numéro de série",
      edit: "Modifier",
      reportBtn: "Rapport",
      passportBtn: "Passeport",
      transferBtn: "Transférer",
      reportTheftBtn: "Signaler volée",
      stolenBadge: "Signalée volée",
      stolenPendingBadge: "Signalement en attente",
      stolenDisputedBadge: "Signalement contesté",
      disputeTheftBtn: "Contester",
      disputeTitle: "Contester ce signalement",
      disputeIntro: ({ watch }) =>
        `Quelqu'un a déclaré ${watch} volée. Si ce n'est pas le cas, dites-le : votre contestation sera consignée au dossier, datée et à votre nom.`,
      disputeReason: "Ce que vous voulez faire consigner",
      disputeReasonPh:
        "Cette montre est en ma possession, je ne l'ai jamais déclarée volée…",
      disputeNotice:
        "Provena ne tranche pas. Votre contestation s'ajoute au signalement sans l'effacer, et l'avertissement reste affiché tant qu'un administrateur n'a pas clos le litige : le registre montre les deux versions.",
      disputeSubmit: "Consigner ma contestation",
      disputeSending: "Envoi en cours…",
      disputeDone: ({ watch }) =>
        `Votre contestation est consignée au dossier de ${watch}.`,
      disputeError:
        "Une erreur est survenue. Vérifiez les informations et réessayez.",
      reportTheftTitle: "Signaler cette montre volée",
      reportTheftConfirm: "Je confirme que cette montre m'appartient et qu'elle a été volée. Cette déclaration sera inscrite au registre.",
      theftDone: "{watch} a été signalée volée dans le registre.",
      notifTitle: "Notifications par e-mail",
      notifIntro: "Choisissez les e-mails que vous souhaitez recevoir. Les confirmations de vos propres actions sont toujours envoyées.",
      notifProEvent: "Événement professionnel",
      notifProEventHint: "Quand un professionnel ajoute un événement à l'une de vos montres.",
      notifTheftAlerts: "Alerte vols",
      notifTheftAlertsHint:
        "Un récapitulatif chaque matin des montres signalées volées au registre, seulement s'il y en a de nouvelles.",
      notifSaved: "Préférences enregistrées.",
      rgpdTitle: "Mes données",
      rgpdIntro: "Vous gardez le contrôle de vos données. Exportez-les à tout moment, ou supprimez définitivement votre compte.",
      exportBtn: "Exporter mes données",
      exportHint: "Télécharge un fichier avec l'ensemble de vos données (profil, montres, passeports, signalements).",
      deleteBtn: "Supprimer mon compte",
      deleteHint: "Supprime définitivement votre compte et les montres que vous possédez. Action irréversible.",
      deleteTitle: "Supprimer définitivement mon compte",
      deleteWarning: "Cette action est irréversible. Votre compte, les montres que vous possédez et leurs documents seront définitivement supprimés. Les montres que vous avez transférées restent chez leur nouveau propriétaire, mais votre nom en sera retiré.",
      deleteConfirmLabel: "Pour confirmer, tapez {word} ci-dessous.",
      deleteConfirmWord: "SUPPRIMER",
      deleteConfirmBtn: "Supprimer définitivement",
      deleteCancel: "Annuler",
      deleteError: "La suppression a échoué. Réessayez.",
      photoAlt: "Montre",
    },
    // Les e-mails de passeport ont longtemps désigné le document par
    // `/certificat/<id>`, une adresse que rien ne servait. Elle redirige
    // désormais ; ce bloc ne parle que du cas où elle ne peut pas.
    certificateRedirect: {
      seoTitle: "Ouverture de votre passeport",
      notFoundTitle: "Ce passeport n'a pas pu être ouvert",
      notFoundBody:
        "Le lien que vous avez suivi ne désigne aucun passeport de votre compte. Tous vos passeports sont listés sur votre compte, avec leur montre.",
      backToAccount: "Voir mes passeports",
    },
    reportView: {
      seoTitle: "Rapport de provenance · {brand} {model}",
      notFound: "Rapport introuvable.",
      backToAccount: "Retour à mon compte",
      account: "Mon compte",
      print: "Imprimer / Télécharger",
      reportNo: "Report N°",
      provenaId: "Provena ID",
      eyebrow: "Rapport de provenance premium",
      issuedOn: "Émis le {date}",
      identification: "Identification",
      serial: "Numéro de série",
      brand: "Marque",
      model: "Modèle",
      year: "Année",
      declaredOwner: "Propriétaire déclaré",
      provenanceDoc: "Provenance & documentation",
      purchaseProof: "Justificatifs d'achat",
      serviceRecords: "Carnet d'entretien",
      notes: "Notes",
      acquisitionMethod: "Méthode d'acquisition",
      boxPapers: "Boîte & papiers",
      photos: "Photographies",
      dial: "Cadran",
      caseback: "Fond de boîte",
      movement: "Mouvement",
      fileStatus: "État du dossier",
      registered: "Enregistrée dans le registre Provena",
      reportedStolen: "Signalée comme volée",
      noTheft: "Aucun signalement de vol",
      lastUpdate: "Dernière mise à jour : {date}",
      stolenAlert:
        "Cette montre est actuellement signalée comme volée dans le registre Provena.",
      consultFile: "Consulter ce dossier",
      boxOrigin: "Boîte d'origine",
      papersOrigin: "Papiers d'origine",

      provenanceOverview: "Portrait de provenance",
      timeline: "Chronologie",
      sources: "Sources",
      documentsHeading: "Documents au dossier",
      gaps: "Ce que ce dossier n'établit pas",
      gapsIntro:
        "Provena consigne ce qui lui a été rapporté. Les points ci-dessous ne mettent en cause ni la montre ni son propriétaire : ils délimitent la portée de ce rapport.",
      methodology: "Méthodologie",
      methodologyNotice:
        "Un niveau de vérification qualifie la source d'une information, jamais l'authenticité de la montre. Provena n'authentifie pas et ne certifie pas.",
      noEvents: "Aucun événement consigné à ce jour.",
      noGaps: "Aucune lacune notable détectée dans ce dossier.",
      noDocuments: "Aucun document versé au dossier.",
      undatedEvent: "Date non précisée",
      attachmentCount: "{count} pièce(s) jointe(s)",
      sealMismatch:
        "Le sceau de ce dossier ne correspond plus à son contenu. Contactez Provena.",
      tallies: {
        events_recorded: "événements consignés",
        documents: "documents versés",
        ownership_events: "événements de propriété",
        service_events: "interventions consignées",
        third_party_events: "événements attestés par un tiers",
        documented_events: "événements appuyés par une pièce",
      },
      gapKeys: {
        pre_record_gap:
          "Entre {from} et {to}, la montre existait sans qu'aucun événement ne soit consigné ici.",
        coverage_gap: "Aucun événement consigné entre {from} et {to}.",
        undated_events:
          "{count} événement(s) sans date précise : leur place dans la chronologie est incertaine.",
        no_documents: "Aucune pièce justificative n'est versée au dossier.",
        no_serial:
          "Ce dossier ne porte pas de numéro de série : le recoupement avec le registre des vols est impossible.",
        ownership_self_reported_only:
          "Les {count} changement(s) de main reposent sur la seule déclaration du propriétaire.",
        no_service_history: "Aucune intervention d'entretien n'est consignée.",
        event_precedes_production:
          "{count} événement(s) sont datés avant l'année de production déclarée ({production_year}). Provena signale l'incohérence sans la trancher.",
      },
    },
    verifyPage: {
      metaTitle: "Vérification Provena",
      seoTitle: "Vérification · {brand} {model}",
      notFoundTitle: "Aucun dossier trouvé",
      notFoundTextPre: "Aucune montre n'est associée à l'identifiant",
      notFoundTextPost: "dans le registre Provena.",
      backHome: "Retour à l'accueil",
      invalidTitle: "Signature invalide",
      validTitle: "Dossier intact",
      invalidText: "Ce document a été modifié après son émission.",
      validText:
        "Signature cryptographique vérifiée : le dossier n'a pas changé depuis son scellement.",
      validTextOn:
        "Signature cryptographique vérifiée : le dossier n'a pas changé depuis son scellement le {date}.",
      scopeNote:
        "Ce contrôle porte sur le dossier. Il ne dit rien de l'authenticité de la montre.",
      stolenPre: "Cette montre est actuellement",
      stolenStrong: "signalée comme volée",
      stolenPost: "dans le registre.",
      watch: "Garde-temps",
      registeredOn: "Enregistré le {date}",
      sealedOn: " · scellé le {date}",
      integrity: "Intégrité cryptographique",
      sealed: "Dossier scellé",
      hashMatch: "Empreinte SHA-256 conforme",
      signatureValid: "Signature RSA valide",
      qrAuthentic: "QR code émis par Provena",
      algorithm: "Algorithme",
      fingerprint: "Empreinte du dossier",
      signatureKey: "Clé de signature",
      signedPassport: "Passeport signé",
      passportSignatureValid: "Signature du passeport valide",
      passportNo: "Passeport n° {no}",
      issuedOn: "Émis le {date}",
      issuedToPreviousHolder:
        "Émis à un détenteur précédent : ce passeport ne dit pas qui détient la montre aujourd'hui.",
      theftCheckTitle: "Vérification anti-vol",
      theftCheckText:
        "Provena enregistre les déclarations de vol adossées à un rapport de police. Pour un contrôle complémentaire, vérifiez le statut de cette montre sur le registre international Enquirus.",
      theftCheckCta: "Vérifier sur Enquirus",
      viewPublicFile: "Voir le dossier public",
      publicKey: "Clé publique",
      legalNote:
        "Cette page confirme l'intégrité des données enregistrées dans le registre Provena à l'aide d'une empreinte SHA-256 et d'une signature RSA. Elle ne constitue pas une authentification de la montre elle-même.",
    },
    payment: {
      metaTitle: "Confirmation de paiement",
      kindReport: "Votre crédit de rapport de provenance a été ajouté.",
      kindCertificate: "Votre crédit de passeport a été ajouté.",
      kindSubscription: "Votre abonnement est désormais actif.",
      kindDefault: "Votre achat a bien été pris en compte.",
      checkingTitle: "Vérification du paiement…",
      checkingText: "Merci de patienter quelques instants.",
      successTitle: "Paiement confirmé",
      toAccount: "Accéder à mon compte",
      timeoutTitle: "Paiement en attente",
      failedTitle: "Paiement non abouti",
      timeoutText:
        "Le traitement prend plus de temps que prévu. Vérifiez votre compte d'ici quelques minutes.",
      failedText:
        "Le paiement n'a pas pu être confirmé. Aucune somme n'a été débitée.",
      backToPricing: "Retour à l'adhésion",
      account: "Mon compte",
    },
    notFound: {
      metaTitle: "Page introuvable",
      metaDescription:
        "La page que vous recherchez n'existe pas ou a été déplacée.",
      error: "Erreur 404",
      title: "Page introuvable",
      text: "La page que vous recherchez n'existe pas ou a été déplacée.",
      backHome: "Retour à l'accueil",
    },
    transfer: {
      title: "Transférer la propriété",
      serial: "N° de série",
      noSerial: "Sans numéro de série",
      provenaIdKept: "Provena ID · {id} (conservé après transfert)",
      newOwnerName: "Nom du nouveau propriétaire",
      newOwnerNamePlaceholder: "Prénom et nom",
      newOwnerEmail: "E-mail du nouveau propriétaire",
      newOwnerEmailPlaceholder: "nouveau@exemple.com",
      note: "Le nouveau propriétaire reçoit un lien pour récupérer le dossier. Jusque-là, il reste à votre nom : vous pouvez relancer ou annuler. Vous serez prévenu quand il l'aura récupéré.",
      confirmCheckbox:
        "Je cède le dossier de {watch} à cette personne. Une fois qu'elle l'aura récupéré, il quittera ma collection.",
      submit: "Envoyer le lien",
      genericError: "Une erreur est survenue.",
      success: "Lien envoyé à {email}. Le dossier reste à votre nom jusqu'à ce qu'il soit récupéré.",
    },
    pendingTransfer: {
      text: "En attente de {name} ({email}) : lien envoyé le {date}.",
      hint: "Le dossier reste à votre nom tant qu'il n'est pas récupéré.",
      resend: "Relancer",
      resendLater: "Relance possible à partir du {date}.",
      cancel: "Annuler le transfert",
      resent: "Lien renvoyé.",
      cancelled: "Transfert annulé : le lien envoyé ne sert plus.",
    },
    recordCreation: {
      action: "Consigner la fabrication",
      title: "Consigner la fabrication",
      intro:
        "Décrivez une étape de fabrication ou son achèvement. Vous pouvez en consigner plusieurs : une pièce se fait en plusieurs temps. Tant qu'aucune fabrication n'est consignée, le dossier vous réclame une facture d'achat, pour une montre que personne n'a achetée.",
      done: "Fabrication consignée dans le dossier.",
    },
    addDocument: {
      title: "Ajouter un document",
      serial: "N° de série",
      provenaId: "Provena ID",
      type: "Type de document",
      dateOptional: "Date (optionnelle)",
      description: "Description",
      attachment: "Pièce jointe",
      descriptionError: "Veuillez décrire le document ou l'information ajoutée.",
      descriptionPublic: "Cette description apparaîtra sur la page publique de votre montre, lisible par tous. Le fichier joint, lui, reste privé et n'est visible que par vous.",
      genericError: "Une erreur est survenue.",
      note: "Le document sera consigné dans l'historique public de la montre au niveau « Déclaré par le propriétaire ».",
      submit: "Ajouter au dossier",
      success: "Document ajouté à l'historique de {watch}.",
      categories: {
        facture: {
          label: "Facture / justificatif d'achat",
          hint: "Ajoutez la facture, la carte de garantie ou le justificatif (PDF ou image).",
          placeholder: "Ex. Facture boutique Rolex du 12/03/2019, montant inclus…",
        },
        entretien: {
          label: "Entretien / révision",
          hint: "Joignez le bon d'entretien ou la facture de révision (PDF ou image).",
          placeholder: "Ex. Révision complète, remplacement du joint de couronne…",
        },
        photo: {
          label: "Photographie",
          hint: "Ajoutez une photographie récente de la montre (JPEG, PNG, WebP).",
          placeholder: "Ex. Photographie du cadran après révision.",
        },
        autre: {
          label: "Autre document / information",
          hint: "Joignez tout document utile à la provenance (PDF ou image).",
          placeholder: "Précisez l'information ou le document ajouté.",
        },
      },
    },
    registerPage: {
      metaTitle: "Enregistrer ma montre",
      metaDescription:
        "Enregistrez votre montre de luxe dans le registre Provena : constituez son historique de propriété et de provenance en toute sécurité.",
      loginDescription:
        "Connectez-vous pour enregistrer votre montre et constituer son historique de provenance en toute sécurité.",
      gateTitle: "Il ne manque plus que vous",
      gateDescription:
        "Créez votre compte pour joindre les photos et les documents, puis sceller le dossier. Ce que vous venez de saisir est conservé.",
      eyebrow: "Dossier de provenance",
      title: "Enregistrer ma montre",
      subtitle:
        "Chaque montre a une histoire. Donnez à la vôtre un dossier qui la consigne, daté et scellé.",
      reassurance: [
        "5 minutes suffisent",
        "Gratuit, sans carte",
        "Visible par vous seul",
      ],
      bulkPrompt: "Plusieurs montres à enregistrer ?",
      bulkLink: "Importer un fichier",
      atelierPrompt: "Une pièce sortie de votre atelier ?",
      atelierLink: "L'enregistrer depuis l'espace créateur",
      similarTitle: "Est-ce la même montre ?",
      similarBody:
        "Un dossier très proche existe déjà dans votre registre : {provena} (numéro {serial}). Une lettre ou un chiffre de différence vient souvent d'une lecture de photo imparfaite.",
      similarSame: "Oui, c'est la même : mettre à jour ce dossier",
      similarDifferent: "Non, c'est une autre montre : créer un dossier",
      similarBack: "Revenir au formulaire",
    },
    registerSuccess: {
      captionProvena: "Identifiant Provena",
      captionSerial: "Numéro de série",
      title: "Montre scellée",
      bodyPre: "La montre portant le numéro de série ",
      bodyAux: " a été ",
      bodyRegistered: "enregistrée et scellée",
      bodyUpdated: "mise à jour et re-scellée",
      bodyPost: " dans le registre Provena.",
      bodyProvenaPre: "La montre a été ",
      bodyProvenaMid: " dans le registre Provena, sous l'identifiant ",
      bodyProvenaPost: ".",
      hint:
        "Son dossier est désormais scellé et consultable par numéro de série dans le registre.",
      hintProvena:
        "Son dossier est désormais scellé et consultable par identifiant Provena dans le registre.",
      backHome: "Retour à l'accueil",
      another: "Enregistrer une autre montre",
    },
    upload: {
      formatDoc: "Format non supporté (PDF, JPG ou PNG).",
      formatPhoto: "Format non supporté (JPEG, PNG ou WebP).",
      tooLargeDoc: "Fichier trop volumineux (max 8 Mo).",
      tooLargePhoto: "Image trop volumineuse (max 8 Mo).",
      failed: "Échec du téléversement. Réessayez.",
      uploading: "Téléversement…",
      chooseFile: "Choisir un fichier (PDF ou image)",
      dropFile: "Glissez-déposez votre fichier ou cliquez pour parcourir",
      docHint: "PDF, JPG ou PNG · max 8 Mo",
      docAdded: "Document ajouté",
      removeDoc: "Retirer le document",
      takePhotoDoc: "Prendre une photo du document",
      takePhoto: "Prendre une photo",
      chooseGallery: "Choisir dans la galerie",
      photoAdded: "Photo ajoutée",
      photoHint: "JPEG, PNG, WebP · max 8 Mo",
      addPhoto: "Ajouter une photo (JPEG, PNG, WebP, max 8 Mo)",
      removePhoto: "Retirer la photo",
      formatGeneric: "Format non supporté.",
      fileAdded: "Fichier ajouté",
      addFile: "Ajouter un fichier (max 8 Mo)",
    },
    completeness: {
      title: "Portrait de provenance",
      axisRichesse: "Richesse",
      axisAncrage: "Ancrage",
      richesse: {
        ebauche: "Ébauche",
        en_construction: "En construction",
        etoffe: "Étoffé",
        nourri: "Nourri",
      },
      richesseBlurb: {
        ebauche: "Dossier ouvert : chaque trace ajoutée l'étoffe.",
        en_construction: "Les premiers chapitres s'écrivent.",
        etoffe: "Un dossier déjà substantiel.",
        nourri: "Un dossier riche, qui raconte la montre.",
      },
      ancrage: {
        declaratif: "Surtout déclaratif",
        partiel: "Partiellement documenté",
        large: "En grande partie documenté",
        plein: "Pleinement documenté",
        none: "Rien de consigné pour l'instant",
      },
      ancrageBlurb: {
        declaratif: "Repose surtout sur la parole du propriétaire.",
        partiel: "Une partie s'appuie sur des pièces.",
        large: "L'essentiel s'appuie sur des pièces.",
        plein: "Adossé à des documents et des tiers.",
        none: "Ajoutez une pièce pour commencer à l'ancrer.",
      },
      chapters: {
        documents: "Documents",
        photos: "Photographies",
        history: "Historique vivant",
        box_papers: "Boîte & papiers",
        identity: "Identité",
      },
      state: {
        absent: "À venir",
        amorce: "Amorcé",
        nourri: "Nourri",
      },
      sources: {
        document: "documenté",
        tiers: "attesté par un tiers",
        declare: "déclaré",
      },
      invitationTitle: "Pour aller plus loin",
      invitation: {
        ajouter: "Ce dossier gagnerait à porter {element}.",
        documenter: "Joignez {element} au dossier pour l'ancrer davantage.",
      },
      elements: {
        facture: "la facture d'origine",
        carnet: "le carnet d'entretien",
        photo_cadran: "une photo du cadran",
        photo_fond: "une photo du fond de boîte",
        photo_mouvement: "une photo du mouvement",
        evenement: "un événement (révision, expertise…)",
        papiers: "les papiers d'origine",
        boite: "la boîte d'origine",
        annee: "l'année de production",
        acquisition: "la méthode d'acquisition",
        pays: "le pays du propriétaire",
      },
      honesty:
        "Provena consigne l'origine des éléments d'un dossier ; elle ne certifie pas leur authenticité.",
    },
    share: {
      eyebrow: "Partager ce dossier",
      copy: "Copier le lien",
      copied: "Lien copié",
      passportText: "Passeport numérique Provena",
    },
    bulkImport: {
      metaTitle: "Importer plusieurs montres",
      metaDescription:
        "Enregistrez toute une collection en une fois dans le registre Provena à partir d'un fichier CSV ou Excel.",
      loginDescription:
        "Connectez-vous pour enregistrer toute votre collection en une seule fois.",
      back: "Enregistrement classique",
      eyebrow: "Import en masse",
      title: "Toute votre collection, en une fois",
      intro:
        "Déposez un fichier CSV ou Excel. Nous validons chaque ligne avant tout enregistrement : vous confirmez, nous scellons. Les photos et documents s'ajoutent ensuite montre par montre.",
      template: "Télécharger le modèle CSV",
      validateError: "Le fichier n'a pas pu être analysé. Vérifiez son format.",
      commitError: "L'import n'a pas pu être finalisé. Réessayez dans un instant.",
      ownerMode: "Ces montres sont",
      modeSelfTitle: "Les miennes",
      modeSelfDesc: "Elles rejoignent directement votre collection.",
      modeClientsTitle: "Celles de mes clients",
      modeClientsDesc:
        "Chaque propriétaire reçoit une invitation à revendiquer sa montre.",
      dropzone: "Glissez-déposez votre fichier ou cliquez pour parcourir",
      analyzing: "Analyse du fichier…",
      dropHint: "CSV ou Excel (.xlsx) · 200 montres max",
      colWatch: "Montre",
      colStatus: "Statut",
      noSerial: "sans numéro de série",
      statusOk: "Prête à enregistrer",
      statusDuplicate: "Mise à jour de votre dossier",
      statusOwned: "Déjà enregistrée par un autre compte",
      statusInvalid: "Ligne invalide",
      analyzedOne: "1 ligne analysée",
      analyzedMany: "{count} lignes analysées",
      toRegister: "{count} à enregistrer",
      ownedCount: "{count} appartiennent à un autre compte",
      invalidOne: "1 invalide",
      invalidMany: "{count} invalides",
      commitOne: "Enregistrer 1 montre",
      commitMany: "Enregistrer {count} montres",
      chooseOther: "Choisir un autre fichier",
      nothingImportable:
        "Aucune ligne enregistrable dans ce fichier. Corrigez-le à partir du modèle, puis réessayez.",
      successCaption: "Montres enregistrées",
      successTitleSelf: "Collection scellée",
      successTitleClients: "Montres enregistrées",
      successBodyOne:
        "1 montre enregistrée. Un récapitulatif vient de vous être envoyé par e-mail.",
      successBodyMany:
        "{count} montres enregistrées. Un récapitulatif vient de vous être envoyé par e-mail.",
      successHintSelf:
        "Complétez chaque dossier (photos, factures, historique) depuis votre espace pour renforcer sa provenance.",
      successHintClientsOne:
        "1 invitation envoyée : chaque propriétaire peut désormais revendiquer sa montre. En attendant, vous en gardez la gestion.",
      successHintClientsMany:
        "{count} invitations envoyées : chaque propriétaire peut désormais revendiquer sa montre. En attendant, vous en gardez la gestion.",
      gotoAccount: "Voir ma collection",
      importAnother: "Importer un autre fichier",
    },
    claim: {
      metaTitle: "Revendiquer ma montre",
      metaDescription:
        "Prenez le contrôle du dossier de provenance d'une montre enregistrée à votre nom.",
      notFoundTitle: "Invitation introuvable",
      notFoundBody:
        "Ce lien n'est plus valable, ou la montre a déjà été revendiquée. Si vous pensez qu'il s'agit d'une erreur, contactez le professionnel qui vous a envoyé cette invitation.",
      backHome: "Retour à l'accueil",
      claimedCaption: "Montres revendiquées",
      claimedTitle: "C'est à vous",
      claimedBodyOne:
        "1 montre vous appartient désormais dans le registre. Vous seul contrôlez son dossier, son historique et son passeport numérique.",
      claimedBodyMany:
        "{count} montres vous appartiennent désormais dans le registre. Vous seul contrôlez leur dossier, leur historique et leur passeport numérique.",
      gotoAccount: "Voir ma collection",
      loginDescription:
        "Connectez-vous avec l'adresse e-mail à laquelle l'invitation a été envoyée pour prendre le contrôle du dossier.",
      eyebrow: "Invitation",
      titleOne: "Une montre vous attend",
      titleMany: "{count} montres vous attendent",
      whatOne: "cette montre",
      whatMany: "ces montres",
      introByProTail: " a enregistré {what} à votre nom dans le registre Provena.",
      introSalePre: "Vous avez acheté cette montre chez ",
      introSaleTail: ". Son dossier vous attend : récupérez-le à votre nom, avec son passeport.",
      introTransferTail: " vous transfère le dossier de sa montre. Récupérez-le à votre nom, avec son passeport.",
      introNoProOne:
        "Cette montre a été enregistrée à votre nom dans le registre Provena.",
      introNoProMany:
        "Ces montres ont été enregistrées à votre nom dans le registre Provena.",
      confirmOne: "C'est ma montre",
      confirmMany: "Revendiquer mes montres",
      disclaimer:
        "En revendiquant, vous devenez le propriétaire enregistré : vous seul contrôlerez le dossier et son passeport. Votre adresse e-mail doit correspondre à celle de l'invitation.",
      claimError: "La revendication a échoué. Réessayez dans un instant.",
      codeEyebrow: "Reçu d'atelier",
      codeTitle: "Revendiquer ma montre",
      codeIntro:
        "Un atelier a inscrit l'entretien de votre montre au registre Provena. Saisissez son numéro de série et le code imprimé sur votre reçu de restitution : le dossier passera à votre nom.",
      codeLoginDescription:
        "Connectez-vous pour revendiquer le dossier de votre montre avec le code de votre reçu d'atelier.",
      codeSerialLabel: "Numéro de série",
      codeLabel: "Code du reçu",
      codeSubmit: "Revendiquer le dossier",
      codeHelp:
        "Reçu perdu ? Écrivez à contact@provenaregistry.com avec une preuve d'achat ou des photos du fond de la montre : nous examinerons votre demande.",
    },
    prov: {
      events: {
        CREATION: "Fabrication à l'atelier",
        REGISTRATION: "Enregistrement au registre",
        SERVICE: "Révision / Entretien",
        SALE: "Vente professionnelle",
        APPRAISAL: "Expertise / Estimation",
        AUTHENTICATION: "Authentification (déclarée par un tiers)",
        THEFT: "Déclaration de vol",
        THEFT_DISPUTED: "Signalement de vol contesté",
        RECOVERY: "Montre retrouvée",
        OWNERSHIP_TRANSFER: "Transfert de propriété",
        INSURANCE: "Assurance",
        UPDATE: "Informations mises à jour",
        DOCUMENT: "Document ajouté",
        CONSIGNMENT: "Confiée en dépôt-vente",
        CONSIGNMENT_END: "Reprise du dépôt-vente",
      },
      levels: {
        SELF_REPORTED: "Déclaré par le propriétaire",
        DOCUMENTED: "Déclaré, pièce à l'appui",
        ATELIER_REPORTED: "Signalé par un atelier",
        CREATOR_DECLARED: "Déclaré par le créateur",
        PROFESSIONAL: "Professionnel enregistré",
        VERIFIED: "Consigné par Provena",
        MANUFACTURER_VERIFIED: "Confirmé par la manufacture",
      },
      actors: {
        proprietaire: "Propriétaire",
        createur: "Créateur",
        horloger: "Horloger",
        marchand: "Marchand",
        expert: "Expert",
        assureur: "Assureur",
        admin: "Provena",
      },
      proActors: {
        createur: { label: "Créateur / manufacture indépendante", desc: "Pièces conçues et fabriquées à l'atelier." },
        horloger: { label: "Horloger / atelier", desc: "Révisions, entretiens et réparations." },
        marchand: { label: "Marchand professionnel", desc: "Ventes et transactions de montres." },
        expert: { label: "Expert horloger", desc: "Expertises, estimations et authentifications." },
        assureur: { label: "Assureur", desc: "Couvertures et déclarations d'assurance." },
      },
    },
    authorize: {
      metaTitle: "Relier une application",
      eyebrow: "Application reliée",
      title: "Relier votre compte Provena à {app}",
      signedInAs: "Connecté en tant que {email}.",
      canTitle: "{app} pourra, en votre nom",
      neverTitle: "{app} ne pourra jamais",
      neverItems: [
        "Transférer une montre à votre place, ni en fixer un prix.",
        "Déclarer un vol.",
        "Voir vos montres personnelles ni les données de leurs propriétaires.",
        "Modifier ou supprimer votre compte.",
      ],
      scopes: {
        "dossiers:read": "Rechercher une montre au registre par son numéro ou son Provena ID, et savoir si elle est signalée volée.",
        "events:write": "Consigner en votre nom des événements (révision, expertise, dépôt-vente…) sur le dossier d'une montre.",
        "dossiers:create": "À la vente d'une montre que vous aviez en dépôt, ouvrir son dossier au nom de l'acheteur, qui le récupère ensuite lui-même. Sans aucun prix, ni le nom du déposant.",
        "files:write": "Joindre des pièces aux événements que vous consignez.",
        "stock:create": "Donner un Provena ID aux montres de votre stock, à votre nom.",
        "stock:transmit": "Transmettre à l'acheteur, sans aucun prix, le dossier d'une montre de votre stock que vous vendez.",
      },
      proPending:
        "Votre demande de statut professionnel est en cours d'examen. Vous pouvez relier votre compte dès maintenant : {app} pourra agir en votre nom dès que Provena l'aura validée.",
      proNeeded:
        "Ces droits ne prennent effet qu'avec un statut professionnel validé par Provena. Vous pouvez relier votre compte dès maintenant, et faire votre demande ici : {app} pourra agir en votre nom dès sa validation.",
      actorLegend: "Votre activité",
      approve: "Autoriser",
      deny: "Refuser",
      decisionError: "La réponse n'a pas pu être enregistrée. Réessayez.",
      revokeHint: "Vous pourrez retirer cet accès à tout moment, dans",
      revokeLink: "Mon compte",
      invalidTitle: "Lien d'autorisation invalide",
      invalidBody: "Ce lien ne vient pas d'une application reliée à Provena. Retournez dans l'application et recommencez.",
      goneTitle: "Demande expirée",
      goneBody: "Cette demande a expiré ou a déjà reçu une réponse. Retournez dans l'application et recommencez.",
    },
    linkedApps: {
      title: "Applications reliées",
      intro: "Ces applications agissent en votre nom, avec les seuls droits que vous leur avez accordés. Retirer l'accès les coupe aussitôt.",
      linkedOn: "Reliée le {date}",
      lastUsed: "dernière utilisation le {date}",
      remove: "Retirer l'accès",
      confirm: "Confirmer le retrait",
      cancel: "Annuler",
      removeError: "L'accès n'a pas pu être retiré. Réessayez.",
    },
    pro: {
      metaTitle: "Espace professionnel",
      metaDescription:
        "Portail professionnel Provena : enrichissez l'historique vérifiable des montres.",
      // RDEC-023 : la page « Professionnels » présente Studio ; les
      // candidatures à l'espace professionnel sont fermées.
      studioPage: {
        title: "Vous êtes un atelier ? Votre outil, c'est Provena Studio",
        intro:
          "Provena Studio est l'outil de travail des ateliers horlogers. C'est là que vous travaillez chaque jour ; Registry reste le registre public de provenance.",
        items: [
          "Les montres en réparation, du dépôt au comptoir à la remise au client.",
          "Les devis, que le client accepte ou signe en ligne.",
          "Le suivi de vos clients, et la vente de montres d'occasion ou en dépôt.",
        ],
        cta: "Découvrir Provena Studio",
        registryTitle: "Et le registre ?",
        registryBody:
          "La publication au registre se fera depuis Studio, sans double saisie. Les candidatures à l'espace professionnel de Registry sont donc fermées ; les professionnels déjà validés gardent leur espace.",
        verify: "Vérifier qu'une montre n'est pas signalée volée reste ouvert à tous, sans compte :",
        verifyLink: "consulter une montre",
      },
      applyMetaTitle: "Professionnels",
      applyMetaDescription:
        "Vous êtes un atelier horloger ? Votre outil de travail est Provena Studio ; la publication au registre de provenance se fera depuis Studio.",
      applyLoginDescription:
        "Connectez-vous pour soumettre votre demande de compte professionnel.",
      gateTitle: "Espace réservé aux professionnels",
      gateBody:
        "Cet espace est réservé aux professionnels dont le compte a déjà été validé par Provena. Les nouvelles candidatures sont fermées : un atelier travaille dans Provena Studio.",
      becomePro: "Professionnels",
      eyebrow: "Espace professionnel",
      portalFallback: "Portail professionnel",
      actorFallback: "Professionnel",
      searchTitle: "Rechercher ou enregistrer une montre",
      searchIntro:
        "Entrez un numéro de série ou un Provena ID. Si le registre connaît la montre, vous ouvrez son dossier et y consignez un événement ; sinon, vous ouvrez son dossier.",
      preview: {
        label: "Voir le portail comme",
        self: "Mon compte",
        active: "Aperçu : rien n'est écrit sous ce rôle.",
      },
      myEvents: "Mes interventions",
      historyEmpty: "Aucune intervention enregistrée pour le moment.",
      historyEmptyHow:
        "Une intervention est ce que vous consignez sur le dossier d'une montre : une fabrication, une révision, une expertise. C'est elle qui porte votre statut dans l'histoire de la pièce, pas le dossier lui-même. Commencez par retrouver la montre, par son numéro de série ou son Provena ID.",
      historyStartCta: "Consigner ma première intervention",
      viewPublic: "Voir le dossier public",
      // Application
      applyEyebrow: "Professionnels",
      applyTitle: "Devenir professionnel",
      applyIntro:
        "Horlogers, marchands, experts et assureurs peuvent enrichir l'historique vérifiable d'une montre. Après validation par notre équipe, vos contributions porteront le niveau « professionnel enregistré ».",
      establishment: "Nom de l'établissement",
      establishmentPh: "Ex. Atelier Horloger Genève",
      applySubmit: "Soumettre ma demande",
      applyError: "Une erreur est survenue. Réessayez.",
      // Ce qu'un professionnel obtient, et ce qui est attendu de lui.
      whatYouDo: "Ce que vous pourrez faire",
      whatYouDoItems: [
        "Consigner vos interventions sur n'importe quelle montre du registre, au niveau « professionnel enregistré ».",
        "Ouvrir un dossier pour un client dont la montre n'est pas encore enregistrée ; il le revendique ensuite lui-même.",
        "Vérifier en un instant qu'une montre n'est pas signalée volée, avant de l'accepter à l'atelier.",
      ],
      whatWeAsk: "Ce que Provena attend de vous",
      whatWeAskBody:
        "Vos entrées portent la mention « professionnel enregistré » : elles pèsent plus lourd que la parole d'un propriétaire. N'y consignez que ce que vous avez constaté vous-même. Provena n'authentifie pas les montres et ne vous demande jamais de le faire.",
      applyFree: "La candidature et l'espace professionnel sont gratuits pendant la bêta.",
      // Champs de candidature
      country: "Pays",
      city: "Ville",
      activityLabel: "Votre activité",
      activityPh:
        "Décrivez votre atelier ou votre maison : depuis quand, quelles marques, quel type d'interventions. Quelques lignes suffisent.",
      activityHint: "30 caractères minimum : c'est sur cette description que reposera la décision.",
      website: "Site web",
      websitePh: "exemple.com",
      websiteHint: "Facultatif, mais c'est l'élément qui accélère le plus la validation.",
      registrationNumber: "Numéro d'immatriculation",
      registrationPh: "SIRET, n° TVA, registre du commerce…",
      phone: "Téléphone",
      optional: "Facultatif",
      applyDetailsTitle: "Votre établissement",
      approvedTitle: "Compte professionnel validé",
      approvedBody:
        "Vous pouvez désormais enrichir l'historique des montres du registre.",
      approvedCta: "Accéder à l'espace professionnel",
      pendingTitle: "Demande en cours d'examen",
      pendingBody:
        "Votre demande de compte professionnel a bien été reçue. Notre équipe la validera prochainement. Vous serez informé dès son acceptation.",
      // Watch search
      searchPlaceholder: "Numéro de série ou Provena ID (ex. PRV-000001)",
      searchBtn: "Rechercher",
      searchNotFoundSerial: "Aucune montre trouvée pour le numéro de série « {q} » dans le registre.",
      searchNotFoundProvenaId: "Aucun dossier pour le Provena ID {q}.",
      registerForClient: "Enregistrer pour un client",
      openDossier: "Ouvrir un dossier",
      // Un marchand détient son stock jusqu'à la vente, exactement comme un
      // créateur détient ce qu'il a fait. Le dépôt-vente, lui, ne passe jamais
      // par ici : la montre reste à son propriétaire.
      stockRegister: {
        title: "Enregistrer une montre de votre stock",
        intro:
          "Vous en devenez le propriétaire enregistré, ce qui est simplement vrai : la pièce est à vous jusqu'à sa vente. La remise à son acquéreur sera plus tard un véritable transfert, et la chaîne montrera le marchand puis l'acheteur.",
        submit: "Ouvrir le dossier",
        cancel: "Annuler",
        ownership:
          "N'utilisez pas cette voie pour une pièce en dépôt-vente : elle reste à son propriétaire, et c'est lui qu'il faut désigner. Le nom du propriétaire entre dans le sceau du dossier.",
        done: "Dossier {provenaId} ouvert à votre nom. Consignez ci-dessous ce que vous savez de la pièce.",
      },
      ownerQuestion: {
        title: "À qui est cette montre ?",
        body:
          "Le registre n'écrit pas la même chose selon la réponse, et le nom du propriétaire entre dans le sceau du dossier. Une pièce reçue en dépôt-vente reste à son propriétaire : désignez-le, il recevra une invitation à revendiquer son dossier.",
        atelierRegister: "Elle est à moi : une pièce de mon atelier",
        stockRegister: "Elle est à moi : c'est mon stock",
        client: "Elle est à un client : dépôt-vente, entretien ou expertise",
      },
      atelierRegister: {
        cta: "Enregistrer une pièce de mon atelier",
        title: "Enregistrer une pièce de votre atelier",
        intro:
          "Vous en devenez le propriétaire enregistré, ce qui est simplement vrai : la pièce est à vous jusqu'à sa vente. La livraison à son acquéreur sera plus tard un véritable transfert, et la chaîne montrera créateur puis premier propriétaire. Vous pourrez consigner sa fabrication immédiatement.",
        submit: "Ouvrir le dossier",
        cancel: "Annuler",
        ownership:
          "Laissez la méthode d'acquisition vide : aucune ne décrit une pièce que vous avez faite. Son acquéreur choisira « Neuf · directement auprès du créateur » en revendiquant le dossier.",
        done: "Dossier {provenaId} ouvert. Consignez sa fabrication ci-dessous.",
        open: "Ouvrir le dossier de cette pièce",
        intent:
          "Pièce de votre atelier : entrez son numéro ci-dessus. Si le registre la connaît déjà, j'ouvre son dossier ; sinon, vous en ouvrirez un.",
      },
      clientRegister: {
        title: "Enregistrer cette montre pour votre client",
        intro:
          "Le dossier est ouvert au nom de votre client et l'attend : vous n'en devenez pas propriétaire. Il reçoit une invitation et le revendique en se connectant. Vous pourrez y consigner votre intervention immédiatement.",
        clientName: "Nom du client",
        clientEmail: "E-mail du client",
        emailHint: "L'invitation à revendiquer le dossier part à cette adresse.",
        submit: "Ouvrir le dossier",
        cancel: "Annuler",
        theClient: "votre client",
        ownership: "Le dossier restera en attente jusqu'à ce que {email} le revendique.",
        alreadyRegistered:
          "Cette montre figure déjà au registre. Recherchez-la pour y ajouter un événement.",
        error: "L'enregistrement a échoué. Réessayez dans un instant.",
        done: "Dossier {provenaId} ouvert. Invitation envoyée à votre client.",
        doneNoEmail: "Dossier {provenaId} ouvert. L'invitation n'a pas pu partir ; votre client pourra le revendiquer à sa prochaine connexion.",
        doneUpdated: "Le dossier {provenaId} existait déjà : il a été mis à jour, non créé. Vérifiez ses champs, puis consignez votre événement ci-dessous.",
      },
      similar: {
        title: "Un numéro très proche existe déjà",
        body: "Le dossier {provena} porte le numéro {serial}, à un caractère de celui-ci. Est-ce la même montre ?",
        open: "Oui, ouvrir son dossier pour y consigner l'intervention",
        different: "Non, c'est une autre pièce : l'enregistrer quand même",
        exactTitle: "Cette montre a déjà son dossier",
        exactBody: "Le numéro {serial} est celui du dossier {provena}. Une montre déjà enregistrée s'enrichit par son historique, elle ne s'enregistre pas deux fois.",
        exactOpen: "Ouvrir son dossier pour y consigner l'intervention",
      },
      searchYear: "Année {y}",
      searchStolen: "Signalée comme volée",
      searchStolenUnregistered:
        "Le numéro « {q} » n'a pas de dossier Provena, mais il est signalé volé. Ne l'achetez pas, et ne l'enregistrez pas.",
      addEvent: "Ajouter un événement",
      // Event form
      eventAdded: "Événement ajouté",
      eventAddedBody: "L'événement a été consigné dans l'historique de {watch}.",
      addAnother: "Ajouter un autre événement",
      selectedWatch: "Montre sélectionnée",
      eventType: "Type d'événement",
      eventDate: "Date de l'intervention",
      description: "Description",
      descriptionPh: "Détaillez l'intervention, l'expertise ou la transaction…",
      descriptionPublic: "Ce texte apparaîtra sur la page publique de la montre, lisible par tous. N'y mettez ni le nom, ni l'adresse, ni les coordonnées de votre client : décrivez l'intervention, pas la personne. Les fichiers joints, eux, restent privés.",
      photoCraft: "Photo de l'étape",
      photoCraftHint: "Travail en cours à l'atelier",
      photoDetail: "Photo de détail",
      photoDetailHint: "Finition, gravure, composant",
      atelierDoc: "Document d'atelier (PDF ou image)",
      photoBefore: "Photo avant",
      photoBeforeHint: "Photo avant intervention",
      photoAfter: "Photo après",
      photoAfterHint: "Photo après intervention",
      invoiceDoc: "Facture (PDF ou image)",
      commercialDoc: "Document commercial (PDF ou image)",
      attachHint: "Facture / document (PDF, JPEG, PNG, WebP)",
      eventSubmit: "Consigner l'événement",
      eventError: "Une erreur est survenue. Réessayez.",
      metaLabel: {
        price: "Prix",
        currency: "Devise",
        buyer: "Acheteur",
        reference: "Référence",
        insurer: "Assureur",
        policy: "Police",
        insuredValue: "Valeur assurée",
        stage: "Étape",
        movement: "Mouvement",
        movementSerial: "N° de mouvement",
        caseSpec: "Boîtier",
        dimensions: "Dimensions",
        dial: "Cadran",
        hands: "Aiguilles",
        crystal: "Verre",
        strap: "Bracelet",
        waterResistance: "Étanchéité",
        edition: "Édition",
      },
      metaPh: {
        amount: "Montant",
        currencyEur: "EUR",
        counterparty: "Contrepartie",
        txNumber: "N° de transaction",
        company: "Compagnie",
        policyNumber: "N° de police",
        stage: "Conception, boîtier, mouvement, cadran, finitions…",
        movement: "Calibre et complications",
        movementSerial: "Numéro gravé sur le mouvement",
        caseSpec: "Matière et forme du boîtier",
        dimensions: "Diamètre, épaisseur, entrecorne",
        dial: "Matière et finition du cadran",
        hands: "Type, matière, finition",
        crystal: "Saphir, minéral, traitement",
        strap: "Matière, boucle, fabricant",
        waterResistance: "30 m, 50 m, 100 m…",
        edition: "Pièce unique, série limitée…",
      },
    },
    registerForm: {
      steps: {
        story: "L'histoire",
        watch: "Le garde-temps",
        memories: "Mémoire",
      },
      stepLabel: "Étape {step} sur {total} · {label}",
      storyQuestion: "De quelle histoire hérite-t-on ?",
      storyIntro:
        "Avant la marque et le numéro, il y a la manière dont elle vous est arrivée.",
      watchQuestion: "Le garde-temps confié",
      watchIntro:
        "Le nécessaire pour qu'il soit reconnu, et lui seul, partout dans le registre.",
      memoriesQuestion: "Mémoire et entretien",
      memoriesIntro:
        "Tout ceci est facultatif. Chaque élément ajouté rend la provenance plus difficile à contester.",
      ownerConfirm: "Dossier ouvert au nom de",
      ownerEdit: "Ce n'est pas vous ?",
      brand: "Marque",
      brandPlaceholder: "Ex. Rolex",
      year: "Année",
      yearPlaceholder: "Ex. 2019",
      serial: "Numéro de série",
      serialPlaceholder: "Ex. 1234567",
      model: "Modèle",
      modelPlaceholder: "Ex. Submariner Date",
      reference: "Référence",
      referencePlaceholder: "Ex. 116610LN",
      serialValid: "Format {canonical} valide.",
      serialExpected: "Format {canonical} attendu : {hint} (ex. {example}).",
      serialTaken:
        "Ce numéro de série figure déjà au registre. S'il s'agit de votre montre, ce dossier sera mis à jour. Sinon, l'enregistrement sera refusé : une montre n'appartient qu'à un seul dossier.",
      serialAwaitingClaim:
        "Ce numéro de série a déjà un dossier, qui attend son propriétaire : il ne se reprend pas en l'enregistrant. Si un atelier vous a rendu cette montre, revendiquez-le avec le code de votre reçu ; si vous avez reçu un lien par e-mail, suivez-le ; sinon, écrivez-nous avec une preuve d'achat.",
      serialStolen:
        "Attention : ce numéro de série est signalé comme volé dans le registre. Si vous venez d'acquérir cette montre, contactez-nous avant d'aller plus loin.",
      noSerialToggle: "Cette montre n'a pas de numéro de série visible",
      noSerialModern:
        "Un numéro de série est requis pour les montres postérieures à 1980.",
      noSerialAnchor:
        "Sans numéro, ce dossier s'appuie sur son identifiant Provena et vos photos : privilégiez le fond de boîte et le mouvement à l'étape suivante.",
      noSerialLabel: "Sans numéro de série",
      scan: "Scanner le numéro",
      scanning: "Lecture de la photo…",
      scanDetected: "Numéro(s) détecté(s), appuyez pour remplir :",
      scanNone: "Numéro non détecté. Saisissez-le manuellement.",
      scanError: "La lecture a échoué. Saisissez le numéro manuellement.",
      photoSerialDetected: "Numéro lu sur cette photo, appuyez pour renseigner la série :",
      photoMaybeNotAWatch:
        "Cette photo ne semble pas montrer une montre. Vérifiez le fichier avant de continuer : elle apparaîtra dans la galerie publique.",
      ownerName: "Nom du propriétaire",
      ownerNamePlaceholder: "Prénom et nom",
      email: "Adresse e-mail",
      emailPlaceholder: "vous@exemple.com",
      country: "Pays",
      select: "Sélectionner…",
      countrySearch: "Tapez pour chercher un pays…",
      countryNone: "Aucun pays ne correspond.",
      acquisitionMethod: "Méthode d'acquisition",
      acquisitionOptional: "Facultatif · aucune ne convient ? Passez à l'étape suivante.",
      purchaseProof: "Justificatif d'achat",
      purchaseProofHint: "Facture ou carte de garantie (PDF, JPG ou PNG, max 8 Mo)",
      serviceRecords: "Carnet d'entretien",
      serviceRecordsHint: "Révisions et interventions (PDF, JPG ou PNG, max 8 Mo)",
      boxPapers: "Boîte & papiers",
      boxOrigin: "Boîte d'origine",
      papersCert: "Papiers / certificat",
      moreInfo: "Ce qu'elle a vécu",
      moreInfoPlaceholder:
        "Le poignet qui la portait, le jour où elle est arrivée, la révision d'un horloger dont vous vous souvenez. Écrivez ce qu'un futur propriétaire aimerait savoir.",
      dialPhoto: "Photo du cadran",
      casebackPhoto: "Photo du fond de boîte",
      movementPhoto: "Photo du mouvement",
      photoUploading: "Téléversement en cours…",
      summary: "Récapitulatif",
      privacyNote:
        "Vos informations sont conservées dans le registre Provena conformément à notre politique de confidentialité.",
      requiredError: "Veuillez compléter les champs obligatoires signalés pour continuer.",
      emailError: "Veuillez saisir une adresse e-mail valide.",
      prev: "Précédent",
      next: "Suivant",
      sealing: "Scellement…",
      submit: "Sceller ma montre",
      submitAnonymous: "Créer mon compte et sceller",
      photosLaterTitle: "Les photographies et les documents s'ajoutent au dossier",
      photosLaterText:
        "Un dossier reçoit ses pièces une fois qu'il existe : photographies, facture, carnet d'entretien se déposent juste après, depuis le dossier lui-même. Décrivez d'abord la montre ; nous ne vous demanderons de compte qu'au moment de sceller.",
      acquisition: {
        neuf_boutique: "Neuf · boutique / concessionnaire agréé",
        neuf_createur: "Neuf · directement auprès du créateur",
        occasion_particulier: "Occasion · particulier",
        occasion_plateforme: "Occasion · plateforme / revendeur",
        heritage: "Héritage / transmission familiale",
        autre: "Autre",
      },
    },
    timeline: {
      title: "Historique de la montre",
      chronology: "Chronologie",
      loadingError:
        "L'historique est momentanément indisponible. Veuillez réessayer plus tard.",
      empty: "Aucun événement enregistré pour cette montre pour le moment.",
      emptyMeaning:
        "Un dossier peut exister avant son histoire. Les événements y sont consignés au fil du temps, par le propriétaire et par les professionnels enregistrés qui interviennent sur la pièce.",
      retry: "Réessayer",
      attachments: "{n} pièce(s) jointe(s)",
      footnote:
        "L'historique est constitué d'événements horodatés que leur auteur ne peut plus modifier une fois consignés, ajoutés par le propriétaire et par des professionnels enregistrés. Le niveau de vérification indique l'origine de chaque déclaration. Provena consigne ces informations mais ne certifie pas l'authenticité des montres.",
      actors: {
        proprietaire: "Propriétaire",
        createur: "Créateur",
        horloger: "Horloger",
        marchand: "Marchand",
        expert: "Expert",
        assureur: "Assureur",
        admin: "Provena",
      },
      levels: {
        SELF_REPORTED: "Déclaré par le propriétaire",
        DOCUMENTED: "Déclaré, pièce à l'appui",
        ATELIER_REPORTED: "Signalé par un atelier",
        CREATOR_DECLARED: "Déclaré par le créateur",
        PROFESSIONAL: "Professionnel enregistré",
        VERIFIED: "Consigné par Provena",
        MANUFACTURER_VERIFIED: "Confirmé par la manufacture",
      },
    },
    cookie: {
      aria: "Consentement aux cookies",
      textPre:
        "Provena utilise des cookies strictement nécessaires au fonctionnement du service, ainsi que des cookies de ",
      textStrong: "mesure d'audience",
      textPost:
        " (PostHog, hébergé dans l'Union européenne) pour comprendre comment le site est utilisé. La mesure d'audience n'est activée qu'avec votre consentement. Aucune publicité, aucune revente de vos données.",
      // Version courte, affichée sur les petits écrans. Le texte long occupait
      // 298 px sur un téléphone de 809, soit 37 % de l'écran, et recouvrait
      // l'endroit exact où s'affiche le résultat d'une consultation. Elle dit
      // le même fond : ce qui est mesuré, par qui, où, et que rien ne part
      // sans accord. Le détail reste à un lien de distance.
      textShort:
        "Cookies nécessaires au service, et mesure d'audience (PostHog, Union européenne) activée seulement si vous l'acceptez. Aucune publicité.",
      learnMore: "En savoir plus",
      accept: "Accepter",
      decline: "Refuser",
      close: "Fermer",
    },
    cookiePolicy: {
      metaDescription:
        "Politique de cookies de Provena Registry : cookies strictement nécessaires (session, paiement) et mesure d'audience PostHog soumise à consentement, hébergée dans l'Union européenne. Aucun traceur publicitaire.",
      eyebrow: "Mentions légales",
      title: "Politique de cookies",
      lastUpdated: "Dernière mise à jour : 2026",
      table: {
        title: "2. Cookies que nous utilisons",
        headers: ["Cookie", "Catégorie", "Finalité", "Durée"],
        rows: [
          {
            name: "__Host-session_token",
            type: "Strictement nécessaire",
            purpose:
              "Maintient votre session connectée de façon sécurisée (cookie httpOnly, Secure, SameSite). Indispensable pour accéder à votre compte.",
            duration: "30 jours",
          },
          {
            name: "Cookies PostHog",
            type: "Mesure d'audience (soumis à consentement)",
            purpose:
              "Déposés uniquement après votre consentement, pour comprendre comment le site est utilisé (pages consultées, parcours, taux de conversion). Hébergés dans l'Union européenne.",
            duration: "Selon la configuration PostHog",
          },
          {
            name: "Cookies de paiement",
            type: "Strictement nécessaire (paiement)",
            purpose:
              "Le service de paiement n'est pas actif à ce jour. Lorsqu'il le sera, des cookies pourront être déposés par notre prestataire uniquement lors d'une transaction, afin de la sécuriser et de prévenir la fraude.",
            duration: "Selon la politique du prestataire",
          },
        ],
      },
      sections: [
        {
          title: "1. Qu'est-ce qu'un cookie ?",
          body: [
            "Un cookie est un petit fichier texte déposé sur votre appareil lors de la visite d'un site. Il permet notamment de maintenir votre session ou d'assurer le bon fonctionnement de certaines fonctionnalités.",
          ],
        },
        {
          title: "3. Mesure d'audience",
          body: [
            "Avec votre consentement, Provena utilise PostHog (hébergé dans l'Union européenne) pour mesurer l'audience du site et comprendre comment il est utilisé. Ces cookies ne sont déposés qu'après votre acceptation explicite via le bandeau de consentement, et vous pouvez les refuser sans affecter votre utilisation du service. Provena n'utilise aucun cookie publicitaire ni traceur de profilage marketing, et ne partage pas vos données de navigation à des fins publicitaires.",
            "Sans cookie ni identifiant, le serveur de Provena compte aussi des faits qu'il constate lui-même : montres enregistrées, passeports téléchargés, vols déclarés, et pages publiques de montres volées affichées, avec leur provenance par grande famille (moteur de recherche, réseau social, lien direct). Ni votre adresse IP, ni l'adresse de la page d'où vous venez, ni un numéro de série ne sont transmis. Ces chiffres ne décrivent personne ; ils ne dépendent donc pas du bandeau.",
          ],
        },
        {
          title: "4. Gestion et consentement",
          body: [
            "Les cookies strictement nécessaires ne requièrent pas de consentement préalable car ils sont indispensables au fonctionnement du service. Les cookies de mesure d'audience ne sont déposés qu'avec votre consentement explicite, que vous pouvez retirer à tout moment. Vous pouvez également supprimer ou bloquer les cookies via les paramètres de votre navigateur. Le blocage du cookie de session vous empêchera toutefois d'utiliser les fonctionnalités nécessitant une connexion.",
          ],
        },
        {
          title: "5. Modifications",
          body: [
            "Cette politique de cookies peut être mise à jour. Toute modification substantielle sera signalée sur cette page.",
          ],
        },
      ],
      controlTitle: "Votre choix",
      controlIntro:
        "Vous pouvez revenir sur votre décision à tout moment, dans un sens comme dans l'autre. Le retrait prend effet immédiatement : la mesure d'audience s'arrête et les cookies correspondants cessent d'être utilisés.",
      controlState: {
        granted: "Mesure d'audience acceptée",
        denied: "Mesure d'audience refusée",
        none: "Aucun choix enregistré",
      },
      controlAccept: "Accepter la mesure d'audience",
      controlRevoke: "Retirer mon consentement",
      controlNote:
        "Les cookies strictement nécessaires au fonctionnement du site, comme votre session de connexion, ne dépendent pas de ce choix et restent actifs.",
      footerPre:
        "Pour en savoir plus sur le traitement de vos données, consultez notre",
      footerLink: "politique de confidentialité",
      footerPost: ".",
    },
    privacyPolicy: {
      metaDescription:
        "Politique de confidentialité conforme au RGPD : responsable du traitement, sous-traitants, finalités, durées de conservation et vos droits (accès, suppression, portabilité).",
      eyebrow: "Mentions légales · RGPD",
      title: "Politique de confidentialité",
      lastUpdated: "Dernière mise à jour : 2026",
      processors: {
        title: "4. Destinataires et sous-traitants",
        intro:
          "Nous ne vendons jamais vos données. Elles sont partagées uniquement avec les prestataires (sous-traitants) strictement nécessaires au fonctionnement du service, dans le cadre d'accords de traitement des données :",
        headers: ["Prestataire", "Rôle", "Finalité", "Localisation"],
        rows: [
          {
            name: "MongoDB Atlas",
            role: "Hébergement de la base de données",
            purpose:
              "Stockage sécurisé des comptes, des montres enregistrées, des documents et des signalements.",
            location: "Union européenne / Clauses contractuelles types",
          },
          {
            name: "Cloudflare R2",
            role: "Stockage des fichiers",
            purpose:
              "Conservation des photos de vos montres et des documents que vous versez à leur dossier (factures, certificats, bons d'entretien).",
            location: "États-Unis et réseau mondial de Cloudflare / Clauses contractuelles types",
          },
          {
            name: "PostHog",
            role: "Mesure d'audience",
            purpose:
              "Mesure d'audience du site, déposée uniquement après votre consentement (pages consultées, parcours, taux de conversion). S'y ajoutent, sans cookie ni identifiant, des compteurs tenus par le serveur, qui ne décrivent personne. Aucune publicité, aucune revente de vos données.",
            location: "Union européenne",
          },
          {
            name: "Stripe",
            role: "Traitement des paiements",
            purpose:
              "Le service de paiement n'est pas actif à ce jour. Lorsqu'il sera activé, Stripe traitera les paiements et les abonnements ; Provena ne stocke jamais vos données de carte bancaire.",
            location: "États-Unis / Clauses contractuelles types",
          },
          {
            name: "Google (OAuth)",
            role: "Authentification",
            purpose:
              "Connexion sécurisée via votre compte Google (nom, adresse e-mail, photo de profil).",
            location: "États-Unis / Clauses contractuelles types",
          },
          {
            name: "Google Cloud Vision",
            role: "Lecture du numéro de série",
            purpose:
              "Lecture du numéro gravé sur la photo du fond de boîte, quand vous utilisez le scan, pour pré-remplir le formulaire. La photo n'est ni conservée ni journalisée.",
            location: "Union européenne",
          },
          {
            name: "Resend",
            role: "Envoi d'e-mails transactionnels",
            purpose:
              "Envoi des confirmations d'enregistrement, de signalement de vol, de génération de documents et de transfert de propriété.",
            location: "États-Unis / Clauses contractuelles types",
          },
        ],
      },
      rights: {
        title: "7. Vos droits",
        intro:
          "Conformément au Règlement général sur la protection des données (RGPD), vous disposez des droits suivants :",
        items: [
          {
            title: "Droit d'accès",
            body: "Obtenir la confirmation que des données vous concernant sont traitées et en recevoir une copie.",
          },
          {
            title: "Droit de rectification",
            body: "Demander la correction de données inexactes ou incomplètes.",
          },
          {
            title: "Droit à l'effacement (suppression)",
            body: "Demander la suppression de vos données personnelles, sous réserve des obligations légales de conservation.",
          },
          {
            title: "Droit à la portabilité",
            body: "Recevoir vos données dans un format structuré, couramment utilisé et lisible par machine, et les transmettre à un autre responsable.",
          },
          {
            title: "Droit d'opposition et de limitation",
            body: "Vous opposer au traitement de vos données ou en demander la limitation dans les cas prévus par le RGPD.",
          },
        ],
        outroPre: "Pour exercer ces droits, écrivez-nous à ",
        outroEmail: "contact@provenaregistry.com",
        outroPost:
          ". Vous disposez également du droit d'introduire une réclamation auprès de l'autorité de contrôle compétente (en France, la CNIL : www.cnil.fr).",
      },
      sections: [
        {
          title: "1. Responsable du traitement",
          body: [
            "Le responsable du traitement des données est Nathan De Ridder, éditeur de Provena Registry (« Provena », « nous »).",
            "Pour toute question relative à vos données personnelles ou pour exercer vos droits, vous pouvez nous contacter à l'adresse : contact@provenaregistry.com.",
          ],
        },
        {
          title: "2. Données que nous collectons",
          body: [
            "Données d'identité et de contact : nom, adresse e-mail et photo de profil (via Google), nom du propriétaire déclaré.",
            "Données relatives aux montres : numéro de série, marque, modèle, année, méthode d'acquisition, justificatifs d'achat, carnet d'entretien, photographies et informations de signalement de vol.",
            "Données reçues d'un professionnel : quand vous achetez une montre inscrite au registre chez un professionnel qui utilise Provena Studio, il nous transmet, avec votre accord, votre nom et votre adresse e-mail, uniquement pour vous envoyer le lien qui vous permet de récupérer le dossier de la montre. Si la montre lui avait été confiée en dépôt-vente et n'était pas encore au registre, son dossier s'ouvre à ce moment, à votre nom, en attente de votre récupération ; le nom du déposant ne nous est jamais transmis. Jamais le prix ni d'autres données de la vente.",
            "Données de paiement : le service de paiement n'est pas actif à ce jour. Lorsqu'il le sera, elles seront traitées exclusivement par Stripe et Provena ne conservera aucune donnée de carte bancaire.",
            "Données techniques : journaux de connexion et cookie de session strictement nécessaires au fonctionnement du service. Avec votre consentement, données de mesure d'audience via PostHog (hébergé dans l'Union européenne).",
          ],
        },
        {
          title: "3. Finalités et bases légales (art. 6 RGPD)",
          body: [
            "Fourniture du service (enregistrement, consultation, signalement, transfert) : exécution du contrat.",
            "Gestion des paiements et abonnements, lorsque le service de paiement sera activé : exécution du contrat et obligations légales (comptabilité).",
            "Envoi d'e-mails transactionnels liés à votre compte : exécution du contrat.",
            "Mesure d'audience du site (PostHog) : consentement (art. 6-1-a RGPD).",
            "Compteurs anonymes tenus par le serveur (faits du service, pages publiques de vols affichées) : intérêt légitime de Provena à connaître l'usage du registre (art. 6-1-f RGPD). Aucune donnée personnelle n'y est conservée ni transmise.",
            "Invitation à récupérer le dossier d'une montre achetée chez un professionnel, à partir du nom et de l'adresse e-mail qu'il nous transmet : votre consentement, recueilli par ce professionnel (art. 6-1-a RGPD). Sans suite de votre part, ces données servent uniquement à vous renvoyer le lien à sa demande, au plus une fois par jour.",
            "Sécurité, prévention de la fraude et amélioration de la fiabilité du registre : intérêt légitime.",
          ],
        },
        {
          title: "5. Transferts hors Union européenne",
          body: [
            "Certains de nos sous-traitants sont situés en dehors de l'Union européenne (notamment aux États-Unis). Ces transferts sont encadrés par des garanties appropriées, en particulier les Clauses Contractuelles Types de la Commission européenne.",
          ],
        },
        {
          title: "6. Durée de conservation",
          body: [
            "Vos données de compte et les informations relatives à vos montres sont conservées tant que votre compte est actif et aussi longtemps que nécessaire à la finalité du registre.",
            "Les données de facturation sont conservées conformément aux obligations légales applicables. Sur demande de suppression, vos données sont effacées sous réserve de ces obligations.",
          ],
        },
        {
          title: "8. Cookies",
          body: [
            "Provena utilise des cookies strictement nécessaires au fonctionnement du service, ainsi que des cookies de mesure d'audience (PostHog, hébergé dans l'Union européenne) déposés uniquement avec votre consentement. Pour en savoir plus, consultez notre politique de cookies.",
          ],
        },
        {
          title: "9. Sécurité",
          body: [
            "Nous mettons en œuvre des mesures techniques et organisationnelles raisonnables (chiffrement des échanges, contrôle d'accès, cookie de session httpOnly) afin de préserver la confidentialité et l'intégrité de vos données.",
          ],
        },
        {
          title: "10. Modifications",
          body: [
            "La présente politique peut être mise à jour. Toute modification substantielle sera signalée sur cette page. La version applicable est celle publiée à la date de votre consultation.",
          ],
        },
      ],
      footerPre:
        "Provena est une plateforme de documentation et de traçabilité et n'authentifie ni ne certifie les montres. Ce document est fourni à titre informatif. Voir aussi nos",
      footerTermsLink: "conditions d'utilisation",
      footerMid: "et notre",
      footerCookiesLink: "politique de cookies",
      footerPost: ".",
    },
    termsPage: {
      metaDescription:
        "Conditions générales d'utilisation du registre horloger Provena Registry.",
      eyebrow: "Mentions légales",
      title: "Conditions d'utilisation",
      lastUpdated: "Dernière mise à jour : 2026",
      editor: {
        label: "Éditeur du site",
        pre: "Provena Registry est édité par Nathan De Ridder. Pour toute question relative au service ou à vos données : ",
        email: "contact@provenaregistry.com",
        post: ".",
      },
      sections: [
        {
          title: "1. Objet",
          body: [
            "Les présentes conditions d'utilisation régissent l'accès et l'usage du registre Provena Registry (« Provena », « le service »).",
            "En utilisant le service, vous acceptez sans réserve les présentes conditions.",
          ],
        },
        {
          title: "2. Description du service",
          body: [
            "Provena propose un registre numérique permettant d'enregistrer la provenance et l'historique de propriété d'une montre, de consulter son statut par numéro de série et de signaler un vol.",
            "Provena est une plateforme de documentation et de traçabilité. Provena n'authentifie pas, ne certifie pas et ne garantit pas l'authenticité des montres. Les informations reposent sur les déclarations des propriétaires. Provena ne saurait être tenu responsable en cas d'informations inexactes ou frauduleuses.",
            "Le service constitue un outil d'aide à la transparence du marché horloger et ne se substitue pas à une expertise d'authentification, ni à une démarche auprès des autorités.",
          ],
        },
        {
          title: "3. Exactitude des informations",
          body: [
            "Vous vous engagez à fournir des informations exactes, complètes et à jour lors de l'enregistrement d'une montre ou de la déclaration d'un vol.",
            "Toute déclaration frauduleuse ou abusive peut entraîner la suppression des données concernées et l'interdiction d'accès au service.",
          ],
        },
        {
          title: "4. Signalement de vol",
          body: [
            "Un signalement de vol effectué via Provena n'a pas valeur de dépôt de plainte. Il vous appartient de signaler le vol aux autorités compétentes.",
            "Provena ne peut être tenue responsable des suites données à un signalement par des tiers.",
          ],
        },
        {
          title: "5. Responsabilité",
          body: [
            "Le service est fourni « en l'état ». Provena met en œuvre des moyens raisonnables pour assurer la fiabilité du registre mais ne garantit pas l'exhaustivité ou l'absence d'erreur des informations.",
            "Provena ne saurait être tenue responsable des décisions d'achat ou de vente prises sur la base des informations consultées.",
          ],
        },
        {
          title: "6. Propriété intellectuelle",
          body: [
            "La marque Provena Registry, son logo et l'ensemble des éléments du site sont protégés. Toute reproduction non autorisée est interdite.",
          ],
        },
        {
          title: "7. Modification des conditions",
          body: [
            "Provena se réserve le droit de modifier les présentes conditions à tout moment. La version applicable est celle publiée sur cette page.",
          ],
        },
      ],
      disclaimer:
        "Ce document est fourni à titre informatif et ne constitue pas un avis juridique. Nous vous recommandons de consulter un professionnel du droit pour toute question spécifique.",
    },
    plans: {
      tiers: {
        free: "Gratuit",
        collector: "Collectionneur",
        professional: "Professionnel",
        enterprise: "Maisons & institutions",
      },
      features: {
        free: [
          "Création de compte",
          "Enregistrement de montres illimité",
          "Passeport numérique de chaque montre",
          "Statut consultable publiquement",
          "Déclaration de vol",
          "Gestion de collection de base",
        ],
        collector: [
          "Tout le plan Gratuit",
          "Rapports de provenance premium (5 inclus / mois)",
          "Alertes vol",
          "Support prioritaire",
        ],
        professional: [
          "Tout le plan Collectionneur",
          "Rapports de provenance illimités",
          "Outils de consultation en lot",
          "Profil négociant et badge professionnel",
          "Prise en charge client",
          "Rapports exportables",
          "Accès équipe",
          "API (accès limité)",
          "Support prioritaire",
        ],
        enterprise: [
          "Tarification sur mesure",
          "Compagnies d'assurance & maisons de vente",
          "Grands négociants",
          "Accès API illimité",
          "Registre en marque blanche",
          "Gestionnaire de compte dédié",
        ],
      },
    },
    editWatch: {
      title: "Modifier la montre",
      provenaIdKept: "Provena ID · {id} (conservé)",
      submit: "Enregistrer les modifications",
      success:
        "{watch} a été mise à jour. La modification a été consignée dans l'historique.",
      genericError: "Une erreur est survenue.",
      attachFile: "Fichier joint",
    },
    documents: {
      title: "Pièces justificatives",
      item: "Document",
      photosTitle: "Photographies",
      photoItem: "Photographie",
    },
  },

  en: {
    switcher: { aria: "Choose language" },
    common: {
      spamHint: "If you don't see it, check your spam/junk folder.",
      registryUnavailable: "The registry could not respond. Nothing can be concluded from this.",
      retry: "Try again",
      close: "Close",
    },
    legal: {
      disclaimer:
        "Provena is a documentation and traceability platform. Provena does not authenticate, certify or guarantee the authenticity of watches. Information is based on the declarations of owners and registered professionals. Provena cannot be held liable for inaccurate or fraudulent information.",
    },
    reportTheft: {
      locationHint: "City and country only, please avoid a precise address.",
      metaTitle: "Report a stolen watch",
      metaDescription:
        "Report your luxury watch as stolen to make it identifiable on the secondary market and hinder any fraudulent resale.",
      loginDescription:
        "Sign in to report your watch as stolen and make it identifiable on the secondary market.",
      submittedTitle: "Report recorded",
      submittedBodyPre: "The watch with serial number ",
      submittedBodyPost:
        " is now flagged as stolen in the Provena registry.",
      submittedHint:
        "Any buyer looking up this serial number will be alerted to its status.",
      backHome: "Back to home",
      another: "Report another watch",
      eyebrow: "Stolen watches registry",
      title: "Report a stolen watch",
      intro:
        "Report your watch as stolen to make it identifiable on the secondary market and hinder any fraudulent resale.",
      fSerial: "Serial number",
      fSerialPh: "E.g. 4113-02-0997",
      fSerialHint: "Leave empty for a watch with no serial and provide the Provena ID instead.",
      fProvena: "Provena ID",
      fProvenaPh: "E.g. PRV-000123",
      fProvenaHint: "For a vintage watch with no serial number, registered to your account.",
      needIdentifier: "Provide a serial number or a Provena ID.",
      fDate: "Date of theft",
      fBrand: "Brand",
      fBrandPh: "E.g. Patek Philippe",
      fModel: "Model",
      fModelPh: "E.g. Nautilus 5711/1A",
      fOwnerName: "Owner name",
      fOwnerNamePh: "First and last name",
      fEmail: "Email address",
      fEmailPh: "you@example.com",
      fLocation: "Place of theft",
      fLocationPh: "City, country",
      fPolice: "Police report reference",
      fPolicePh: "Report number",
      fCircumstances: "Circumstances of the theft",
      fCircumstancesPh: "Describe the circumstances and any useful detail.",
      disclaimer:
        "A theft report is not a police complaint. Remember to contact the relevant authorities.",
      submitting: "Sending…",
      submit: "Report the theft",
      submitAnonymous: "Create my account and report",
      sworn:
        "I declare on my honour that this watch was stolen from me and that a police report has been filed, or is about to be. A false declaration is my responsibility.",
      swornRequired:
        "Please confirm your declaration on your honour to continue.",
      pendingReference:
        "Your report is recorded. Add your police reference within seven days, otherwise the report will lapse.",
      submitError:
        "Something went wrong. Check the information and try again.",
    },
    magicLinkPage: {
      metaTitle: "Sign-in link",
      metaDescription: "Confirm signing in to your Provena space.",
      title: "Sign in",
      signInAs: "This link opens the Provena space of:",
      confirm: "Sign in",
      notYou: "Not your address? Close this page: nobody has been signed in.",
    },
    loginPage: {
      metaTitle: "Sign in",
      metaDescription:
        "Sign in to your Provena space: collection, provenance reports, passports and ownership transfers.",
      gateDescription:
        "Sign in with Google to access your Provena space: collection, reports, passports and ownership transfers.",
      errors: {
        generic: "Sign-in failed. Please try again.",
        oauth: "The Google sign-in was cancelled or did not complete. Try again.",
        state:
          "Your sign-in session has expired or is invalid. Please try again.",
        config:
          "Google sign-in is not configured correctly. Contact support.",
        token: "The secure exchange with Google failed. Try again in a moment.",
        userinfo: "Could not retrieve your Google profile. Try again.",
        network:
          "The authentication service is temporarily unavailable. Try again.",
        email:
          "Your Google address is not verified. Check your Google account, then try again.",
        magic_invalid:
          "This sign-in link is invalid. Request a new one below.",
        magic_expired:
          "This sign-in link has expired. Request a new one below.",
        magic_used:
          "This sign-in link has already been used. Request a new one below.",
      },
    },
    header: {
      nav: {
        problem: "The problem",
        stolen: "Stolen watches",
        verify: "Look up",
        gallery: "Gallery",
        passport: "The passport",
        howItWorks: "How it works",
      },
      register: "Register my watch",
      professionals: "Professionals",
      home: "Home",
      account: "My account",
      logout: "Log out",
      login: "Sign in",
      proArea: "Pro area",
      becomePro: "Professionals",
      accountMenu: "Account menu",
      admin: "Admin",
    },
    footer: {
      groups: {
        registry: "Registry",
        understand: "Understand",
        account: "Account",
        legal: "Legal",
      },
      about: "About",
      pricing: "Pricing",
      reportTheft: "Report a theft",
      stolenGuide: "What to do after a theft?",
      faq: "FAQ",
      yourData: "Your data",
      privacy: "Privacy policy",
      cookies: "Cookies",
      terms: "Terms of use",
      account: "My account",
      register: "Register my watch",
      home: "Home",
      rights:
        "Provena Registry · The trusted watch registry. All rights reserved.",
      signature: "Every watch has a story. We keep it.",
      instagram: "Provena on Instagram (new tab)",
      studio: "Provena Studio, for watch workshops",
    },
    hero: {
      eyebrow: "Watch provenance registry",
      titlePre: "Your watch's file,",
      titleHighlight: "verifiable by whoever buys it.",
      subtitle:
        "Successive owners, servicing, documents, theft reports: Provena records what a watch has lived through and makes it consultable. Without ever claiming to authenticate it.",
      verify: "Look up a watch",
      register: "Register my watch",
      trust: [
        "Independent registry",
        "Confidential data",
        "Free look-up",
      ],
      scroll: "Discover",
    },
    registry: {
      eyebrow: "The registry",
      title: "What Provena does with your watch",
      steps: [
        {
          title: "You file what you have",
          description:
            "Invoice, warranty documents, service records, photographs. None of it is required. Your documents stay private and your own details are never published; only a photo of the watch may appear in the public gallery, with nothing that identifies you.",
        },
        {
          title: "The watch receives its identifier",
          description:
            "A permanent Provena identifier, attached to the piece rather than to you. It outlives sales and follows the watch through its successive owners.",
        },
        {
          title: "A third party can check",
          description:
            "A buyer, an insurer or a dealer looks the watch up and sees what is on file, since when, and whether it has been reported stolen. No account needed, free of charge.",
        },
      ],
      dossierLabel: "Pieces on file",
      dossier: [
        "Ownership history",
        "Proof of purchase",
        "Service records",
        "Original documents and warranties",
        "Digital provenance file",
      ],
      mission:
        "Our mission: make every watch easier to look up, safer to own and more valuable to pass on.",
    },
    counter: {
      eyebrow: "The living registry",
      label: "watches on the registry",
      foundersEyebrow: "Registry open",
      foundersTitle: "Founders edition",
      foundersText:
        "The registry has just opened. The first watches registered carry the lowest numbers forever. Yours is waiting.",
    },
    trust: {
      eyebrow: "Trusted by",
    },
    physicalPassport: {
      eyebrow: "The Metal Passport",
      title: "The tactile extension of steel and memory",
      body:
        "A timepiece is defined by its weight, its cold steel, and its mechanical friction. Its registry should feel no different. Every registered timepiece can be paired with our Metal Passport: a heavy, precision-machined metal card encased in vegetable-tanned leather that will take on its own patina over decades. Embedded with an invisible secure NFC link, it anchors your watch's eternal legacy in the palm of your hand.",
      imageAlt:
        "Brushed Metal Passport card in its vegetable-tanned leather sleeve",
      cta: "Request your Metal Passport",
      registerPrompt: "Would you like to anchor this story in a physical legacy?",
    },
    nfc: {
      seoTitle: "Opening the registry",
      reading: "Reading the ledger…",
      opening: "Opening the record",
      notFound: "This passport does not match any dossier in the registry.",
    },
    login: {
      reassurance: [
        "Free, no credit card",
        "Your data stays private",
        "2 minutes to register your first watch",
      ],
      google: "Continue with Google",
      or: "or",
      emailLabel: "Email address",
      emailPlaceholder: "you@example.com",
      magicSubmit: "Send me a sign-in link",
      sameAccount: "Both methods open the same account, tied to your address. If it is a Google address, you can use the button above and find your watches again, without waiting for an email.",
      magicError:
        "Invalid email address, or the service is briefly unavailable. Please try again.",
      magicSentTitle: "Check your inbox",
      // Split around the address, which is styled inline.
      magicSentPre: "If an account matches ",
      magicSentPost:
        ", a sign-in link has just been sent. It is valid for 15 minutes.",
      magicOtherAddress: "Use another address",
    },
    problem: {
      eyebrow: "The situation",
      title: "The pre-owned market still runs largely on trust.",
      constat: "A watch changes hands without the buyer being able to easily verify its full history. In 2025, more than 10,000 luxury watches were reported stolen or lost, roughly one every hour.",
      needLabel: "The need",
      need: "The market needs a file that can be consulted before purchase, a register of stolen watches, and a structured history that makes resale clearer and fraud harder.",
      answerLabel: "Provena",
      answer: "Provena does not claim to fix the market. It gives every watch a file that can be consulted before purchase, and helps make a stolen piece harder to resell.",
      cta: "Register my watch",
      sourcePre: "Source:",
      sourceName: "The Watch Register",
      sourceNote: "international register of stolen watches",
    },
    stolen: {
      eyebrow: "Stolen watch registry",
      title: "Report and track stolen watches",
      features: [
        "Report a stolen watch in minutes.",
        "Keep your proof of ownership.",
        "Create a searchable theft report.",
        "Make fraudulent resale harder.",
        "Help future buyers spot a suspicious watch.",
      ],
      cta: "Report a stolen watch",
      guidePre: "Has your watch just been stolen?",
      guideLink: "Here's what to do first.",
      imageAlt: "Precision watch movement",
    },
    editorial: {
      title: "Submit for an episode",
      intro: "Provena devotes episodes to pieces that carry a story. If this one does, tell it: the episode is made by the story, not the photograph.",
      pitchLabel: "This piece's story",
      pitchPlaceholder: "What you know of it: where it comes from, what it lived through, what makes it particular.",
      minChars: "{n} more characters.",
      privacy: "Neither the serial number, nor the owner, nor their city will be published. A piece reported stolen leaves the selection automatically.",
      consent: "I allow Provena to feature this watch in its publications.",
      submit: "Submit this piece",
      done: "{watch} has been submitted for an episode.",
      withdraw: "Withdraw my submission",
      withdrawn: "Submission withdrawn.",
      alreadySubmitted: "This piece is already submitted. You may withdraw it at any time.",
      error: "Submission failed. Please try again.",
      action: "Submit an episode",
    },
    signatoryBadge: {
      founder: "Founder",
      solo: "Signatory {cohort}",
      contributor: "{name} · Signatory {cohort}",
      title: "Signatory of the Provena charter",
      enrichedBy: "File enriched by",
    },
    dataProtection: {
      metaTitle: "Your data, and what becomes of it",
      metaDescription:
        "What a third party sees of a registered watch, what they never see, and how to retrieve or erase your data in one click.",
      eyebrow: "Entrusting your stock, or your collection",
      title: "What becomes of your data",
      lead: "The privacy policy answers the law. This page answers the questions people actually ask before entrusting a stock or photographing their pieces. Every answer describes how the registry really works, not an intention.",

      q1Title: "Who sees what, exactly?",
      q1: "A file looked up by a third party, a buyer or an insurer, shows the piece. Never you. Here is the complete inventory, with no exception:",
      shownTitle: "What a third party sees",
      shown: [
        "The maker, the model, the year",
        "Whether photographs exist, without showing them",
        "Whether photographs or supporting documents are on file",
        "Whether the piece is reported stolen",
        "The number of professional entries",
        "The date it joined the registry",
      ],
      hiddenTitle: "What they never see",
      hidden: [
        "Your name and email address",
        "Your photographs and documents",
        "Your invoices and supporting papers",
        "Your town and contact details",
        "The purchase or sale price",
        "The identity of previous owners",
      ],

      q2Title: "What about my photographs and invoices?",
      q2: "They are accessible to you alone. A file is never served publicly: every access checks that the requesting account owns it, and the sharing links the site generates expire after a few minutes. An intercepted link is therefore useless past that point, and it opens that one file and nothing else.",

      q3Title: "Do my clients appear anywhere?",
      q3: "No. When you register a watch for a client, their name and address appear on no public page. The file that can be looked up does not say who owns the piece, only that it has an owner. Nor can your competitors list your stock: nothing publicly ties registered watches to whoever registered them, unless you choose to appear as a contributing signatory.",

      q4Title: "Can I get my data back?",
      q4: "Yes, in one click, from your dashboard. You receive a file holding everything the registry knows about you: your watches, their events, their documents, your theft reports. No request to file, no waiting. It is your guarantee of never being locked in, and for a young registry it is the only one that counts.",

      q5Title: "And if I leave?",
      q5: "Deleting your account erases your data, not merely your profile: the watches you still own go with their documents, photographs, events and reports. Pieces you have already transferred stay in the registry, since they now belong to someone else, but your identity is stripped from their history.",

      limitsTitle: "What this page does not claim",
      limit1: "A small team can access files for support and moderation, in particular to handle a theft report. Those accesses are logged. Every platform works this way; the ones claiming otherwise are either mistaken or misleading you.",
      limit2: "Your data is hosted with named processors, listed in the privacy policy, with the database in the European Union. Provena is a young company: that is precisely why the export exists, and why it is immediate.",

      cta: "Register my first watch",
      policyLink: "Read the privacy policy",
    },
    signatoryWelcome: {
      eyebrow: "Your status has changed",
      title: "You are a signatory of the {cohort} cohort",
      titleNoCohort: "You are a signatory of the registry",
      access: "Your account now has full access: unlimited passports and provenance reports, for every watch you own. No subscription needed.",
      inReturnLabel: "What you commit to",
      inReturnDealer: "Create a passport for at least ten pieces, hand the file to the buyer at the point of sale, and thirty minutes of feedback per quarter.",
      inReturnMaker: "Record how at least one piece was made, stage by stage, attach your workshop photographs, and thirty minutes of feedback per quarter.",
      inReturnCollector: "Document your collection, at least three pieces, and thirty minutes of feedback per quarter.",
      cta: "Read the charter again",
      dismiss: "Dismiss this notice",
    },
    signatory: {
      metaTitle: "Provena signatories",
      metaDescription:
        "The makers, professionals and collectors who signed the Provena charter. A dated cohort, closing on 31 December.",
      eyebrow: "By invitation",
      title: "The signatories",
      cohort: "Signatories 2026",
      lead: "Provena records dated facts. This is one of them: these makers, professionals and collectors signed the charter in 2026, when the registry barely existed yet.",
      leadTwo: "The 2026 cohort closes on 31 December. Those who sign afterwards will hold a different status, never this one.",

      whoTitle: "Three profiles",
      makerTitle: "Maker",
      makerText: "Records how the pieces leaving their workshop were made, stage by stage, and hands the file to their first owner. Their entries carry the maker's degree in each piece's history.",
      dealerTitle: "Dealer",
      dealerText: "Creates passports for the watches they sell, manages their stock, hands the file to the buyer. Their entries are recorded at professional level in each piece's history.",
      collectorTitle: "Collector",
      collectorText: "Documents their collection, tests the registry against real pieces and reports what is missing.",

      getTitle: "What the status gives",
      get1: "Full access to Provena, free for the whole opening period.",
      get2: "New features before they open publicly.",
      get3: "To be consulted before significant product decisions. Consulted, not followed: we do not promise to comply.",
      get4: "The option to submit a watch and its story for a Provena editorial episode. Open to dealers and makers: a collector would be exposing themselves.",
      get5: "To be listed as a professional using Provena, should you wish.",
      get6: "A dated signature, which is never withdrawn and never reopened.",

      giveTitle: "What each commits to",
      giveMakerTitle: "Maker",
      giveMaker1: "Record how at least one piece was made, stage by stage.",
      giveMaker2: "Attach the workshop photographs to it.",
      giveMaker3: "Thirty minutes of feedback per quarter.",
      giveDealerTitle: "Dealer",
      giveDealer1: "Create a passport for at least ten pieces.",
      giveDealer2: "Hand the file to the buyer at the point of sale.",
      giveDealer3: "Thirty minutes of feedback per quarter.",
      giveCollectorTitle: "Collector",
      giveCollector1: "Document their collection, at least three pieces.",
      giveCollector2: "Thirty minutes of feedback per quarter.",
      giveNote: "It is little, and it is not the same effort whether one makes, keeps a shop or collects. But it is what separates a circle from a mailing list: a status that asks nothing has nothing to tell.",

      neutralTitle: "What Provena does not do",
      dataLink: "What becomes of your data",
      neutral: "Provena does not certify its signatories, guarantees neither their pieces nor their transactions, and takes no commission on their sales. A signature records a commitment; it is neither a recommendation nor a warranty.",

      ctaTitle: "Joining",
      ctaText: "One signs by invitation only. If you believe you belong there, write to us. Tell us who you are and what you keep.",
      ctaButton: "Write to us",
    },
    explore: {
      eyebrow: "The registry in practice",
      passportTitle: "The passport",
      passportText: "The document every watch recorded in the registry receives.",
      verifyTitle: "Look up a watch",
      verifyText: "Check a piece's status before you buy it.",
      stolenTitle: "Stolen watches",
      stolenText: "The public registry of pieces reported stolen by their owners.",
    },
    passportPage: {
      metaTitle: "A watch's provenance passport",
      metaDescription:
        "The document Provena builds for every watch: identity, chain of ownership, documents and an integrity seal anyone can verify.",
      sealTitle: "What makes it verifiable",
      seal1Title: "An integrity seal",
      seal1:
        "On registration, the file receives a digital fingerprint and a cryptographic signature. Any later change becomes visible.",
      seal2Title: "A look-up QR code",
      seal2:
        "The passport carries a code leading to a public page where anyone can check the seal, without seeing your personal data.",
      seal3Title: "A document you can carry",
      seal3:
        "The passport downloads as a PDF, printable and handed on with the watch the day it changes hands.",
      limitTitle: "What the passport is not",
      limit:
        "It is not a certificate of authenticity. Provena does not appraise watches and takes no position on their origin: the passport attests to the traceability of declared events and documents, nothing more.",
      demoCta: "See a full passport",
      registerCta: "Register my watch",
    },
    audience: {
      eyebrow: "Who it is for",
      title: "Three ways into the registry",
      items: [
        {
          role: "You are buying",
          body: "Look a watch up before you pay: what is on file, since when, and whether it has been reported stolen. No account, free of charge, in seconds.",
          cta: "Look up a watch",
        },
        {
          role: "You are an owner",
          body: "Register your watch and gather its supporting documents. On the day of a theft, an estate or a resale, its history exists somewhere other than a drawer.",
          cta: "Register my watch",
        },
        {
          role: "You are selling",
          body: "A file the buyer can check replaces taking your word for it. Dealers open the signatory programme, with full access and a badge on the pieces they register.",
          cta: "Discover the programme",
        },
      ],
      // RDEC-023: a workshop is pointed to Studio, its working tool.
      studio: {
        question: "Are you a watch workshop?",
        link: "Provena Studio, the working tool for watch workshops",
      },
    },
    passportPreview: {
      eyebrow: "The passport, plainly",
      title: "What the passport records",
      subtitle:
        "It documents an object's custody and continuity: its identity, the hands that held it, its assessed condition. Nothing else.",
      demoCta: "See a complete file",
      screens: {
        identity: "Identity",
        custody: "Chain of custody",
        condition: "Condition report",
        continuity: "Continuity",
      },
      identity: {
        name: "Piece",
        maker: "Maker",
        year: "Year",
        material: "Material",
        reference: "Reference",
        noIssuer:
          "No issuing brand. The passport is held by the registry, not by a manufacturer.",
      },
      condition: {
        assessedOn: "Assessed on",
        tags: {
          case: "Case",
          movement: "Movement",
          bracelet: "Bracelet",
        },
        states: {
          intact: "Intact",
          serviced: "Serviced",
          worn: "Signs of wear",
        },
        note: "Assessed by an independent professional, timestamped and signed.",
      },
      continuity: {
        owners: "{count} registered owners",
        anonymous:
          "No identity shown: only roles and dates are recorded.",
        closing: "The record belongs to the object, not to the brand.",
      },
      nav: { goTo: "Show the {screen} screen" },
      demo: {
        name: "Automatic chronograph",
        maker: "Independent manufacture",
        material: "Stainless steel",
      },
    },
    // Fictional watch on the passport card (pricing, final CTA): no real
    // maison, no person's name.
    demoPassport: {
      maker: "Independent manufacture",
      model: "Automatic chronograph",
      owner: "Private collection",
    },
    verifyWatch: {
      metaTitle: "Check a watch before you buy it",
      metaDescription:
        "Look up a watch's status in the Provena registry for free: registration, documented provenance, theft report.",
      showsTitle: "What this look-up tells you",
      shows1: "Whether the watch is recorded in the Provena registry.",
      shows2: "Whether it has been reported stolen by its owner.",
      shows3: "Whether its file contains provenance documents.",
      limitsTitle: "What it does not tell you",
      limits1:
        "Provena does not authenticate watches and does not certify their origin. The registry keeps declarations and documents; it does not appraise them.",
      limits2:
        "A watch absent from the registry is neither suspicious nor guaranteed: it simply was never recorded there.",
      limits3:
        "If you have doubts about a piece, consult a watchmaker or an expert.",
      stolenCta: "Browse the stolen watch registry",
      registerCta: "Register my watch",
    },
    verification: {
      eyebrow: "Registry look-up",
      title: "Check before you buy",
      subtitle:
        "Enter a watch's serial number or Provena ID to look up its status in the Provena registry.",
      placeholder: "Serial number or Provena ID",
      submit: "Look up",
      orScan: "Or, watch in hand, photograph the caseback:",
      ref: "Serial no.",
      provenaIdLabel: "Provena ID",
      extract: "Register extract",
      viewedOn: "Extract viewed on {date}",
      openDossier: "Open the dossier",
      statusRegistered: "On registry",
      statusStolen: "Reported stolen",
      statusAbsent: "Not on registry",
      fieldRegistered: "Registration",
      fieldOwnership: "Ownership",
      fieldProvenance: "On file",
      fieldStolen: "Theft status",
      notFoundSerial: "No watch is registered under serial number {q}.",
      notFoundProvenaId: "No dossier for Provena ID {q}.",
      notFoundOwn:
        "That is true of most watches. If this one is yours, you can open its record: you alone can state that it belongs to you.",
      registerCta: "Register this watch",
      registeredYes: "Registered in the registry",
      registeredNo: "Not registered",
      ownershipYes: "Proof of ownership available",
      ownershipNo: "No proof of ownership",
      provenanceYes: "Photographs or supporting documents on file",
      provenanceNo: "No photographs or supporting documents",
      stolenYes: "Reported as stolen",
      stolenNo: "No theft report",
    },
    about: {
      metaTitle: "The third floor, how Provena began",
      metaDescription:
        "Geneva, 2022. A library of 8,000 volumes, a drawer, and two engraved letters. The story behind the Provena registry.",
      eyebrow: "The origin",
      title: "The third floor",
      place: "Patek Philippe Museum · Geneva · 2022",
      s1: "I remember none of the watches.",
      s2: "I remember the third floor.",
      s2b: "More than 8,000 volumes and manuscripts, some dating back to the 16th century. An entire building to display objects, and an entire floor to remember what they are.",
      s3: "What stayed with me were not the watches. It was the questions behind each of them. Why this complication. Why this design. Why these materials.",
      s4: "If those questions can still be answered today, it is only because someone took the time to write them down.",
      drawerTitle: "The drawer",
      s5: "I came home. I opened my grandmother's drawer.",
      s6: "Her watches lived through two world wars, the quartz crisis and sixty years of ordinary days.",
      s7: "And I cannot tell you a single thing about any of them.",
      s8: "One of them is a gold pocket watch. Inside, two letters are engraved.",
      engraving: "YM",
      s9: "Two initials. An entire life reduced to two letters.",
      s10: "I do not know who YM was. I do not know why the watch was engraved. I only know that it reached me.",
      thesisPre: "What separates these watches from the museum's is neither value nor rarity.",
      thesisA: "The museum had a library.",
      thesisB: "My grandmother had no one.",
      youTitle: "You have one too",
      s11: "A drawer. A box. A watch that stopped long ago. Something you will never sell.",
      s12: "You know it matters. You just don't know why.",
      s13: "Objects outlive the stories they carry.",
      whyTitle: "That is why Provena exists",
      s14: "A registry where a watch keeps its history as it changes hands: successive owners, servicing, documents, and a report if it is stolen.",
      s15: "Provena certifies nothing and authenticates nothing. The registry keeps dated events and documents, and makes them verifiable by anyone. Trust does not come from a label: it comes from the record.",
      closing: "You don't see a history. You write it.",
      ctaRegister: "Register my watch",
      ctaHow: "How it works",
    },
    founder: {
      eyebrow: "A word from the founder",
      title: "An obsession with the history of objects",
      p1: "My fascination with provenance goes beyond watchmaking. A violin, a book, a piece of furniture: every object that travels through time has lived far more than any human. I traced my own genealogy to know mine.",
      p2: "Provena was born from that obsession, one day in 2022, on the third floor of the Patek Philippe Museum.",
      signature: "Nathan De Ridder",
      role: "Founder · Provena",
      readStory: "Read the full story",
    },
    finalCta: {
      title: "Protect your watch's story",
      subtitle:
        "Join the collectors, dealers and enthusiasts building a more transparent market.",
      register: "Register my watch",
      verify: "Look up a watch",
      price:
        "Registering your watches and looking up the registry are free, and will stay free.",
      priceLink: "See pricing",
    },
    gallery: {
      eyebrow: "The registry in pictures",
      title: "The Provena gallery",
      subtitle:
        "An anonymous glimpse of the timepieces listed in the registry. No personal data, no full serial number.",
      all: "All brands",
      empty: "No watch to display yet.",
      anonymized:
        "Anonymised gallery: owners and serial numbers kept confidential.",
      view: "View dossier",
      enlarge: "Enlarge the photo",
      closePhoto: "Close the enlarged photo",
      metaTitle: "Provena gallery · registered watches",
      metaDescription:
        "Discover the timepieces listed in the Provena registry. Anonymised gallery: brand, model and year, no personal data.",
    },
    howItWorks: {
      eyebrow: "The Provena journey",
      title: "How it works",
      metaDescription:
        "From registration to public verification: discover the Provena journey to document your luxury watch for the long term.",
      intro:
        "From registration to public verification, four steps to document your watch for the long term.",
      cta: "Register my watch",
      steps: [
        {
          title: "Register your watch",
          description:
            "Build your timepiece's dossier: brand, model, serial number, supporting documents and photographs.",
        },
        {
          title: "Verify your identity",
          description:
            "Sign in via secure authentication. You become the registered owner of the dossier.",
        },
        {
          title: "Receive the passport",
          description:
            "A signed digital passport is generated, with a SHA-256 fingerprint and a verification QR code.",
        },
        {
          title: "Public verification",
          description:
            "Anyone can scan the QR code and verify the dossier's integrity, with no account and no personal data.",
        },
      ],
    },
    passport: {
      title: "Provena digital passport",
      eyebrow: "Provena registry extract",
      presentation: "Presentation mode",
      exit: "Exit",
      owner: "Registered owner",
      serial: "Serial number",
      year: "Year",
      acquisition: "Acquisition",
      boxPapers: "Box & papers",
      registeredOn: "Registered on",
      verify: "Scan to verify the dossier's seal",
      fingerprint: "Cryptographic fingerprint of the dossier",
      stolen: "This watch is reported as stolen.",
      privateTitle: "Confidential passport",
      privateText:
        "Only the registered owner can view this passport. You can still publicly verify the dossier's integrity.",
      verifyPublic: "Public verification",
      loginCta: "Sign in",
      notFound: "Passport not found.",
      edition: "Registered piece · Edition",
      sealTitle: "Digital seal",
      sealExplain: "This document is protected by a cryptographic signature. Any modification to the dossier invalidates this signature.",
      authenticity: "Document sealed and cryptographically verified",
      verifyStamp: "Verify this passport",
      qrAlt: "Provena verification QR",
      print: "Print",
      downloadPdf: "Download PDF",
      heroEyebrow: "Digital passport",
      cardHolder: "Holder",
      identityTitle: "Watch identity",
      photosTitle: "Photographs",
    },
    pricing: {
      eyebrow: "Plans",
      metaDescription:
        "Discover Provena's plans: free registration, passport and look-up, provenance files and professional tools.",
      title: "Choose your plan",
      intro:
        "Registering your watches, their passport and looking up the registry remain free forever. Higher tiers (provenance reports, professional tools) will be available soon.",
      checkoutError:
        "The payment could not be initiated. Please try again in a moment.",
      passportEyebrow: "Included with every registered watch",
      passportTitle: "The digital passport, an object of its own",
      passportText:
        "Every registered watch receives its interactive passport: a sheen that follows your touch, its Provena ID, a built-in verification QR. An object you present, not just a document.",
      passportHint: "Hover the card: the light follows your touch.",
      passportPrivacy:
        "Fictional example. Outside this demo, a passport's personal information is only visible to its owner.",
      passportCta: "View a full passport",
      comingSoon: "Coming soon",
      joinWaitlist: "Join the waitlist",
      waitlistTitle: "Waitlist",
      waitlistIntro:
        "Subscriptions are coming soon. Leave your email and we'll notify you first at launch.",
      waitlistThanks:
        "Thank you! You're on the list. We'll let you know as soon as subscriptions open.",
      waitlistClose: "Close",
      waitlistError: "Sign-up failed. Please check your email and try again.",
      free: "Free",
      forever: "Forever",
      startFree: "Open the registry",
      collector: "Collector",
      collectorTag: "For collectors",
      chooseCollector: "Choose Collector",
      professional: "Professional",
      professionalTag: "Dealers & professionals",
      chooseProfessional: "Choose Professional",
      enterprise: "Houses & institutions",
      enterpriseTag: "Insurers, auction houses",
      contactUs: "Contact us",
    },
    faq: {
      eyebrow: "Help & questions",
      title: "Frequently asked questions",
      intro:
        "Everything you need to know about how the Provena registry works, what it documents, and what it does not.",
      items: [
        {
          q: "What is Provena Registry?",
          a: "Provena Registry is a digital registry dedicated to the documentation and traceability of luxury watches. It lets you build a watch's ownership and provenance history, report a theft and look up a watch's status by its serial number.",
        },
        {
          q: "Does Provena certify or authenticate watches?",
          a: "No. Provena is a documentation and traceability platform. Provena does not authenticate, certify or guarantee the authenticity of watches. Recorded information relies on owners' declarations. For an authenticity assessment, consult a watchmaker or a specialised house.",
        },
        {
          q: "Why does Provena refuse to certify?",
          a: "Because authentication is a physical act. It requires the watch in hand, opened, its components compared against the manufacturer's references. A registry that never touches the object cannot do this, and were it to claim otherwise, it would be lying about what it saw. It is also a deliberate refusal. A registry that passes judgement becomes a single point of failure: declare a counterfeit genuine and it launders it under its own name; declare a genuine piece false and it destroys someone's property on a guess. Neither error can be undone, and both would be ours. Finally, a verdict ages badly. An authentication is true on the day it is issued and says nothing about the watch two owners later. A dated history keeps its value precisely because it never claimed to conclude. What Provena does instead: name who declared what, when, and on what basis. Every event carries the standing of whoever recorded it: the owner, the maker of the piece, a registered professional, the manufacture. Provena does not tell you whether the watch is genuine; it puts you in a position to judge. And it answers for what it can answer for: the integrity of the file. Every change writes a visible event into it, and the cryptographic seal, publicly verifiable, lets anyone check that the file you are shown is the one that was sealed.",
        },
        {
          q: "How does serial-number look-up work?",
          a: "Enter a watch's serial number on the home page. The registry indicates whether the watch is registered, whether photographs or supporting documents are on file and whether it has been reported as stolen. No personal owner details are displayed publicly.",
        },
        {
          q: "What are the Provena digital passport and the provenance file?",
          a: "The Provena digital passport is a document summarising a watch's registration to the registry under its declared owner's name. The provenance file gathers the ownership history, supporting documents, service records and photographs you provide. None of these documents constitutes an authenticity certification.",
        },
        {
          q: "Is the Provena digital passport the European Digital Product Passport (DPP)?",
          a: "No. These are two distinct things. The Digital Product Passport (DPP), introduced by the EU ecodesign regulation, is issued by the manufacturer placing a product on the market and describes what the product is: composition, repairability, compliance. The Provena digital passport is built from the owner's declarations and describes who owns the watch and where it comes from: ownership chain, transfers, servicing, theft reports. The two are complementary, never interchangeable: Provena does not issue DPPs, and a Provena document constitutes neither regulatory compliance nor certification.",
        },
        {
          q: "Are my personal details publicly visible?",
          a: "No. During a public look-up, only status information (registered watch, photographs or documents on file, theft report) is visible. Your details remain confidential. To learn more, see our privacy policy.",
        },
        {
          q: "How do I report a stolen watch?",
          a: "Go to the 'Report a stolen watch' page after signing in. A report makes the watch identifiable during any serial-number look-up. Note: a Provena report does not constitute a police complaint, so be sure to contact the relevant authorities.",
        },
        {
          q: "How do I transfer ownership of a watch?",
          a: "From your account, enter the new owner's name and email: they receive a link to take the file. Until then the file stays in your name, and you can cancel. The Provena ID and provenance history are preserved, and you are told once they have taken it.",
        },
        {
          q: "How much does Provena cost?",
          a: "Account creation, watch registration and serial-number look-up are free. Premium options (provenance files, passports, professional tools) are offered per use or by subscription.",
        },
        {
          q: "How is my personal data protected?",
          a: "We apply reasonable technical and organisational measures and never sell your data. The details of processing, processors and your rights (access, deletion, portability) are set out in our privacy policy.",
        },
      ],
      moreTitle: "Another question?",
      moreText:
        "Our team is available for any request about the registry, your account or your data.",
      legalPre: "See also our",
      legalPrivacy: "privacy policy",
      legalCookies: "cookie policy",
      legalTermsPre: "and our",
      legalTerms: "terms of use",
    },
    // RDEC-022: a relayed theft is read under the name of whoever published it.
    theftSource: {
      notice: "Reported stolen by {publisher} in a public notice relayed by Provena.",
      noticeDated:
        "Reported stolen by {publisher} in a public notice dated {date}, relayed by Provena.",
      viewNotice: "View the notice",
      pageLink: "Report page",
    },
    stolenRegistry: {
      metaTitle: "Stolen watch registry | Provena",
      metaDescription:
        "Check for free whether a watch has been reported stolen before buying it. Public registry kept by Provena.",
      eyebrow: "Public registry",
      title: "Watches reported stolen",
      subtitle:
        "Before buying a pre-owned watch, check that it has not been reported stolen. Search by serial number, brand or model.",
      searchPlaceholder: "Serial number, brand or model…",
      searchBtn: "Search",
      clearBtn: "Clear",
      resultsCount: "{count} watch(es) reported stolen",
      empty: "No stolen watch matches your search.",
      emptyAll: "No watch is currently reported stolen in the registry.",
      emptyHint:
        "That says it is not reported, and nothing more: the registry may not know this watch at all. Its full record is looked up elsewhere.",
      emptyAllHint:
        "The registry is young. A watch appears here only once its holder has reported it, with a police reference.",
      emptyVerifyCta: "Look up a serial number",
      emptyReportCta: "Report a theft",
      colWatch: "Watch",
      colSerial: "Serial number",
      noSerial: "No serial",
      colStolen: "Reported stolen",
      colLocation: "Location",
      reportedOn: "Reported on {date}",
      loadMore: "Show more",
      viewFile: "View public file",
      disclaimer:
        "This registry is based on declarations made by owners. Absence from this list does not guarantee a watch has not been stolen. When in doubt, contact the authorities.",
      ctaOwnerPre: "Has one of your watches been stolen?",
      ctaOwnerLink: "Report it here",
    },
    stolenGuide: {
      metaTitle:
        "Stolen watch: what to do? Report your stolen watch | Provena",
      metaDescription:
        "Has your luxury watch been stolen? Learn the steps to report it, notify your insurer and make it identifiable. Practical guide and free reporting.",
      eyebrow: "What to do after a theft",
      title: "Has your watch been stolen? Here's what to do.",
      intro:
        "Having a watch stolen, especially a piece that means something to you, is a hard moment. Beyond its value, it is often a story, a memory, sometimes an inheritance that disappears. This page explains the steps to take quickly to maximise your chances of recovering it, and how to make it identifiable if someone tries to resell it.",
      stepsTitle: "Act fast: the first hours count",
      stepsIntro:
        "The sooner you report the theft, the harder the watch becomes to offload for the thief. Here are the steps to follow.",
      steps: [
        {
          title: "1. File a police report",
          description:
            "File a report with the police as quickly as possible. Bring everything that identifies the watch: brand, model, and above all the serial number. The police report is essential for your insurance and for any later steps. Keep the receipt safe.",
        },
        {
          title: "2. Gather proof of ownership",
          description:
            "Collect everything that proves the watch is yours: purchase invoice, certificate, photos (especially of the case back and serial number), original papers. These will be requested by the police and your insurer, and will serve to prove your rights if the watch resurfaces.",
        },
        {
          title: "3. Notify your insurer",
          description:
            "If your watch is insured (home insurance, a specific policy, or dedicated cover), report the theft within the deadlines set by your contract. These deadlines vary between insurers and countries, so check your terms without delay.",
        },
        {
          title: "4. Spread the word",
          description:
            "A stolen watch is often resold quickly, online or through specialised channels. Report the theft around you: dealers, collector forums, resale platforms, the watch community. The more widely the theft is known, the riskier resale becomes for the thief.",
        },
        {
          title: "5. List the theft in a provenance registry",
          description:
            "Recording the theft on a registry like Provena creates an official, dated record tied to your watch's serial number. If a cautious buyer, a professional or a dealer checks the watch before a transaction, the report appears. This makes the piece harder to offload and strengthens your evidence if it resurfaces.",
        },
      ],
      reportCta: "Report my stolen watch",
      reportCtaNote: "Reporting is free.",
      protectTitle: "Do your other watches have a dossier?",
      protectText:
        "A watch registered in advance is far easier to report and identify in case of theft. Its serial number, photos and proof of ownership are already gathered, ready to use. Provena lets you build that file ahead of time, for your own watches and for those you will pass on.",
      protectCta: "Register my watches",
      faqTitle: "Frequently asked questions",
      faq: [
        {
          q: "How do I report a stolen watch?",
          a: "Start by filing a police report with the serial number and a description of the watch. Then notify your insurer within your contract's deadlines, and spread the word among dealers, resale platforms and collector communities. You can also record the theft on a provenance registry like Provena to create an official, dated record tied to the serial number.",
        },
        {
          q: "Can a stolen watch be recovered using its serial number?",
          a: "The serial number is the key element for identifying a watch. It is what distinguishes it from any other, proves it belongs to you, and lets you flag it as stolen. If the watch reappears for sale, an attentive buyer or professional can compare this number against existing reports. The more the theft is documented and shared, the higher the chances of identification.",
        },
        {
          q: "Is it legal to resell a stolen watch?",
          a: "No. Knowingly selling or buying stolen goods is an offence. That is why more and more buyers check a watch's origin before purchase, asking for its proof of ownership and history. A watch whose theft has been reported becomes significantly harder to offload.",
        },
        {
          q: "What should I do if I find my stolen watch for sale somewhere?",
          a: "Do not try to recover it yourself. Note down all available information (listing, seller, location, screenshot) and pass it to the police, linking it to your original report. It is up to the authorities to step in. Your proof of ownership and earlier report will make the procedure easier.",
        },
        {
          q: "Do I need insurance to report a stolen watch?",
          a: "No. Reporting a theft, to the police or on a provenance registry, is independent of your insurance. Insurance concerns any compensation; reporting aims to make the watch identifiable and hard to resell. The two steps are complementary.",
        },
        {
          q: "How much does reporting a theft on Provena cost?",
          a: "Reporting a theft on Provena is free.",
        },
      ],
    },
    dossier: {
      eyebrow: "Registry look-up",
      title: "Provena File",
      permanentId: "Permanent identifier",
      notFoundTitle: "No file found",
      notFoundText:
        "No watch is associated with this Provena identifier. Please check the number entered.",
      backHome: "Back to home",
      stolenAlertPre: "This piece is currently",
      stolenAlertStrong: "reported as stolen",
      stolenAlertPost: "in the Provena registry.",
      stolenPending:
        "A theft has been reported for this piece. The police reference has not been provided yet: the report is unconfirmed.",
      stolenDisputed:
        "A theft has been reported for this piece, and the dossier's holder disputes it. Provena records both, and does not arbitrate.",
      proBadge: (n) =>
        `${n} documented professional intervention${n > 1 ? "s" : ""}`,
      noTheftReport: "No known theft report",
      ownerRegistered: "Registered owner, identity kept confidential",
      ownerPending: "Opened by a professional, awaiting its owner",
      ownerUnclaimed: "Dossier awaiting its owner's claim",
      servicedByAtelier: "Serviced by a professional workshop",
      unclaimedHistory:
        "This dossier's history stays private until its owner claims it.",
      unclaimedCta: "Claim it with the code on my workshop receipt",
      registeredOn: "Recorded in the registry on {date}",
      verifyTitle: "Verify this dossier's seal",
      qrAlt: "Dossier verification QR code",
      verifyLink: "Open the verification page",
      confidential: "The owner's details remain confidential.",
      enrichTitle: "Are you the owner of this watch?",
      enrichText:
        "Enrich its file: add invoices, photographs and service documents to enhance its provenance.",
      enrichCta: "I'm the owner · enrich",
    },
    dashboard: {
      metaTitle: "My account",
      metaDescription:
        "Your Provena registry: collection, membership, reports, passports and billing history.",
      loginTitle: "My account",
      loginDescription:
        "Sign in to reach your collection, your registry and your membership.",
      loadErrorTitle: "Unable to load",
      loadErrorText:
        "Your data could not be loaded. Check your connection and try again.",
      retry: "Try again",
      eyebrow: "Your collection",
      greeting: "Hello, {name}",
      greetingNoName: "Welcome to your registry",
      emailSentTitle: "An email has been sent to you",
      emailFailedTitle: "Document generated",
      emailFailedDesc:
        "We couldn't send the email. You can find your document in your account.",
      proArea: "Pro area",
      becomePro: "Professionals",
      planBadge: "{tier} plan",
      subscription: "Subscription",
      intervalAnnual: "Annual",
      intervalMonthly: "Monthly",
      subscriptionValid: "{interval} · valid until {date}",
      changeRenew: "Change / Renew",
      comingSoon: "Coming soon",
      cancelConfirmText:
        "Cancel your subscription? Access will end immediately.",
      cancelConfirmYes: "Confirm cancellation",
      cancelConfirmNo: "Keep my subscription",
      cancel: "Cancel",
      planFree: "Free plan",
      freeUpsell:
        "Upgrade to a subscription to unlock included reports and advanced tools.",
      seeSubscriptions: "View subscriptions",
      seePricing: "View membership",
      genericError: "Something went wrong.",
      notOwnerError:
        "This watch is not registered under your account. Only the registered owner can enrich this file.",
      collection: "My collection",
      collectionEmpty: "You haven't registered any watch yet.",
      registerWatch: "Register a watch",
      addWatch: "Register a new watch",
      importBulk: "Import a file",
      reports: "My reports",
      reportsEmpty: "No report generated.",
      passports: "My passports",
      passportsEmpty: "No passport generated.",
      billing: "Billing history",
      billingEmpty: "No transaction.",
      colDate: "Date",
      colOffer: "Plan",
      colAmount: "Amount",
      colStatus: "Status",
      paid: "Paid",
      cancelFailed: "Cancellation failed. Please try again.",
      itemSerial: "Serial no.",
      viewDossier: "View the dossier and its timeline",
      moreActions: "More actions",
      itemNoSerial: "No serial number",
      edit: "Edit",
      reportBtn: "Report",
      passportBtn: "Passport",
      transferBtn: "Transfer",
      reportTheftBtn: "Report stolen",
      stolenBadge: "Reported stolen",
      stolenPendingBadge: "Report pending",
      stolenDisputedBadge: "Report disputed",
      disputeTheftBtn: "Dispute",
      disputeTitle: "Dispute this report",
      disputeIntro: ({ watch }) =>
        `Someone reported ${watch} as stolen. If that is not the case, say so: your dispute will be recorded on the dossier, dated and in your name.`,
      disputeReason: "What you want on the record",
      disputeReasonPh:
        "This watch is in my possession, I never reported it stolen…",
      disputeNotice:
        "Provena does not arbitrate. Your dispute is added to the report without erasing it, and the warning stays visible until an administrator closes the matter: the registry shows both sides.",
      disputeSubmit: "Record my dispute",
      disputeSending: "Sending…",
      disputeDone: ({ watch }) =>
        `Your dispute is recorded on the dossier for ${watch}.`,
      disputeError: "Something went wrong. Check the details and try again.",
      reportTheftTitle: "Report this watch stolen",
      reportTheftConfirm: "I confirm this watch is mine and has been stolen. This declaration will be recorded in the registry.",
      theftDone: "{watch} has been reported stolen in the registry.",
      notifTitle: "E-mail notifications",
      notifIntro: "Choose which e-mails you want to receive. Confirmations of your own actions are always sent.",
      notifProEvent: "Professional event",
      notifProEventHint: "When a professional adds an event to one of your watches.",
      notifTheftAlerts: "Theft alerts",
      notifTheftAlertsHint:
        "A morning digest of watches reported stolen to the registry, only when there are new ones.",
      notifSaved: "Preferences saved.",
      rgpdTitle: "My data",
      rgpdIntro: "You stay in control of your data. Export it at any time, or permanently delete your account.",
      exportBtn: "Export my data",
      exportHint: "Downloads a file with all your data (profile, watches, passports, reports).",
      deleteBtn: "Delete my account",
      deleteHint: "Permanently deletes your account and the watches you own. This cannot be undone.",
      deleteTitle: "Permanently delete my account",
      deleteWarning: "This action is irreversible. Your account, the watches you own and their documents will be permanently deleted. Watches you transferred away stay with their new owner, but your name will be removed from them.",
      deleteConfirmLabel: "To confirm, type {word} below.",
      deleteConfirmWord: "DELETE",
      deleteConfirmBtn: "Delete permanently",
      deleteCancel: "Cancel",
      deleteError: "Deletion failed. Please try again.",
      photoAlt: "Watch",
    },
    certificateRedirect: {
      seoTitle: "Opening your passport",
      notFoundTitle: "This passport could not be opened",
      notFoundBody:
        "The link you followed does not point to a passport on your account. All your passports are listed on your account, each with its watch.",
      backToAccount: "See my passports",
    },
    reportView: {
      seoTitle: "Provenance report · {brand} {model}",
      notFound: "Report not found.",
      backToAccount: "Back to my account",
      account: "My account",
      print: "Print / Download",
      reportNo: "Report No.",
      provenaId: "Provena ID",
      eyebrow: "Premium provenance report",
      issuedOn: "Issued on {date}",
      identification: "Identification",
      serial: "Serial number",
      brand: "Brand",
      model: "Model",
      year: "Year",
      declaredOwner: "Declared owner",
      provenanceDoc: "Provenance & documentation",
      purchaseProof: "Proof of purchase",
      serviceRecords: "Service records",
      notes: "Notes",
      acquisitionMethod: "Acquisition method",
      boxPapers: "Box & papers",
      photos: "Photographs",
      dial: "Dial",
      caseback: "Case back",
      movement: "Movement",
      fileStatus: "File status",
      registered: "Registered in the Provena registry",
      reportedStolen: "Reported as stolen",
      noTheft: "No theft report",
      lastUpdate: "Last update: {date}",
      stolenAlert:
        "This watch is currently reported as stolen in the Provena registry.",
      consultFile: "View this file",
      boxOrigin: "Original box",
      papersOrigin: "Original papers",

      provenanceOverview: "Provenance overview",
      timeline: "Timeline",
      sources: "Sources",
      documentsHeading: "Documents on file",
      gaps: "What this record does not establish",
      gapsIntro:
        "Provena records what has been reported to it. The points below cast no doubt on the watch or its owner: they set the boundaries of this report.",
      methodology: "Methodology",
      methodologyNotice:
        "A verification level qualifies the source of a statement, never the authenticity of the watch. Provena does not authenticate and does not certify.",
      noEvents: "No event recorded to date.",
      noGaps: "No notable gap detected in this record.",
      noDocuments: "No document on file.",
      undatedEvent: "Date not specified",
      attachmentCount: "{count} attachment(s)",
      sealMismatch:
        "This record's seal no longer matches its content. Please contact Provena.",
      tallies: {
        events_recorded: "events recorded",
        documents: "documents on file",
        ownership_events: "ownership events",
        service_events: "service interventions",
        third_party_events: "events attested by a third party",
        documented_events: "events backed by a document",
      },
      gapKeys: {
        pre_record_gap:
          "Between {from} and {to}, the watch existed with no event recorded here.",
        coverage_gap: "No event recorded between {from} and {to}.",
        undated_events:
          "{count} event(s) carry no precise date: their position in the timeline is uncertain.",
        no_documents: "No supporting document has been added to this record.",
        no_serial:
          "This record carries no serial number: cross-checking against the theft registry is not possible.",
        ownership_self_reported_only:
          "The {count} change(s) of hands rest on the owner's declaration alone.",
        no_service_history: "No service intervention is recorded.",
        event_precedes_production:
          "{count} event(s) are dated before the declared production year ({production_year}). Provena flags the inconsistency without arbitrating it.",
      },
    },
    verifyPage: {
      metaTitle: "Provena verification",
      seoTitle: "Verification · {brand} {model}",
      notFoundTitle: "No file found",
      notFoundTextPre: "No watch is associated with the identifier",
      notFoundTextPost: "in the Provena registry.",
      backHome: "Back to home",
      invalidTitle: "Invalid signature",
      validTitle: "Dossier intact",
      invalidText: "This document was modified after issuance.",
      validText:
        "Cryptographic signature verified: the dossier has not changed since it was sealed.",
      validTextOn:
        "Cryptographic signature verified: the dossier has not changed since it was sealed on {date}.",
      scopeNote:
        "This check covers the dossier. It says nothing about the authenticity of the watch.",
      stolenPre: "This watch is currently",
      stolenStrong: "reported as stolen",
      stolenPost: "in the registry.",
      watch: "Timepiece",
      registeredOn: "Registered on {date}",
      sealedOn: " · sealed on {date}",
      integrity: "Cryptographic integrity",
      sealed: "File sealed",
      hashMatch: "SHA-256 fingerprint matches",
      signatureValid: "Valid RSA signature",
      qrAuthentic: "QR code issued by Provena",
      algorithm: "Algorithm",
      fingerprint: "File fingerprint",
      signatureKey: "Signing key",
      signedPassport: "Signed passport",
      passportSignatureValid: "Valid passport signature",
      passportNo: "Passport No. {no}",
      issuedOn: "Issued on {date}",
      issuedToPreviousHolder:
        "Issued to a previous holder: this passport does not say who holds the watch today.",
      theftCheckTitle: "Theft check",
      theftCheckText:
        "Provena records theft declarations backed by a police report. For an additional check, search this watch on the international Enquirus register.",
      theftCheckCta: "Check on Enquirus",
      viewPublicFile: "View public file",
      publicKey: "Public key",
      legalNote:
        "This page confirms the integrity of the data recorded in the Provena registry using a SHA-256 fingerprint and an RSA signature. It does not constitute an authentication of the watch itself.",
    },
    payment: {
      metaTitle: "Payment confirmation",
      kindReport: "Your provenance report credit has been added.",
      kindCertificate: "Your passport credit has been added.",
      kindSubscription: "Your subscription is now active.",
      kindDefault: "Your purchase has been recorded.",
      checkingTitle: "Verifying payment…",
      checkingText: "Please wait a few moments.",
      successTitle: "Payment confirmed",
      toAccount: "Go to my account",
      timeoutTitle: "Payment pending",
      failedTitle: "Payment unsuccessful",
      timeoutText:
        "Processing is taking longer than expected. Check your account in a few minutes.",
      failedText:
        "The payment could not be confirmed. No amount has been charged.",
      backToPricing: "Back to membership",
      account: "My account",
    },
    notFound: {
      metaTitle: "Page not found",
      metaDescription:
        "The page you are looking for does not exist or has been moved.",
      error: "Error 404",
      title: "Page not found",
      text: "The page you are looking for does not exist or has been moved.",
      backHome: "Back to home",
    },
    transfer: {
      title: "Transfer ownership",
      serial: "Serial no.",
      noSerial: "No serial number",
      provenaIdKept: "Provena ID · {id} (kept after transfer)",
      newOwnerName: "New owner's name",
      newOwnerNamePlaceholder: "First and last name",
      newOwnerEmail: "New owner's email",
      newOwnerEmailPlaceholder: "new@example.com",
      note: "The new owner receives a link to take the file. Until then it stays in your name: you can send a reminder or cancel. You will be told once they have taken it.",
      confirmCheckbox:
        "I am handing the file of {watch} to this person. Once they have taken it, it will leave my collection.",
      submit: "Send the link",
      genericError: "Something went wrong.",
      success: "Link sent to {email}. The file stays in your name until it is taken.",
    },
    pendingTransfer: {
      text: "Waiting for {name} ({email}): link sent on {date}.",
      hint: "The file stays in your name until it is taken.",
      resend: "Send a reminder",
      resendLater: "A reminder can be sent from {date}.",
      cancel: "Cancel the transfer",
      resent: "Link sent again.",
      cancelled: "Transfer cancelled: the link sent no longer works.",
    },
    recordCreation: {
      action: "Record the making",
      title: "Record the making",
      intro:
        "Describe a stage of the making, or its completion. You can record several: a piece is made in more than one sitting. Until a making is recorded, the record asks you for a purchase invoice, for a watch nobody bought.",
      done: "The making has been recorded.",
    },
    addDocument: {
      title: "Add a document",
      serial: "Serial no.",
      provenaId: "Provena ID",
      type: "Document type",
      dateOptional: "Date (optional)",
      description: "Description",
      attachment: "Attachment",
      descriptionError: "Please describe the document or information added.",
      descriptionPublic: "This description will appear on your watch's public page, readable by anyone. The attached file stays private and is visible to you alone.",
      genericError: "Something went wrong.",
      note: "The document will be recorded in the watch's public history at the « Declared by the owner » level.",
      submit: "Add to file",
      success: "Document added to the history of {watch}.",
      categories: {
        facture: {
          label: "Invoice / proof of purchase",
          hint: "Add the invoice, warranty card or proof of purchase (PDF or image).",
          placeholder: "E.g. Rolex boutique invoice dated 12/03/2019, amount included…",
        },
        entretien: {
          label: "Service / maintenance",
          hint: "Attach the service slip or maintenance invoice (PDF or image).",
          placeholder: "E.g. Full service, crown gasket replacement…",
        },
        photo: {
          label: "Photograph",
          hint: "Add a recent photograph of the watch (JPEG, PNG, WebP).",
          placeholder: "E.g. Photograph of the dial after servicing.",
        },
        autre: {
          label: "Other document / information",
          hint: "Attach any document useful to provenance (PDF or image).",
          placeholder: "Specify the information or document added.",
        },
      },
    },
    registerPage: {
      metaTitle: "Register my watch",
      metaDescription:
        "Register your luxury watch in the Provena registry: build its ownership and provenance history securely.",
      loginDescription:
        "Sign in to register your watch and build its provenance history securely.",
      gateTitle: "Only you are missing",
      gateDescription:
        "Create your account to attach the photographs and documents, then seal the dossier. What you have just entered is kept.",
      eyebrow: "Provenance dossier",
      title: "Register my watch",
      subtitle:
        "Every watch has a story. Give yours a dossier that records it, dated and sealed.",
      reassurance: [
        "Five minutes is enough",
        "Free, no card",
        "Visible to you alone",
      ],
      bulkPrompt: "Several watches to register?",
      bulkLink: "Import a file",
      atelierPrompt: "A piece from your own atelier?",
      atelierLink: "Register it from the maker's area",
      similarTitle: "Is this the same watch?",
      similarBody:
        "A very close dossier already exists in your registry: {provena} (serial {serial}). A one-letter or one-digit difference often comes from an imperfect photo reading.",
      similarSame: "Yes, it's the same: update that dossier",
      similarDifferent: "No, it's another watch: create a dossier",
      similarBack: "Back to the form",
    },
    registerSuccess: {
      captionProvena: "Provena ID",
      captionSerial: "Serial number",
      title: "Watch sealed",
      bodyPre: "The watch with serial number ",
      bodyAux: " has been ",
      bodyRegistered: "registered and sealed",
      bodyUpdated: "updated and re-sealed",
      bodyPost: " in the Provena registry.",
      bodyProvenaPre: "The watch has been ",
      bodyProvenaMid: " in the Provena registry, under the identifier ",
      bodyProvenaPost: ".",
      hint:
        "Its dossier is now sealed and searchable by serial number in the registry.",
      hintProvena:
        "Its dossier is now sealed and searchable by Provena ID in the registry.",
      backHome: "Back to home",
      another: "Register another watch",
    },
    upload: {
      formatDoc: "Unsupported format (PDF, JPG or PNG).",
      formatPhoto: "Unsupported format (JPEG, PNG or WebP).",
      tooLargeDoc: "File too large (max 8 MB).",
      tooLargePhoto: "Image too large (max 8 MB).",
      failed: "Upload failed. Please try again.",
      uploading: "Uploading…",
      chooseFile: "Choose a file (PDF or image)",
      dropFile: "Drag and drop your file, or click to browse",
      docHint: "PDF, JPG or PNG · max 8 MB",
      docAdded: "Document added",
      removeDoc: "Remove document",
      takePhotoDoc: "Photograph the document",
      takePhoto: "Take a photo",
      chooseGallery: "Choose from gallery",
      photoAdded: "Photo added",
      photoHint: "JPEG, PNG, WebP · max 8 MB",
      addPhoto: "Add a photo (JPEG, PNG, WebP, max 8 MB)",
      removePhoto: "Remove photo",
      formatGeneric: "Unsupported format.",
      fileAdded: "File added",
      addFile: "Add a file (max 8 MB)",
    },
    completeness: {
      title: "Provenance portrait",
      axisRichesse: "Richness",
      axisAncrage: "Anchoring",
      richesse: {
        ebauche: "Outline",
        en_construction: "In progress",
        etoffe: "Substantial",
        nourri: "Rich",
      },
      richesseBlurb: {
        ebauche: "Dossier opened: every trace added deepens it.",
        en_construction: "The first chapters are being written.",
        etoffe: "Already a substantial dossier.",
        nourri: "A rich dossier that tells the watch's story.",
      },
      ancrage: {
        declaratif: "Mostly declared",
        partiel: "Partly documented",
        large: "Largely documented",
        plein: "Fully documented",
        none: "Nothing recorded yet",
      },
      ancrageBlurb: {
        declaratif: "Rests mostly on the owner's word.",
        partiel: "Part of it rests on evidence.",
        large: "Most of it rests on evidence.",
        plein: "Backed by documents and third parties.",
        none: "Add a piece to start anchoring it.",
      },
      chapters: {
        documents: "Documents",
        photos: "Photographs",
        history: "Living history",
        box_papers: "Box & papers",
        identity: "Identity",
      },
      state: {
        absent: "To come",
        amorce: "Started",
        nourri: "Full",
      },
      sources: {
        document: "documented",
        tiers: "third-party attested",
        declare: "declared",
      },
      invitationTitle: "To go further",
      invitation: {
        ajouter: "This dossier would gain from carrying {element}.",
        documenter: "Attach {element} to anchor the dossier further.",
      },
      elements: {
        facture: "the original invoice",
        carnet: "the service booklet",
        photo_cadran: "a photo of the dial",
        photo_fond: "a photo of the caseback",
        photo_mouvement: "a photo of the movement",
        evenement: "an event (service, appraisal…)",
        papiers: "the original papers",
        boite: "the original box",
        annee: "the production year",
        acquisition: "the acquisition method",
        pays: "the owner's country",
      },
      honesty:
        "Provena records where a dossier's elements come from; it does not certify their authenticity.",
    },
    share: {
      eyebrow: "Share this dossier",
      copy: "Copy link",
      copied: "Link copied",
      passportText: "Provena digital passport",
    },
    bulkImport: {
      metaTitle: "Import several watches",
      metaDescription:
        "Register a whole collection at once in the Provena registry from a CSV or Excel file.",
      loginDescription:
        "Sign in to register your entire collection in one go.",
      back: "Single registration",
      eyebrow: "Bulk import",
      title: "Your whole collection, at once",
      intro:
        "Drop a CSV or Excel file. We validate every row before anything is written: you confirm, we seal. Photos and documents are added afterwards, watch by watch.",
      template: "Download the CSV template",
      validateError: "The file could not be parsed. Check its format.",
      commitError: "The import could not be completed. Try again in a moment.",
      ownerMode: "These watches are",
      modeSelfTitle: "Mine",
      modeSelfDesc: "They go straight into your collection.",
      modeClientsTitle: "My clients'",
      modeClientsDesc:
        "Each owner receives an invitation to claim their watch.",
      dropzone: "Drag and drop your file, or click to browse",
      analyzing: "Analysing the file…",
      dropHint: "CSV or Excel (.xlsx) · 200 watches max",
      colWatch: "Watch",
      colStatus: "Status",
      noSerial: "no serial number",
      statusOk: "Ready to register",
      statusDuplicate: "Updates your dossier",
      statusOwned: "Already registered by another account",
      statusInvalid: "Invalid row",
      analyzedOne: "1 row analysed",
      analyzedMany: "{count} rows analysed",
      toRegister: "{count} to register",
      ownedCount: "{count} belong to another account",
      invalidOne: "1 invalid",
      invalidMany: "{count} invalid",
      commitOne: "Register 1 watch",
      commitMany: "Register {count} watches",
      chooseOther: "Choose another file",
      nothingImportable:
        "No registrable row in this file. Fix it from the template, then try again.",
      successCaption: "Watches registered",
      successTitleSelf: "Collection sealed",
      successTitleClients: "Watches registered",
      successBodyOne:
        "1 watch registered. A summary has just been emailed to you.",
      successBodyMany:
        "{count} watches registered. A summary has just been emailed to you.",
      successHintSelf:
        "Complete each dossier (photos, invoices, history) from your account to strengthen its provenance.",
      successHintClientsOne:
        "1 invitation sent: each owner can now claim their watch. Until then, you keep management of it.",
      successHintClientsMany:
        "{count} invitations sent: each owner can now claim their watch. Until then, you keep management of them.",
      gotoAccount: "View my collection",
      importAnother: "Import another file",
    },
    claim: {
      metaTitle: "Claim my watch",
      metaDescription:
        "Take control of the provenance dossier of a watch registered in your name.",
      notFoundTitle: "Invitation not found",
      notFoundBody:
        "This link is no longer valid, or the watch has already been claimed. If you believe this is a mistake, contact the professional who sent you this invitation.",
      backHome: "Back to home",
      claimedCaption: "Watches claimed",
      claimedTitle: "It's yours",
      claimedBodyOne:
        "1 watch now belongs to you in the registry. You alone control its dossier, its history and its digital passport.",
      claimedBodyMany:
        "{count} watches now belong to you in the registry. You alone control their dossier, their history and their digital passport.",
      gotoAccount: "View my collection",
      loginDescription:
        "Sign in with the email address the invitation was sent to, to take control of the dossier.",
      eyebrow: "Invitation",
      titleOne: "A watch awaits you",
      titleMany: "{count} watches await you",
      whatOne: "this watch",
      whatMany: "these watches",
      introByProTail: " registered {what} in your name in the Provena registry.",
      introSalePre: "You bought this watch from ",
      introSaleTail: ". Its file is waiting for you: take it in your name, with its passport.",
      introTransferTail: " is transferring their watch's file to you. Take it in your name, with its passport.",
      introNoProOne:
        "This watch has been registered in your name in the Provena registry.",
      introNoProMany:
        "These watches have been registered in your name in the Provena registry.",
      confirmOne: "This is my watch",
      confirmMany: "Claim my watches",
      disclaimer:
        "By claiming, you become the registered owner: you alone will control the dossier and its passport. Your email address must match the one on the invitation.",
      claimError: "The claim failed. Try again in a moment.",
      codeEyebrow: "Workshop receipt",
      codeTitle: "Claim my watch",
      codeIntro:
        "A workshop recorded your watch's servicing in the Provena registry. Enter its serial number and the code printed on your hand-back receipt: the dossier will pass into your name.",
      codeLoginDescription:
        "Sign in to claim your watch's dossier with the code on your workshop receipt.",
      codeSerialLabel: "Serial number",
      codeLabel: "Receipt code",
      codeSubmit: "Claim the dossier",
      codeHelp:
        "Lost your receipt? Write to contact@provenaregistry.com with a proof of purchase or photos of the caseback: we will review your request.",
    },
    prov: {
      events: {
        CREATION: "Crafted in the atelier",
        REGISTRATION: "Registry entry",
        SERVICE: "Service / Maintenance",
        SALE: "Professional sale",
        APPRAISAL: "Appraisal / Valuation",
        AUTHENTICATION: "Authentication (declared by a third party)",
        THEFT: "Theft report",
        THEFT_DISPUTED: "Theft report disputed",
        RECOVERY: "Watch recovered",
        OWNERSHIP_TRANSFER: "Ownership transfer",
        INSURANCE: "Insurance",
        UPDATE: "Information updated",
        DOCUMENT: "Document added",
        CONSIGNMENT: "Placed on consignment",
        CONSIGNMENT_END: "Returned from consignment",
      },
      levels: {
        SELF_REPORTED: "Declared by the owner",
        DOCUMENTED: "Declared, with supporting document",
        ATELIER_REPORTED: "Reported by a workshop",
        CREATOR_DECLARED: "Declared by the maker",
        PROFESSIONAL: "Registered professional",
        VERIFIED: "Recorded by Provena",
        MANUFACTURER_VERIFIED: "Confirmed by the manufacture",
      },
      actors: {
        proprietaire: "Owner",
        createur: "Maker",
        horloger: "Watchmaker",
        marchand: "Dealer",
        expert: "Expert",
        assureur: "Insurer",
        admin: "Provena",
      },
      proActors: {
        createur: { label: "Independent maker / manufacture", desc: "Pieces designed and made in the atelier." },
        horloger: { label: "Watchmaker / workshop", desc: "Services, maintenance and repairs." },
        marchand: { label: "Professional dealer", desc: "Watch sales and transactions." },
        expert: { label: "Watch expert", desc: "Appraisals, valuations and authentications." },
        assureur: { label: "Insurer", desc: "Coverage and insurance declarations." },
      },
    },
    authorize: {
      metaTitle: "Link an application",
      eyebrow: "Linked application",
      title: "Link your Provena account to {app}",
      signedInAs: "Signed in as {email}.",
      canTitle: "{app} will be able to, on your behalf",
      neverTitle: "{app} will never be able to",
      neverItems: [
        "Transfer a watch on your behalf, or set a price.",
        "Report a theft.",
        "See your personal watches or their owners' data.",
        "Change or delete your account.",
      ],
      scopes: {
        "dossiers:read": "Look up a watch in the registry by its serial number or Provena ID, and see whether it is reported stolen.",
        "events:write": "Record events (service, appraisal, consignment…) on a watch's file, in your name.",
        "dossiers:create": "When you sell a watch you held on consignment, open its file in the buyer's name, which the buyer then claims. Without any price, nor the consignor's name.",
        "files:write": "Attach documents to the events you record.",
        "stock:create": "Give a Provena ID to the watches in your stock, in your name.",
        "stock:transmit": "Pass the file of a watch from your stock that you sell to the buyer, without any price.",
      },
      proPending:
        "Your professional status request is under review. You can link your account now: {app} will act on your behalf as soon as Provena approves it.",
      proNeeded:
        "These rights only apply with a professional status approved by Provena. You can link your account now and apply here: {app} will act on your behalf once you are approved.",
      actorLegend: "Your activity",
      approve: "Authorize",
      deny: "Decline",
      decisionError: "Your answer could not be saved. Please try again.",
      revokeHint: "You can remove this access at any time, in",
      revokeLink: "My account",
      invalidTitle: "Invalid authorization link",
      invalidBody: "This link does not come from an application linked to Provena. Go back to the application and start again.",
      goneTitle: "Request expired",
      goneBody: "This request has expired or has already been answered. Go back to the application and start again.",
    },
    linkedApps: {
      title: "Linked applications",
      intro: "These applications act on your behalf, with only the rights you granted them. Removing access cuts them off at once.",
      linkedOn: "Linked on {date}",
      lastUsed: "last used on {date}",
      remove: "Remove access",
      confirm: "Confirm removal",
      cancel: "Cancel",
      removeError: "Access could not be removed. Please try again.",
    },
    pro: {
      metaTitle: "Professional area",
      metaDescription:
        "Provena professional portal: enrich the verifiable history of watches.",
      // RDEC-023: the « Professionals » page presents Studio; applications to
      // the professional area are closed.
      studioPage: {
        title: "Are you a watch workshop? Your tool is Provena Studio",
        intro:
          "Provena Studio is the working tool of watch workshops. It is where you work every day; Registry remains the public provenance registry.",
        items: [
          "Watches in for repair, from counter drop-off to hand-back.",
          "Quotes, which the client accepts or signs online.",
          "Keeping your clients informed, and selling pre-owned or consigned watches.",
        ],
        cta: "Discover Provena Studio",
        registryTitle: "What about the registry?",
        registryBody:
          "Publishing to the registry will be done from Studio, with nothing typed twice. Applications to Registry's professional area are therefore closed; professionals already validated keep their area.",
        verify: "Checking that a watch has not been reported stolen stays open to everyone, without an account:",
        verifyLink: "look up a watch",
      },
      applyMetaTitle: "Professionals",
      applyMetaDescription:
        "A watch workshop? Your working tool is Provena Studio; publishing to the provenance registry will be done from Studio.",
      applyLoginDescription:
        "Sign in to submit your professional account request.",
      gateTitle: "Reserved for professionals",
      gateBody:
        "This area is reserved for professionals whose account has already been validated by Provena. New applications are closed: a workshop works in Provena Studio.",
      becomePro: "Professionals",
      eyebrow: "Professional area",
      portalFallback: "Professional portal",
      actorFallback: "Professional",
      searchTitle: "Look up or register a watch",
      searchIntro:
        "Enter a serial number or a Provena ID. If the registry knows the watch, you open its record and log an event on it; if not, you open its record.",
      preview: {
        label: "View the portal as",
        self: "My account",
        active: "Preview: nothing is written under this role.",
      },
      myEvents: "My interventions",
      historyEmpty: "No intervention recorded yet.",
      historyEmptyHow:
        "An intervention is what you record on a watch's file: how it was made, a service, an appraisal. It is what carries your standing in the piece's history, not the file itself. Start by finding the watch, by serial number or Provena ID.",
      historyStartCta: "Record my first intervention",
      viewPublic: "View public dossier",
      applyEyebrow: "Professionals",
      applyTitle: "Become a professional",
      applyIntro:
        "Watchmakers, dealers, experts and insurers can enrich a watch's verifiable history. Once validated by our team, your contributions will carry the “registered professional” level.",
      establishment: "Business name",
      establishmentPh: "E.g. Geneva Watch Workshop",
      applySubmit: "Submit my request",
      applyError: "Something went wrong. Try again.",
      whatYouDo: "What you will be able to do",
      whatYouDoItems: [
        "Record your interventions on any watch in the registry, at the “registered professional” level.",
        "Open a record for a client whose watch is not registered yet; they claim it themselves afterwards.",
        "Check in a moment that a watch is not reported stolen, before accepting it at the workshop.",
      ],
      whatWeAsk: "What Provena expects from you",
      whatWeAskBody:
        "Your entries carry the “registered professional” mark: they weigh more than an owner's word. Record only what you have observed yourself. Provena does not authenticate watches and will never ask you to.",
      applyFree: "Applying and the professional workspace are free during the beta.",
      country: "Country",
      city: "City",
      activityLabel: "Your activity",
      activityPh:
        "Describe your workshop or house: how long, which brands, what kind of work. A few lines are enough.",
      activityHint: "30 characters minimum: the decision rests on this description.",
      website: "Website",
      websitePh: "example.com",
      websiteHint: "Optional, but it is what speeds up validation the most.",
      registrationNumber: "Registration number",
      registrationPh: "VAT number, company register…",
      phone: "Phone",
      optional: "Optional",
      applyDetailsTitle: "Your establishment",
      approvedTitle: "Professional account validated",
      approvedBody:
        "You can now enrich the history of watches in the registry.",
      approvedCta: "Enter the professional area",
      pendingTitle: "Request under review",
      pendingBody:
        "Your professional account request has been received. Our team will validate it soon. You will be notified once it is accepted.",
      searchPlaceholder: "Serial number or Provena ID (e.g. PRV-000001)",
      searchBtn: "Search",
      searchNotFoundSerial: "No watch found for serial number “{q}” in the registry.",
      searchNotFoundProvenaId: "No dossier for Provena ID {q}.",
      registerForClient: "Register for a client",
      openDossier: "Open a record",
      stockRegister: {
        title: "Register a watch from your stock",
        intro:
          "You become its registered owner, which is simply true: the piece is yours until it is sold. Handing it to its buyer will later be a real transfer, and the chain will read dealer, then buyer.",
        submit: "Open the record",
        cancel: "Cancel",
        ownership:
          "Do not use this route for a piece held on consignment: it stays its owner's, and it is the owner who must be named. The owner's name is part of the record's seal.",
        done: "Record {provenaId} opened in your name. Record what you know about the piece below.",
      },
      ownerQuestion: {
        title: "Whose watch is this?",
        body:
          "The registry writes something different depending on the answer, and the owner's name is part of the record's seal. A piece taken on consignment stays its owner's: name them, and they will be invited to claim their record.",
        atelierRegister: "It's mine: a piece from my atelier",
        stockRegister: "It's mine: it's my stock",
        client: "It belongs to a client: consignment, service or appraisal",
      },
      atelierRegister: {
        cta: "Register a piece from my atelier",
        title: "Register a piece from your atelier",
        intro:
          "You become its registered owner, which is simply true: the piece is yours until it is sold. Delivering it to its buyer will later be a real transfer, and the chain will read maker, then first owner. You can record how it was made right away.",
        submit: "Open the record",
        cancel: "Cancel",
        ownership:
          "Leave the acquisition method empty: none of them describes a piece you made yourself. Its buyer will choose \u201cNew \u00b7 directly from the maker\u201d when they claim the record.",
        done: "Record {provenaId} opened. Record how it was made below.",
        open: "Open a record for this piece",
        intent:
          "A piece from your atelier: enter its number above. If the registry already knows it, I open its record; if not, you open one.",
      },
      clientRegister: {
        title: "Register this watch for your client",
        intro:
          "The record is opened in your client's name and waits for them: you do not become its owner. They receive an invitation and claim it by signing in. You can record your intervention right away.",
        clientName: "Client name",
        clientEmail: "Client email",
        emailHint: "The invitation to claim the record goes to this address.",
        submit: "Open the record",
        cancel: "Cancel",
        theClient: "your client",
        ownership: "The record stays pending until {email} claims it.",
        alreadyRegistered:
          "This watch is already in the registry. Search for it to add an event.",
        error: "Registration failed. Please try again in a moment.",
        done: "Record {provenaId} opened. Invitation sent to your client.",
        doneNoEmail: "Record {provenaId} opened. The invitation could not be sent; your client can claim it at their next sign-in.",
        doneUpdated: "Record {provenaId} already existed: it was updated, not created. Check its fields, then log your event below.",
      },
      similar: {
        title: "A very close number already exists",
        body: "Record {provena} carries the number {serial}, one character away from this one. Is it the same watch?",
        open: "Yes, open its record to log the work",
        different: "No, it's another piece: register it anyway",
        exactTitle: "This watch already has a record",
        exactBody: "The number {serial} belongs to record {provena}. A watch already in the registry is enriched through its history, not registered twice.",
        exactOpen: "Open its record to log the work",
      },
      searchYear: "Year {y}",
      searchStolen: "Reported stolen",
      searchStolenUnregistered:
        "Serial number “{q}” has no Provena dossier, but it is reported stolen. Do not buy it or register it.",
      addEvent: "Add an event",
      eventAdded: "Event added",
      eventAddedBody: "The event has been recorded in the history of {watch}.",
      addAnother: "Add another event",
      selectedWatch: "Selected watch",
      eventType: "Event type",
      eventDate: "Date of intervention",
      description: "Description",
      descriptionPh: "Detail the service, appraisal or transaction…",
      descriptionPublic: "This text will appear on the watch's public page, readable by anyone. Do not put your client's name, address or contact details in it: describe the work, not the person. Attached files stay private.",
      photoCraft: "Stage photograph",
      photoCraftHint: "Work in progress in the atelier",
      photoDetail: "Detail photograph",
      photoDetailHint: "Finishing, engraving, component",
      atelierDoc: "Atelier document (PDF or image)",
      photoBefore: "Before photo",
      photoBeforeHint: "Photo before intervention",
      photoAfter: "After photo",
      photoAfterHint: "Photo after intervention",
      invoiceDoc: "Invoice (PDF or image)",
      commercialDoc: "Commercial document (PDF or image)",
      attachHint: "Invoice / document (PDF, JPEG, PNG, WebP)",
      eventSubmit: "Record the event",
      eventError: "Something went wrong. Try again.",
      metaLabel: {
        price: "Price",
        currency: "Currency",
        buyer: "Buyer",
        reference: "Reference",
        insurer: "Insurer",
        policy: "Policy",
        insuredValue: "Insured value",
        stage: "Stage",
        movement: "Movement",
        movementSerial: "Movement no.",
        caseSpec: "Case",
        dimensions: "Dimensions",
        dial: "Dial",
        hands: "Hands",
        crystal: "Crystal",
        strap: "Strap",
        waterResistance: "Water resistance",
        edition: "Edition",
      },
      metaPh: {
        amount: "Amount",
        currencyEur: "EUR",
        counterparty: "Counterparty",
        txNumber: "Transaction no.",
        company: "Company",
        policyNumber: "Policy no.",
        stage: "Design, case, movement, dial, finishing…",
        movement: "Calibre and complications",
        movementSerial: "Number engraved on the movement",
        caseSpec: "Case material and shape",
        dimensions: "Diameter, thickness, lug width",
        dial: "Dial material and finishing",
        hands: "Type, material, finishing",
        crystal: "Sapphire, mineral, coating",
        strap: "Material, buckle, maker",
        waterResistance: "30 m, 50 m, 100 m…",
        edition: "One of one, limited series…",
      },
    },
    registerForm: {
      steps: {
        story: "The story",
        watch: "The timepiece",
        memories: "Memory",
      },
      stepLabel: "Step {step} of {total} · {label}",
      storyQuestion: "Whose story are we preserving?",
      storyIntro:
        "Before the brand and the number, there is the way it came to you.",
      watchQuestion: "The guarded timepiece",
      watchIntro:
        "What it takes for this one, and only this one, to be recognised anywhere in the registry.",
      memoriesQuestion: "Memories and upkeep",
      memoriesIntro:
        "All of this is optional. Each piece added makes the provenance harder to dispute.",
      ownerConfirm: "Dossier opened in the name of",
      ownerEdit: "Not you?",
      brand: "Brand",
      brandPlaceholder: "E.g. Rolex",
      year: "Year",
      yearPlaceholder: "E.g. 2019",
      serial: "Serial number",
      serialPlaceholder: "E.g. 1234567",
      model: "Model",
      modelPlaceholder: "E.g. Submariner Date",
      reference: "Reference",
      referencePlaceholder: "E.g. 116610LN",
      serialTaken:
        "This serial number is already on the registry. If it is your watch, that dossier will be updated. Otherwise the registration will be refused: a watch belongs to one dossier only.",
      serialAwaitingClaim:
        "This serial number already has a dossier, waiting for its owner: it cannot be taken by registering it. If a workshop returned this watch to you, claim it with the code on your receipt; if you received a link by email, follow it; otherwise, write to us with a proof of purchase.",
      serialStolen:
        "Careful: this serial number is reported stolen on the registry. If you have just acquired this watch, contact us before going further.",
      noSerialToggle: "This watch has no visible serial number",
      noSerialModern:
        "A serial number is required for watches made in 1980 or later.",
      noSerialAnchor:
        "Without a serial, this dossier is anchored on its Provena ID and your photos: favour the caseback and movement on the next step.",
      noSerialLabel: "No serial number",
      scan: "Scan the number",
      scanning: "Reading the photo…",
      scanDetected: "Number(s) detected, tap to fill:",
      scanNone: "No number detected. Enter it manually.",
      scanError: "Reading failed. Enter the number manually.",
      photoSerialDetected: "Number read from this photo, tap to fill the serial:",
      photoMaybeNotAWatch:
        "This photo does not seem to show a watch. Check the file before continuing: it will appear in the public gallery.",
      serialValid: "{canonical} format valid.",
      serialExpected: "{canonical} format expected: {hint} (e.g. {example}).",
      ownerName: "Owner's name",
      ownerNamePlaceholder: "First and last name",
      email: "Email address",
      emailPlaceholder: "you@example.com",
      country: "Country",
      select: "Select…",
      countrySearch: "Type to search for a country…",
      countryNone: "No country matches.",
      acquisitionMethod: "Acquisition method",
      acquisitionOptional: "Optional · none of them fits? Move on to the next step.",
      purchaseProof: "Proof of purchase",
      purchaseProofHint: "Invoice or warranty card (PDF, JPG or PNG, max 8 MB)",
      serviceRecords: "Service records",
      serviceRecordsHint: "Services and interventions (PDF, JPG or PNG, max 8 MB)",
      boxPapers: "Box & papers",
      boxOrigin: "Original box",
      papersCert: "Papers / certificate",
      moreInfo: "What it has lived through",
      moreInfoPlaceholder:
        "The wrist that wore it, the day it arrived, a watchmaker's service you remember. Write what a future owner would want to know.",
      dialPhoto: "Dial photo",
      casebackPhoto: "Case back photo",
      movementPhoto: "Movement photo",
      photoUploading: "Uploading…",
      summary: "Summary",
      privacyNote:
        "Your information is kept in the Provena registry in accordance with our privacy policy.",
      requiredError: "Please complete the highlighted required fields to continue.",
      emailError: "Please enter a valid email address.",
      prev: "Previous",
      next: "Next",
      sealing: "Sealing…",
      submit: "Seal my watch",
      submitAnonymous: "Create my account and seal",
      photosLaterTitle: "Photographs and documents are added to the dossier",
      photosLaterText:
        "A dossier receives its files once it exists: photographs, invoice and service records are added right afterwards, from the dossier itself. Describe the watch first; we only ask for an account at the moment of sealing.",
      acquisition: {
        neuf_boutique: "New · boutique / authorised dealer",
        neuf_createur: "New · directly from the maker",
        occasion_particulier: "Pre-owned · private seller",
        occasion_plateforme: "Pre-owned · platform / dealer",
        heritage: "Inheritance / family transmission",
        autre: "Other",
      },
    },
    timeline: {
      title: "Watch history",
      chronology: "Timeline",
      loadingError:
        "The history is temporarily unavailable. Please try again later.",
      empty: "No event recorded for this watch yet.",
      emptyMeaning:
        "A record can exist before its history does. Events are added over time, by the owner and by the registered professionals who work on the piece.",
      retry: "Try again",
      attachments: "{n} attachment(s)",
      footnote:
        "The history is made of timestamped events that their author can no longer change once recorded, added by the owner and by registered professionals. The verification level indicates the origin of each declaration. Provena records this information but does not certify the authenticity of watches.",
      actors: {
        proprietaire: "Owner",
        createur: "Maker",
        horloger: "Watchmaker",
        marchand: "Dealer",
        expert: "Expert",
        assureur: "Insurer",
        admin: "Provena",
      },
      levels: {
        SELF_REPORTED: "Declared by the owner",
        DOCUMENTED: "Declared, with supporting document",
        ATELIER_REPORTED: "Reported by a workshop",
        CREATOR_DECLARED: "Declared by the maker",
        PROFESSIONAL: "Registered professional",
        VERIFIED: "Recorded by Provena",
        MANUFACTURER_VERIFIED: "Confirmed by the manufacture",
      },
    },
    cookie: {
      aria: "Cookie consent",
      textPre:
        "Provena uses cookies that are strictly necessary for the service to work, plus ",
      textStrong: "audience-measurement",
      textPost:
        " cookies (PostHog, hosted in the European Union) to understand how the site is used. Audience measurement is only enabled with your consent. No advertising, no resale of your data.",
      textShort:
        "Cookies needed to run the service, plus audience measurement (PostHog, European Union) enabled only if you accept. No advertising.",
      learnMore: "Learn more",
      accept: "Accept",
      decline: "Decline",
      close: "Close",
    },
    cookiePolicy: {
      metaDescription:
        "Provena Registry's cookie policy: strictly necessary cookies (session, payment) and consent-based PostHog audience measurement, hosted in the European Union. No advertising trackers.",
      eyebrow: "Legal",
      title: "Cookie Policy",
      lastUpdated: "Last updated: 2026",
      table: {
        title: "2. Cookies we use",
        headers: ["Cookie", "Category", "Purpose", "Duration"],
        rows: [
          {
            name: "__Host-session_token",
            type: "Strictly necessary",
            purpose:
              "Keeps your session securely signed in (httpOnly, Secure, SameSite cookie). Required to access your account.",
            duration: "30 days",
          },
          {
            name: "PostHog cookies",
            type: "Audience measurement (subject to consent)",
            purpose:
              "Placed only after your consent, to understand how the site is used (pages viewed, journeys, conversion rates). Hosted in the European Union.",
            duration: "Per PostHog configuration",
          },
          {
            name: "Payment cookies",
            type: "Strictly necessary (payment)",
            purpose:
              "The payment service is not active at this time. When it is, cookies may be placed by our provider only during a transaction, to secure it and prevent fraud.",
            duration: "Per the provider's policy",
          },
        ],
      },
      sections: [
        {
          title: "1. What is a cookie?",
          body: [
            "A cookie is a small text file placed on your device when you visit a website. It notably helps maintain your session or ensure that certain features work properly.",
          ],
        },
        {
          title: "3. Audience measurement",
          body: [
            "With your consent, Provena uses PostHog (hosted in the European Union) to measure the site's audience and understand how it is used. These cookies are only placed after your explicit acceptance via the consent banner, and you can decline them without affecting your use of the service. Provena uses no advertising cookies or marketing profiling trackers, and does not share your browsing data for advertising purposes.",
            "Without any cookie or identifier, Provena's server also counts facts it observes itself: watches registered, passports downloaded, thefts reported, and public pages of stolen watches displayed, with their origin by broad family (search engine, social network, direct link). Neither your IP address, nor the address of the page you came from, nor a serial number is sent. These figures describe no one; they therefore do not depend on the banner.",
          ],
        },
        {
          title: "4. Managing cookies and consent",
          body: [
            "Strictly necessary cookies do not require prior consent, as they are essential to the operation of the service. Audience-measurement cookies are only placed with your explicit consent, which you can withdraw at any time. You can also delete or block cookies via your browser settings. Blocking the session cookie will, however, prevent you from using features that require signing in.",
          ],
        },
        {
          title: "5. Changes",
          body: [
            "This cookie policy may be updated. Any substantial change will be indicated on this page.",
          ],
        },
      ],
      controlTitle: "Your choice",
      controlIntro:
        "You can change your decision at any time, in either direction. Withdrawal takes effect immediately: analytics stops and the corresponding cookies are no longer used.",
      controlState: {
        granted: "Analytics accepted",
        denied: "Analytics declined",
        none: "No choice recorded",
      },
      controlAccept: "Accept analytics",
      controlRevoke: "Withdraw my consent",
      controlNote:
        "Cookies strictly necessary for the site to work, such as your sign-in session, do not depend on this choice and stay active.",
      footerPre: "To learn more about how your data is processed, see our",
      footerLink: "privacy policy",
      footerPost: ".",
    },
    privacyPolicy: {
      metaDescription:
        "Provena Registry's GDPR-compliant privacy policy: data controller, processors, purposes, retention periods, and your rights (access, erasure, portability).",
      eyebrow: "Legal · GDPR",
      title: "Privacy Policy",
      lastUpdated: "Last updated: 2026",
      processors: {
        title: "4. Recipients and processors",
        intro:
          "We never sell your data. It is shared only with the providers (processors) strictly necessary to operate the service, under data processing agreements:",
        headers: ["Provider", "Role", "Purpose", "Location"],
        rows: [
          {
            name: "MongoDB Atlas",
            role: "Database hosting",
            purpose:
              "Secure storage of accounts, registered watches, documents and reports.",
            location: "European Union / Standard Contractual Clauses",
          },
          {
            name: "Cloudflare R2",
            role: "File storage",
            purpose:
              "Keeps the photos of your watches and the documents you add to their file (invoices, certificates, service records).",
            location: "United States and Cloudflare's global network / Standard Contractual Clauses",
          },
          {
            name: "PostHog",
            role: "Audience measurement",
            purpose:
              "Site audience measurement, placed only after your consent (pages viewed, journeys, conversion rates). Added to it, without any cookie or identifier, are counters kept by the server, which describe no one. No advertising, no resale of your data.",
            location: "European Union",
          },
          {
            name: "Stripe",
            role: "Payment processing",
            purpose:
              "The payment service is not active at this time. When enabled, Stripe will process payments and subscriptions; Provena never stores your card details.",
            location: "United States / Standard Contractual Clauses",
          },
          {
            name: "Google (OAuth)",
            role: "Authentication",
            purpose:
              "Secure sign-in via your Google account (name, email address, profile picture).",
            location: "United States / Standard Contractual Clauses",
          },
          {
            name: "Google Cloud Vision",
            role: "Serial-number reading",
            purpose:
              "Reads the number engraved on the caseback photo, when you use the scan, to pre-fill the form. The photo is neither kept nor logged.",
            location: "European Union",
          },
          {
            name: "Resend",
            role: "Transactional email delivery",
            purpose:
              "Sending registration, theft-report, document-generation and ownership-transfer confirmations.",
            location: "United States / Standard Contractual Clauses",
          },
        ],
      },
      rights: {
        title: "7. Your rights",
        intro:
          "Under the General Data Protection Regulation (GDPR), you have the following rights:",
        items: [
          {
            title: "Right of access",
            body: "Obtain confirmation that data concerning you is processed and receive a copy of it.",
          },
          {
            title: "Right to rectification",
            body: "Request correction of inaccurate or incomplete data.",
          },
          {
            title: "Right to erasure (deletion)",
            body: "Request deletion of your personal data, subject to legal retention obligations.",
          },
          {
            title: "Right to portability",
            body: "Receive your data in a structured, commonly used and machine-readable format, and transmit it to another controller.",
          },
          {
            title: "Right to object and to restriction",
            body: "Object to the processing of your data or request its restriction in the cases provided for by the GDPR.",
          },
        ],
        outroPre: "To exercise these rights, write to us at ",
        outroEmail: "contact@provenaregistry.com",
        outroPost:
          ". You also have the right to lodge a complaint with the competent supervisory authority (in France, the CNIL: www.cnil.fr).",
      },
      sections: [
        {
          title: "1. Data controller",
          body: [
            "The data controller is Nathan De Ridder, publisher of Provena Registry (\"Provena\", \"we\").",
            "For any question about your personal data or to exercise your rights, contact us at: contact@provenaregistry.com.",
          ],
        },
        {
          title: "2. Data we collect",
          body: [
            "Identity and contact data: name, email address and profile picture (via Google), declared owner name.",
            "Watch data: serial number, brand, model, year, acquisition method, proof of purchase, service records, photographs and theft-report information.",
            "Data received from a professional: when you buy a watch registered in the registry from a professional who uses Provena Studio, they send us, with your agreement, your name and email address, only to send you the link that lets you take the watch's file. If the watch had been left with them on consignment and was not yet in the registry, its file is opened at that moment, in your name, waiting for you to take it; the consignor's name is never sent to us. Never the price nor any other sale data.",
            "Payment data: the payment service is not active at this time. When it is, this data will be processed exclusively by Stripe and Provena will not retain any card details.",
            "Technical data: connection logs and the session cookie strictly necessary to operate the service. With your consent, audience-measurement data via PostHog (hosted in the European Union).",
          ],
        },
        {
          title: "3. Purposes and legal bases (art. 6 GDPR)",
          body: [
            "Providing the service (registration, consultation, reporting, transfer): performance of the contract.",
            "Managing payments and subscriptions, once the payment service is enabled: performance of the contract and legal obligations (accounting).",
            "Sending transactional emails related to your account: performance of the contract.",
            "Site audience measurement (PostHog): consent (art. 6(1)(a) GDPR).",
            "Anonymous counters kept by the server (service facts, public pages of stolen watches displayed): Provena's legitimate interest in knowing how the registry is used (art. 6(1)(f) GDPR). No personal data is kept or sent in them.",
            "Inviting you to take the file of a watch bought from a professional, using the name and email address they send us: your consent, collected by that professional (Art. 6(1)(a) GDPR). If you do not act on it, these data only serve to resend you the link at their request, at most once a day.",
            "Security, fraud prevention and improving the registry's reliability: legitimate interest.",
          ],
        },
        {
          title: "5. Transfers outside the European Union",
          body: [
            "Some of our processors are located outside the European Union (notably in the United States). These transfers are governed by appropriate safeguards, in particular the European Commission's Standard Contractual Clauses.",
          ],
        },
        {
          title: "6. Retention period",
          body: [
            "Your account data and information about your watches are retained for as long as your account is active and as long as necessary for the registry's purpose.",
            "Billing data is retained in accordance with applicable legal obligations. Upon a deletion request, your data is erased subject to those obligations.",
          ],
        },
        {
          title: "8. Cookies",
          body: [
            "Provena uses cookies that are strictly necessary to operate the service, as well as audience-measurement cookies (PostHog, hosted in the European Union) placed only with your consent. To learn more, see our cookie policy.",
          ],
        },
        {
          title: "9. Security",
          body: [
            "We implement reasonable technical and organisational measures (encrypted communications, access control, httpOnly session cookie) to preserve the confidentiality and integrity of your data.",
          ],
        },
        {
          title: "10. Changes",
          body: [
            "This policy may be updated. Any substantial change will be indicated on this page. The applicable version is the one published on the date you consult it.",
          ],
        },
      ],
      footerPre:
        "Provena is a documentation and traceability platform and does not authenticate or certify watches. This document is provided for information purposes. See also our",
      footerTermsLink: "terms of use",
      footerMid: "and our",
      footerCookiesLink: "cookie policy",
      footerPost: ".",
    },
    termsPage: {
      metaDescription:
        "General terms of use for the Provena Registry watch registry.",
      eyebrow: "Legal",
      title: "Terms of Use",
      lastUpdated: "Last updated: 2026",
      editor: {
        label: "Site publisher",
        pre: "Provena Registry is published by Nathan De Ridder. For any question about the service or your data: ",
        email: "contact@provenaregistry.com",
        post: ".",
      },
      sections: [
        {
          title: "1. Purpose",
          body: [
            "These terms of use govern access to and use of the Provena Registry (\"Provena\", \"the service\").",
            "By using the service, you accept these terms without reservation.",
          ],
        },
        {
          title: "2. Description of the service",
          body: [
            "Provena offers a digital registry to record the provenance and ownership history of a watch, check its status by serial number, and report a theft.",
            "Provena is a documentation and traceability platform. Provena does not authenticate, certify or guarantee the authenticity of watches. Information is based on owners' declarations. Provena cannot be held liable for inaccurate or fraudulent information.",
            "The service is a tool that supports transparency in the watch market and does not replace an authentication assessment or any steps with the authorities.",
          ],
        },
        {
          title: "3. Accuracy of information",
          body: [
            "You undertake to provide accurate, complete and up-to-date information when registering a watch or reporting a theft.",
            "Any fraudulent or abusive declaration may result in deletion of the data concerned and a ban from the service.",
          ],
        },
        {
          title: "4. Theft reporting",
          body: [
            "A theft report made through Provena does not constitute a police complaint. It is your responsibility to report the theft to the competent authorities.",
            "Provena cannot be held liable for actions taken on a report by third parties.",
          ],
        },
        {
          title: "5. Liability",
          body: [
            "The service is provided \"as is\". Provena uses reasonable means to ensure the registry's reliability but does not guarantee the completeness or absence of error of the information.",
            "Provena cannot be held liable for purchase or sale decisions made on the basis of the information consulted.",
          ],
        },
        {
          title: "6. Intellectual property",
          body: [
            "The Provena Registry trademark, its logo and all elements of the site are protected. Any unauthorised reproduction is prohibited.",
          ],
        },
        {
          title: "7. Changes to the terms",
          body: [
            "Provena reserves the right to modify these terms at any time. The applicable version is the one published on this page.",
          ],
        },
      ],
      disclaimer:
        "This document is provided for information purposes and does not constitute legal advice. We recommend consulting a legal professional for any specific question.",
    },
    plans: {
      tiers: {
        free: "Free",
        collector: "Collector",
        professional: "Professional",
        enterprise: "Houses & institutions",
      },
      features: {
        free: [
          "Account creation",
          "Unlimited watch registration",
          "Digital passport for every watch",
          "Publicly searchable status",
          "Theft reporting",
          "Basic collection management",
        ],
        collector: [
          "Everything in Free",
          "Premium provenance reports (5 included / month)",
          "Theft alerts",
          "Priority support",
        ],
        professional: [
          "Everything in Collector",
          "Unlimited provenance reports",
          "Bulk look-up tools",
          "Dealer profile and professional badge",
          "Customer onboarding",
          "Exportable reports",
          "Team access",
          "API (limited access)",
          "Priority support",
        ],
        enterprise: [
          "Custom pricing",
          "Insurers & auction houses",
          "Large dealers",
          "Unlimited API access",
          "White-label registry",
          "Dedicated account manager",
        ],
      },
    },
    editWatch: {
      title: "Edit watch",
      provenaIdKept: "Provena ID · {id} (kept)",
      submit: "Save changes",
      success:
        "{watch} has been updated. The change has been recorded in the history.",
      genericError: "Something went wrong.",
      attachFile: "Attached file",
    },
    documents: {
      title: "Supporting documents",
      item: "Document",
      photosTitle: "Photographs",
      photoItem: "Photograph",
    },
  },
};

export default translations;
